function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestToJoinCoalition({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1280,
    height: 720,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M0 0L0 720L263 720L349 720L391 719.853L403.09 712.115L428.245 696.062L443.004 682.147L481 682.625L563 674L562 672L576 672L576 668C583.949 668 603.377 664.443 608 672L632 677L632 680L648 684L647 689L656 692L656 672C648.38 672 640.287 673.566 640 664L643 664L643 648L640 648C640.151 635.158 647.488 643.916 655 645L655 640L654 640L655 642L654 642L640 633L640 636L632 630L632 624L636 624L632 605L642 598C641.455 594.732 641.297 593.324 644 594L643 591L648 590L654 584L655 583L658 581L655 577L655 576L659 580L660 580L661 578L660 568C659.748 562.708 655.561 562.401 651 561.845C639.382 560.429 628.908 557.208 618 553L620 544C612.654 543.42 600.697 544.143 600 535L593 533L593 532C600.592 530.379 613.153 528.4 616 520C625.931 518.297 629.199 499.566 633.668 492C635.698 488.563 639.319 485.146 639.713 481.005C640.151 476.403 636.083 474.207 632 474.188C615.867 474.11 626.849 488.617 623.682 496.83C621.833 501.625 616.922 502.036 614.174 505.583C611.488 509.052 612.359 512.579 607 513C608.489 521.557 604.82 520.896 598 520L600 517L598 514L600 511L608 505L607 501C610.794 499.67 611.218 496.714 612 493L607 491L607 495C599.892 491.446 604.415 502.104 600 501L601 504L599 504L600 507L598 506L598 510C594.196 511.78 591.719 513.801 591 518L581 525L560 523L559 518L555 520L553 519L554 516L550 510L549 510L548 514L547 514L546 510L548 507L544 505L543 505L541 507L544 504L545 495L544 495L543 497L541 495L543 492L535 491L535 490L544 488L543 484L547 484L546 478L549 479L548 476L555 474L557 469L556 471L559 471L559 469L560 469L561 470L559 467L562 465L565 467L562 463L566 456L562 456L560 445C567.82 441.581 565.616 435.566 569.8 429.76C573.54 424.57 579.701 421.338 583.906 416.439C589.481 409.943 592.966 400.195 595 392L600 392L606 386L607 386L608 386C610.12 388.468 613.629 388.357 615.867 390.943C621.57 397.534 619.001 408.125 619 416L623 420C629.189 415.754 630.975 407.477 621 408L621 400L624 402C629.854 401.024 633.723 389.585 630 384C627.996 380.994 625.246 382.018 626 379L619.667 367L625 359L618 360L618 359L620 359L620 358L616 359L611 356L611 355L613 354C606.469 344.739 622.784 344.157 628 350L629 350C625.72 339.42 624.543 318.14 640 317L648 312L650 304L648 300C653.97 298.923 658.695 296.177 660 290L656 287L659 286L666 273L665 270C669.531 270.461 671.632 273.631 672 278L674 277L673 280L681 281L681 270C686.889 270.501 691.555 275.903 694 281L695 281L695 270L700 270L703 293L704 293L703 291L704 291L708 292C708.987 296.627 714.897 296.855 719 297L719 301L720 301L721 299L725 301L725 302L722 302L722 303C731.717 305.949 725.399 317.346 725 324L721 325C722.702 330.301 723.962 335.045 730 336L732 343L734 343L735 338L749 336L752 342L756 345L760 344L759 347L764 351L765 351L765 346L768 346L768 345L765 345C764.861 340.828 764.253 338.928 760 338L761 335L758 336L757 325L758 310L754 306C751.09 306 749.328 294.191 750 291L742 290L751 269L755 270L756 276L759 275L759 271L761 269L764 270L762 266C765.786 264.639 767.188 262.932 768 259C759.849 259.133 755.956 248.509 760 242L757 239L757 242C746.174 239.542 749 251.572 749 259L745 259C743.578 254.441 740.72 246.131 744 242L744 241L736 241L737 236L756 236C760.182 240.215 778.016 230.802 771 244L770 244C767.973 241.699 766.617 242.74 765 245L773 246L766 250L766 252L777 252L779 236C787.812 235.886 787.53 228.74 788.014 221C788.784 208.676 787.637 195.086 790.393 183C791.977 176.056 798.434 175.357 800 170L814 168.047L832 172L832 175L848.867 176.333L857 184L859 192L860.985 226L860.108 330.985L864 367L864 368L864 384L872 384L872 400L875 400L875 392L880 392L880 387L898 384L912 368C920.716 366.997 935.728 344.398 936 336L944 336L944 328L947 328C947 324.489 947.987 320.854 944 320C952.035 312.354 957.632 300.627 968 296C970.225 288.704 990.402 273.956 998 272C990.146 314.307 983.597 355.521 967.55 396C961.078 412.327 953.677 428.252 945.917 444C942.129 451.686 935.358 460.571 933.696 469C932.721 473.947 937.736 477.752 939.521 482C942.128 488.204 941.51 493.541 941 500C931.757 500 914.751 496.233 911 507C919.217 510.954 926.244 507.224 934 504L939 515C932.197 518.176 926.772 521.904 919 521.996C914.686 522.047 905.807 518.628 902.379 520.847C895.302 525.428 889.445 538.324 884.21 545C875.55 556.044 858.369 570.018 853.603 583C851.52 588.675 853 597.008 853 603L853 647L839.603 645.397L838 633L838 600C816.944 609.819 832.335 627.96 825.397 643.852C823.017 649.303 814.142 647.209 811 644C806.637 645.247 802.599 647.582 798 647.903C794.115 648.174 789.688 646.068 786 647.502C777.843 650.673 770.053 659.642 763 664.846C747.215 676.492 730.746 687.424 714 697.655C704.081 703.715 683.269 710.429 677 720L776 720C789.813 720 808.758 723.394 822 719.487C831.161 716.784 838.767 707.577 845.921 701.735C866.338 685.059 891.342 666.272 907 645C903.631 645 900.112 639.068 898.833 636C894.619 625.885 903.008 607 889 607L889 594L897 594L898 580L912 581L912 594L927 594L927 607L912 607L913 631L915 631L915 632L914 633C921.436 630.021 933.035 617.585 935.971 609.911C937.624 605.593 935.466 599.071 938.742 595.519C941.351 592.691 946.601 593.529 949.957 592.005C954.368 590.002 956.436 585.296 958 581L959 581L959 584L960 584C963.535 567.752 979.202 549.683 988.562 536C991.773 531.305 995.328 522.855 1000 520L1003 508C998.942 508 1001.13 485.148 1002 481L994 481L994 468C1004.95 467.395 998.182 456.79 1006.06 454.434C1009.54 453.391 1014.95 453.674 1016.97 457.148C1018.89 460.459 1017.85 471.998 1025.3 464.347C1033.48 455.942 1036.33 438.616 1040.8 428C1056.18 391.409 1062.28 352.901 1072.44 314.985C1076.49 299.872 1085.37 276.175 1080 261C1085.52 260.099 1084.66 241.681 1085.26 237C1087.07 222.747 1089.58 207.486 1088.68 193C1088.13 184.122 1085.49 167.642 1090 160C1086.11 153.262 1089.27 145.456 1087.8 138.134C1085.07 124.551 1080.13 111.246 1080 97C1079.96 92.8598 1079.24 76.6132 1075 76L1071 48L1066 48L1064 26L1049.83 31.4367L1035 32L1035 42L1032 46L1056 44L1056 39L1064 39L1064 40L1060 40L1060 56L1064 56L1066 104L1072 104L1072 112L1068 112L1068 120L1072 120C1072 134.499 1076.83 153.131 1061 160L1062 136L1056 136L1056 120L1064 120L1064 119C1051.06 118.847 1048 106.825 1048 96L1045 96L1044 80L1040 80L1038 64C1033.77 52.8726 1028 44.5079 1028 32L1024 32L1024 24C1017.23 19.9024 1015.73 6.99481 1013 0L962 0L962 8L968 8L970 17L973 16C977.114 43.4658 989.934 69.5187 994.586 97C1002.74 145.163 1001.13 191.628 1001 240L1000 240L1000 236C997.05 236.983 996.378 237.487 997 235L993 234L991 235L987 239L986 239L977 229C983.315 221.768 982 206.203 982 197C982 173.815 983.207 151.567 982 128L978 128L978 112L976 112L976 152L972 152L972 144L968 144C968 138.315 967.52 134.036 972 130C967.827 107.927 972.052 84.3814 972 62C971.989 57.2816 969.534 40.9717 965 40L968 24L971 24L971 18L969 18L966 24L968 16L956 16L956 0L869 0L870 10L864 13L864 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M864 0L864 13L870 10L869 0L864 0M956 0L956 16L968 16L966 24L969 18L971 18L971 24L968 24L965 40C970.401 43.5004 971.988 58.8037 972 65C972.029 79.602 971.821 93.561 971.821 108C971.821 115.514 970.213 122.495 972 130C966.876 133.143 968 138.589 968 144L972 144L972 152L976 152L976 112L978 112L978 128L982 128C982.507 149.644 982.042 170.795 982 192C981.977 203.457 983.21 219.003 977 229L986 239L987 239L993 234L997 235C996.969 237.294 997.832 236.716 1000 236L1000 240L1001 240C1001.28 205.866 1004.77 171.255 1000.71 137C995.758 95.169 982.65 56.7423 973 16L970 17L968 8L962 8L962 0L956 0M1013 0C1014.27 5.86969 1017.75 22.1783 1024 24L1024 32L1028 32C1028 44.176 1032.19 53.5879 1038 64L1040 80L1044 80L1045 96L1048 96C1048 107.435 1050.4 118.952 1064 119L1064 120L1056 120L1056 136L1062 136L1061 160C1077.4 155.588 1072 133.187 1072 120L1068 120L1068 112L1072 112L1072 104L1066 104L1064 56L1060 56L1060 40L1064 40L1064 39L1056 39L1056 44C1047.75 43.9317 1039.56 41.663 1032 46L1035 42L1033 40L1035 32L1050.71 31.4367L1064 26L1066 48L1071 48L1075 76C1078.11 75.9999 1080 92.3077 1080 96C1080 105.625 1081.06 118.381 1083.33 128C1084.25 131.883 1087.47 135.328 1088 139C1088.84 144.77 1085.31 156.18 1090 160C1085.17 163.865 1090.36 169.548 1089 175C1087.42 181.326 1089.98 189.139 1089 195C1086.6 209.43 1087.27 222.35 1085 236C1084.05 241.712 1084.45 262.112 1080 261C1084.32 280.163 1075 302.645 1070.46 321.285C1062.32 354.609 1054.91 387.175 1044.01 420C1039.88 432.459 1034.12 445.126 1028.58 457.039C1026.56 461.387 1023.82 468.563 1018 465L1017 465C1018.26 470.861 1025.85 466.206 1029.89 468.722C1033.32 470.86 1032 477.554 1032 481L1017 481C1017 496.214 1013.77 509.464 1033 508C1033 511.485 1034.14 517.575 1031.4 520.258C1022.78 528.691 1006.19 517.232 1003 509L1002 509L1000 520L988.583 535.056L966.907 570L960 584L959 584L959 581L958 581C954.614 587.426 951.714 592.205 944 593L944 594L953 594L953 647L938 647L938 596L937 596C937 609.87 928.102 625.616 915 632L915 633L929 634C929 637.208 929.797 641.872 927.972 644.697C923.017 652.365 907.623 644.901 900.039 651.201C873.62 673.15 851.268 698.9 823 719L823 720L1280 720L1280 0L1013 0M1056 29C1056.85 32.9871 1060.49 32 1064 32L1056 29M1065 48L1065 56L1066 56L1065 48M1076 79L1077 80L1076 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M1048 87L1048 88L1056 88L1048 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M424 143L427 145L427 144L424 143M424 149L428 150L427 147L424 149M376 150L376 151L382 148L376 150M412.667 155.333L413.333 155.667L412.667 155.333M398.667 158.333L399.333 158.667L398.667 158.333M411 159L411 162L416 159L411 159M968 160L968 200L971 200L972 168L976 168L976 160L968 160M398.667 161.333L399.333 161.667L398.667 161.333M379 166L383 165L379 166M362 170L364 176L368 175L368 168L362 170M800 170C796.883 175.115 791.985 175.138 790.456 182.001C787.529 195.139 789.648 208.744 787.871 222C786.94 228.945 786.974 235.562 779 236L779 237C783.979 237 792.418 235.841 794.339 242.044C796.212 248.095 792.575 250.711 797 257L785 251C784.699 254.952 783.882 256.822 780 258L780 239L779 239L777 252L773 252L773 253C776.417 259.052 765.515 258 762 258L762 259L768 259L762 266L764 270L761 269L759 271L759 275L757 274L761 290L748 288L752 307L753 307C755.169 299.859 764.938 303 771 303L771 307L765 307L765 323C756.496 321.644 759.729 313.32 760 307L753 307L753 308C761.07 311.717 757.94 328.233 758 336L761 335L760 338C763.768 339.384 764.695 341.044 765 345C769.242 344.55 772.789 344.326 774 349L769 348C775.58 354.039 774.509 358.732 765 357L767 353L768 353L772 355L766 346L765 346L765 351L764 351L759 347L760 344C756.524 347.364 761.859 354.634 764 358L751 358L757 343L748.661 336.603L735 338L734 343L732 343L730 336C724.392 334.387 723.213 329.94 721 325L725 324L727 304L726 304C726 308.378 726.892 313.973 724.821 317.985C721.259 324.884 712.771 324.889 709.179 317.981C706.829 313.462 707.874 306.731 709 302L712 302C712.53 304.228 713.791 325.746 719.972 316.677C723.406 311.64 718.552 305.556 725 302L725 301L720 301L719 301L719 297C714.653 296.501 710.404 295.912 708 292L703 291L704 293L703 293L701 285L700 285L700 291L687 280L686 291L683 291L682 276L681 276L681 281L674 279L675.658 288.539L659 291C658.401 296.372 652.716 298.612 648 300L650 304L648 312C644.517 312.542 640.787 313.309 640 317C624.548 316.98 624.907 339.845 629 350L628 350L621 344L621 345C628.087 350.4 625.269 355.791 618 359L618 360L625 359C623.47 361.07 620.226 363.584 619.583 366.083C618.73 369.402 622.871 379.02 626 379C626.982 387.823 635.303 395.088 624 402L621 400L621 408C630.899 408.079 628.015 415.322 623 420L619 416C619.005 408.128 622.037 396.713 615.867 390.264C613.734 388.035 610.402 387.852 608 386L607 386L606 386L600 392L595 392L585.272 414L569.8 429.04L560 445L562 456L566 456L562 463L565 467L562 465L559 468C564.873 469.224 570.844 466.392 577 467.301C595.372 470.013 601 485.903 601 502L602 502C602.685 498.176 602.85 495.701 607 495L607 491L612 493L607 501L608 505L600 511L598 514L600 517L598 520C605.037 521.568 609.069 521.813 607 513C612.47 512.992 611.605 510.05 614.174 506.309C616.916 502.319 622.366 502.173 624.107 496.83C626.702 488.863 616.542 475.774 631 474.424C634.858 474.063 639.94 476.466 639.419 481.005C638.968 484.933 634.998 488.646 633.096 492C628.554 500.005 625.798 516.943 616 520C611.326 528.309 601.225 529.264 593 532L593 533L600 535C600.309 544.405 612.408 543.674 620 544L618 553C627.579 558.047 638.366 560.328 649 561.718C653.631 562.324 659.223 562.417 660 568L661 578L659 578L659 579C670.084 575.976 679.783 573.098 691 577.88C704.428 583.604 711.764 593.509 696 601C691.41 589.399 678.573 589.037 668 591L668 592L672 593L672 594L669 593L670 596L666 595L667 592C663.158 594.269 660.409 596.958 658.378 601.001C653.529 610.651 655.855 623.906 665.015 630.146C674.892 636.874 691.812 634.044 696 622C699.138 623.561 705.578 626.453 706.539 630.184C708.306 637.051 693.953 644.133 689 645.91C676.167 650.513 667.065 645.474 655 642C650.341 648.818 640.057 631.82 640 648L643 648L643 664L640 664C640.119 673.949 648.075 672 656 672L656 692L647 689L648 684L632 680L632 677L608 672C605.811 664.517 582.689 668 576 668L576 672L562 672L563 674C543.734 674 525.254 679.583 506 680.911C492.616 681.833 479.421 682.314 466 681.985C459.536 681.827 452.436 679.663 446 680.803C436.308 682.521 432.711 691.871 425.714 697.624C415.732 705.831 401.956 709.482 394 720L589 720L648 720L675.714 719.502L709 701.166L787 647L787 646C777.392 638.612 774.21 625.478 787.004 619C794.084 615.415 803.29 616 811 616C808.312 603.196 795.367 603.462 788 613L787 613C785.555 610.494 781.961 606.999 782.041 604.004C782.196 598.237 792.39 594.339 797 593.468C810.359 590.943 821.82 597.62 825 611C841.414 599.437 838 585.112 838 567L853 567L853 582C874.242 566.912 888.034 539.131 904 519C884.428 505.595 883.876 475.004 910 467.927C918.497 465.626 925.315 468.805 933 472C940.382 446.374 957.633 422.018 967.55 397C983.491 356.788 992.606 314.681 998 272C990.478 273.091 969.229 288.67 968 296C958.567 298.576 949.575 312.484 944 320L947 328L944 328L944 336L936 336C935.571 341.727 932.111 343.31 929.278 347.76C925.297 354.012 920.043 366.324 912 368L898 384L880 387L880 392L875 392L875 400L872 400L872 384L864 384C864.054 379.151 868.086 371.57 864 368L864 367C868.444 362.016 862.923 354.015 861.585 348.91C860.437 344.532 859.926 334.574 860.304 329.996C861.234 318.733 858.689 308.116 859.043 297C859.944 268.766 861.181 240.26 860.999 212C860.955 205.17 858.636 198.932 859 192L857 184C853.639 182.088 852.829 178.463 849.725 176.329C843.99 172.387 838.334 174.943 832 175L832 172L816 168.104L800 170M380 169L380 170L383 170L380 169M411 171L408 176L412 177L413 171L411 171M380 174L381 175L380 174M456 175L459 178L456 175M390 178L393 178L392 176L390 178M1070 176L1070 184L1072 184L1072 176L1070 176M378 177C375.974 182.563 371.548 183.745 366 183L362 190L359 188L354 197L354 202L352 200L344 215C344.413 221.406 344.182 226.232 352 223L355 232L352 233L352 235L356 236L354 239L357 241L352 240L352 241L364 243L364 244L361 245L361 246C366.824 246.961 372.89 246.61 376 241L382 243L392 232L392 231L389 228L393 230L396 225L391 225L391 224L397 224L397 222L393 222L393 219L400 219L405 212L403 220L408 211L400 212L403 202L399 202L400 192L381 184L381 177L378 177M408 177L409 178L408 177M390 180L392 182L392 180L390 180M423 181L424 182L423 181M356 182L358 186L358 182L356 182M472.333 184.667L472.667 185.333L472.333 184.667M389 185L390 186L389 185M412 188L410 194L414 188L412 188M471 188L470 195L471 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M390 195L394 198L390 195M391 199L393 201L391 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M418 203L424 201C421.12 199.902 419.65 200.445 418 203M467 200L468 208L472 208C471.861 203.735 471.292 201.303 467 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M392 202L392 204L394 204L394 202L392 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M533 202L534 203L533 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M535.667 202.333L536.333 202.667L535.667 202.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M534 203L533 205L534 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M544 289L548 272L550 272L554 285L555 285L569 273C569.475 278.381 567.382 284.814 563.772 288.91C561.659 291.309 555.634 294.661 556.752 298.582C557.798 302.253 568.818 305.182 571.907 307.819C576.555 311.788 577.615 319.891 582.394 322.972C588.32 326.793 603.06 324 610 324C612.628 324 617.06 324.782 619.254 322.972C621.705 320.95 620.355 316.614 619.919 314C618.748 306.978 616.475 299.034 618.854 292C622.697 280.64 639.308 280.52 640.767 268.005C641.489 261.812 635.041 261.284 631.514 257.671C621.428 247.337 612.002 244.611 612 229C594.845 236.646 582.679 254.792 580 273C560.058 264.229 558.803 239.363 550.244 222C547.689 216.816 543.601 206.63 537.842 204.327C531.306 201.714 529.114 219.651 523.895 222.147C520.057 223.982 515.647 224.158 512.089 226.702C508.425 229.323 506.286 233.463 501.999 235.297C496.831 237.508 490.141 235.698 485.318 238.514C478.714 242.369 486.602 254.63 490.043 257.892C497.368 264.834 507.577 261.26 512.737 271.001C519.274 283.342 521.213 297.457 523.803 311C524.304 313.617 524.214 323.364 528.043 323.364C531.336 323.364 538.501 312.155 538.079 309.213C537.653 306.233 533.489 305.372 532.238 302.787C529.331 296.78 539.401 290.377 544 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M537 203L538 204L537 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M423 204L423 208L424 208L423 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M532 205L533 206L532 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M532 206L533 207L532 206M540 206L541 207L540 206M541 207L542 208L541 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M542 207L544 209L542 207M965 208L966 224L971 224C971 217.873 973.616 207.339 965 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M394 208L395 209L394 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M531 208L532 209L531 208M542 208L543 209L542 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M531 209L532 210L531 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M543 209L544 210L543 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M395 210L394 214L395 214L395 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M504 211L511 224L511 225L504 234L520 223L520 222L508 210L504 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M530 210L531 211L530 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M543 210L544 211L543 210M530 211L531 212L530 211M544 211L545 212L544 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M423 212L424 213L423 212M432 212L432 213L436 213L432 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M545 212L546 213L545 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M439 213L440 214L439 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M529 213L530 214L529 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M545 213L546 214L545 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M418 214C420.741 216.602 422.501 216.169 426 215L426 214L418 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M529 214L530 215L529 214M546 214L547 215L546 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M394 215L394 218L396 215L394 215M398.667 216.333L399.333 216.667L398.667 216.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M440 216L444 218L444 217L440 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M528 216L529 217L528 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M547 216L548 217L547 216M528 217L529 218L528 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M548 217L549 218L548 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M548 218L549 219L548 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M407.333 219.667L407.667 220.333L407.333 219.667M440.333 219.667L440.667 220.333L440.333 219.667M445 219L444 221L445 219M526 219L527 220L526 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M527 219L528 220L527 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M549 219L550 220L549 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M346.667 220.333L347.333 220.667L346.667 220.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M395 220L396 221L395 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M549 220L550 221L549 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M521.667 221.333L522.333 221.667L521.667 221.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M525 221L526 222L525 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M526 221L527 222L526 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M550 221L551 222L550 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M403 224L408 224C406.231 221.966 404.769 221.966 403 224M442 222L443 223L442 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M521 222L522 223L521 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M522.667 222.333L523.333 222.667L522.667 222.333M550 222L551 223L550 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M399 223L400 224L399 223M427 223L428 228L420 230L420 231C426.372 230.731 430.27 230.065 435 235L437 231L435 229L428 229L429 223L427 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M517 223L518 224L517 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M518 223L519 224L518 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M519 223L520 224L519 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M551 223L552 224L551 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M453 227L453 228L456 228L453 231L453 232L456 233L459 248L464 244L464 243L464 242L463 237L457 236L457 231L463 229L462 227L464 225L453 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M514 224L515 225L514 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M515 224L516 225L515 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M516 224L517 225L516 224M551 224L552 225L551 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M512 225L513 226L512 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M513 225L514 226L513 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M511 226L512 227L511 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M552 226L553 227L552 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M422 227L423 228L422 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M510 227L511 228L510 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M509 228L510 229L509 228M553 228L554 229L553 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M609 228L608 230L609 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M611 228L612 229L611 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M255 236C258.675 234.83 260.958 234.455 264 237C266.123 236.792 268.191 236.739 270.321 236.701C273.036 236.654 280.484 233.257 275.627 230.071C271.712 227.503 256.379 231.846 255 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M388 229L384 232L384 233L388 229M508 229L509 230L508 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M553 229L554 230L553 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M609 229L610 230L609 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M612 229L612 240L613 240L612 229M508 230L509 231L508 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M554 230L555 231L554 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M606 230L605 232L606 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M608 230L609 231L608 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M613.333 230.667L613.667 231.333L613.333 230.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M455 231L456 232L455 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M507 231L508 232L507 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M554 231L555 232L554 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M606 231L607 232L606 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M607 231L608 232L607 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M419 233L419 234L423 233L422 237L423 237L425 232L419 233M458 232L458 233L461 233L458 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M506 232L507 233L506 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M606 232L607 233L606 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M505 233L506 234L505 233M555 233L556 234L555 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M603 233L601 236L603 233M742 233L743 234L742 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M503 234L504 235L503 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M504 234L505 235L504 234M555 234L556 235L555 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M603 234L604 235L603 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M440 235L441 236L440 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M500 235L501 236L500 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M501.667 235.333L502.333 235.667L501.667 235.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M602 235L603 236L602 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M740 236L740 237L754 237L740 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M491 236L491 237L494 237L491 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M494 236L494 237L498 237L494 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M556 236L557 237L556 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M599 236L600 237L599 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M601 236L602 237L601 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M663 236L664 237L663 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M667.667 236.333L668.333 236.667L667.667 236.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M670.667 236.333L671.333 236.667L670.667 236.333M695.667 236.333L696.333 236.667L695.667 236.333M707 236L707 237L716 237L707 236M719 236L720 237L719 236M727.667 236.333L728.333 236.667L727.667 236.333M730 236L731 237L730 236M737.667 236.333L738.333 236.667L737.667 236.333M755 236L756 237L755 236M756 240L760 241L760 237L772 237C767.004 234.903 759.311 235.346 756 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M485 237L485 238L489 238L485 237M556 237L557 238L556 237M600 237L601 238L600 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M664 237L665 238L664 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M665 237L666 238L665 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M671 253L661 252C662.755 257.557 673.888 259.515 673.994 251.985C674.065 246.917 667.149 245.009 665 241L674 241C670.525 237.065 660.903 235.902 662.377 243.899C663.076 247.695 668.691 250.057 671 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M670 237L671 238L670 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M671 237L672 238L671 237M681 237L682 238L681 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M681 257L682 257L682 238L685 238L685 245C685.782 243.115 685.315 234.722 682.008 238.662C679.069 242.164 681 252.6 681 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M685 237L686 238L685 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M694 237L694 245L695 245L695 238L698 238L698 257C700.298 251.524 701.201 238.202 694 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M698 237L699 238L698 237M705 237L706 238L705 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M705 257L706 257L706 238L719 238C703.414 231.46 705 246.552 705 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M725 237C725 250.521 722.419 258 738 258L738 257L726 257L725 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M726 237L726 238L729 238L730.028 252.397L738 257L739 257C737.544 252.613 734.15 253.015 730 253L730 237L726 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M738 237L739 238L738 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M738 241L739 241L739 238L755 238C750.205 235.988 739.907 235.255 738 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M755 237L755 241L756 241L755 237M760 237L761 238L760 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M760 257L761 257L761 238L774 238C758.414 231.46 760 246.552 760 257M780 239L790 238C786.756 236.639 782.437 236.211 780 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M790 237L791 238L790 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M413.667 238.333L414.333 238.667L413.667 238.333M416 238L416 239L421 239L416 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M483 238L484 239L483 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M599 238L600 239L599 238M663 238L664 239L663 238M672 238L673 239L672 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M682 238L682 257L685 257C685.128 246.19 694.872 246.19 695 257L698 257L698 238L695 238L695 245L685 245L685 238L682 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M704 238L704 241L705 241L704 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M706 238L706 257L719 257L719 254C714.021 253.982 710.978 253.96 709 249L716 248L716 245L709 242L719 241L719 238L706 238M726 238L726 257L738 257L738 254C727.478 253.876 729 246.472 729 238L726 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M736 238L736 241L738 238L736 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M739 238L739 241L745 241L745 257C751.023 255.001 749 246.262 749 241L755 241L755 238L739 238M761 238L761 257L774 257L774 254C767.233 253.976 761.094 248.756 771 248L771 245L764 245L764 241C767.987 240.997 771.668 241.598 774 238L761 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M778 238L779 239L778 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M780 239L781 257L784 257L784 250L796 257C791.898 246.958 796.639 234.082 780 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M792 238L793 239L792 238M557 239L558 240L557 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M596 239L597 240L596 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M598 239L599 240L598 239M662 239L663 240L662 239M673 239L674 240L673 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M680 239L680 243L681 243L680 239M686 239L687 240L686 239M724 239L725 240L724 239M774 239L775 240L774 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M793 239L794 240L793 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M984 239L985 240L984 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M359 240L360 241L359 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M482 240L482 245L483 245L482 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M557 240L558 241L557 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M558 240L559 241L558 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M597 240L598 241L597 240M661 240L661 245L662 245L661 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M674 240L675 241L674 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M693 240L694 241L693 240M730 240L730 248L731 248L730 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M773 240L774 241L773 240M780 240L780 257L781 257L780 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M794 240L795 241L794 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M437 241L438 242L437 241M594 241L595 242L594 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M665 241L666 242L665 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M669 241L670 242L669 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M673 241L674 242L673 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M699 241L699 247L700 247L699 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M710 241L710 242L719 242L710 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M737 241L738 242L737 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M744 241L745 242L744 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M749 241L750 242L749 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M755.667 241.333L756.333 241.667L755.667 241.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M764 241L764 245L765 245L764 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M765 241L765 242L773 242L765 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M774 241L775 242L774 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M784 241L784 247L791 246L791 245L785 246L784 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M785 241L785 246L790 246C789.423 242.526 788.474 241.577 785 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M789 241L790 242L789 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M794 241L795 242L794 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M471 242L470 247L479 248L479 247L471 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M558 242L559 243L558 242M594 242L595 243L594 242M613 242L614 243L613 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M614 242L615 243L614 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M665 242L666 243L665 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M666 242L668 244L666 242M669 242L670 243L669 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M671.667 242.333L672.333 242.667L671.667 242.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M686.333 242.667L686.667 243.333L686.333 242.667M704 242L705 243L704 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M709 242L710 243L709 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M710 242L711 243L710 242M713 242L714 243L713 242M739 242L740 245L741 245L741 242L739 242M742 242L743 256L744 256L742 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M744 242L744 257L745 257L744 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M750 244L755 243L750 244M758 242L759 245L760 245L760 242L758 242M765.333 242.667L765.667 243.333L765.333 242.667M770.333 242.667L770.667 243.333L770.333 242.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M790 242L791 243L790 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M285 243L286 244L285 243M349 243L350 244L349 243M414 244L416 245L416 246L410 247L410 248L421 245L421 244L416 243L414 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M558 243L559 244L558 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M592 243L591 245L592 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M593 243L594 244L593 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M613 243L614 244L613 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M660 243L661 244L660 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M665 243L667 245L665 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M666 243L667 244L666 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M767.667 243.333L768.333 243.667L767.667 243.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M790.333 243.667L790.667 244.333L790.333 243.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M446.667 244.333L447.333 244.667L446.667 244.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M592 244L593 245L592 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M614 244L615 245L614 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M667 244L668 245L667 244M693 244L694 245L693 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M704 244L705 245L704 244M737 244L738 245L737 244M257.001 245.654C247.264 248.671 247.397 260.922 258.985 257.196C268.185 254.238 267.93 242.267 257.001 245.654M288 245L288 246L294 250L288 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M559 245L560 246L559 245M591 245L592 246L591 245M616 245L617 246L616 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M618 245L619 246L618 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M669 245L670 246L669 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M716 245L709 249L709 250C712.102 249.222 716.912 249.061 716 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M771 245L772 246L771 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M483.333 246.667L483.667 247.333L483.333 246.667M559 246L560 247L559 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M589 246L590 247L589 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M590 246L591 247L590 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M618 246L619 247L618 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M619 246L620 247L619 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M621 246L622 247L621 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M662 246L663 247L662 246M671 246L672 247L671 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M704 246L704 249L705 249L704 246M717.333 246.667L717.667 247.333L717.333 246.667M739 246L740 247L739 246M759 246L759 256L760 256L759 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M771 246C764.868 250.772 762.459 253.963 773 254L773 253L765 253L765 249C767.575 248.958 771.542 249.286 771 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M772.333 246.667L772.667 247.333L772.333 246.667M775 246L776 247L775 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M794 246L795 247L794 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M446 247L446 248L448 249L446 251L451 256C452.442 250.03 453.557 247.246 446 247M482 247L483 248L482 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M620 247L621 248L620 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M621 247L622 248L621 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M623 247L625 249L623 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M664 247L665 248L664 247M672 247L673 248L672 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M754 247L755 248L754 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M560 248L561 249L560 248M623 248L624 249L623 248M665 248L666 249L665 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M666 248L667 249L666 248M673 248L674 249L673 248M685 257L686 257L686 249L694 249L694 257C698.052 247.319 685.044 244.595 685 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M716 248L717 249L716 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M738 248L739 249L738 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M771 248L772 249L771 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M792 248L793 249L792 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M322 249L322 251L324 251L324 249L322 249M380 249L381 250L380 249M424 249L429 259C428.899 253.624 430.979 249.544 424 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M560 249L561 250L560 249M588 249L589 250L588 249M624 249L625 250L624 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M626 249L627 250L626 249M666 249L667 250L666 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M667 249L668 250L667 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M668 249L669 250L668 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M674 249L675 250L674 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M686 251L690 250L686 251M692 249L694 251L694 249L692 249M710 249L711 250L710 249M712 249L712 250L715 250L712 249M765 249L765 253L772 253L772 252L766 252L766 250L772 250L765 249M295.333 250.667L295.667 251.333L295.333 250.667M416 250L417 251L416 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M484 250L485 251L484 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M587 250L588 251L587 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M625 250L626 251L625 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M661 250L662 251L661 250M663 250L664 251L663 250M668 250L670 252L668 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M669 250L670 251L669 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M674 250L675 251L674 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M680 250L681 251L680 250M699 250L699 255L700 255L699 250M704 250L704 255L705 255L704 250M730 250C730.796 253.716 733.637 253 737 253L737 252L730 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M784 250L784 256L785 256L784 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M785.667 250.333L786.333 250.667L785.667 250.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M787 250L788 251L787 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M792 250L793 251L792 250M561 251L562 252L561 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M626 251L627 252L626 251M662.667 251.333L663.333 251.667L662.667 251.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M670 251L671 252L670 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M709 251L710 252L709 251M788 251L789 252L788 251M485 252L486 253L485 252M561 252L562 253L561 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M562 252L563 253L562 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M586 252L587 253L586 252M627 252L628 253L627 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M628 252L630 254L628 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M660 252L661 253L660 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M664 252L665 253L664 252M670 252L671 253L670 252M674.333 252.667L674.667 253.333L674.333 252.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M710 252L711 253L710 252M713 252L713 253L716 253L713 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M793 252L794 253L793 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M628 253L629 254L628 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M660 253L661 254L660 253M665 253L666 254L665 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M666 253L666 254L669 254L666 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M669 253L670 254L669 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M675 253L676 254L675 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M710 253L710 254L719 254L710 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M724 253L724 257L725 257L724 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M773 253L774 257L775 257L773 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M774 253L775 254L774 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M789 253L790 254L789 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M794 253L795 254L794 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M432 254L432 255L437 255L437 256L434 256L436 260L432 261L432 262L438 266L437 269L443 269L443 268L440 268L440 267C442.338 264.588 440.377 262.614 438 261L438 260L447 259L447 258C443.146 258 440.327 257.691 441 255L432 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M486 254L487 255L486 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M562.333 254.667L562.667 255.333L562.333 254.667M585 254L586 255L585 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M660 254L662 256L660 254M674 254L675 255L674 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M680.333 254.667L680.667 255.333L680.333 254.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M719 254L719 257L720 257L719 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M739.333 254.667L739.667 255.333L739.333 254.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M790 254L791 255L790 254M795 254L796 255L795 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M298 255L300.84 273.571L292 279L292 281L296 284L288 284C289.53 289.235 296.351 288.984 301 289L299 286C309.98 280.792 307.642 260.606 298 255M486 255L487 256L486 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M487 255L488 256L487 255M629 255L630 256L629 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M660 255L661 256L660 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M673 255L674 256L673 255M791 255L792 256L791 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M460 257L461 266L468 262C466.6 257.439 464.769 255.715 460 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M488 256L489 257L488 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M563 256L564 257L563 256M584 256L585 257L584 256M630 256L631 257L630 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M631 256L632 257L631 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M663 256L664 257L663 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M672 256L673 257L672 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M686 256L687 257L686 256M699 256L700 257L699 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M748 256L749 257L748 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M784 256L785 257L784 256M796 256L797 257L796 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M489 257L491 259L489 257M584 257L585 258L584 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M664 257L665 258L664 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M665 257L665 258L670 258L665 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M670 257L671 258L670 257M682 257L682 258L685 258L682 257M694 257L694 258L698 258L694 257M706 257L706 258L719 258L706 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M739 257L740 258L739 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M745 257L745 258L749 258L745 257M761 257L761 258L774 258L761 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M780 257L781 258L780 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M781 257L781 258L784 258L781 257M793 257L793 258L796 258L793 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M488 258L489 259L488 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M489 258L490 259L489 258M564 258L565 259L564 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M631 258L632 259L631 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M709 258L710 259L709 258M713 258L714 259L713 258M715 258L716 259L715 258M717 258L718 259L717 258M726 258L726 259L738 259L726 258M745 258L746 259L745 258M747.667 258.333L748.333 258.667L747.667 258.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M491 259L492 260L491 259M583 259L584 260L583 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M633 259L634 260L633 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M634 259L635 260L634 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M492 260L493 261L492 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M565 260L566 261L565 260M634 260L635 261L634 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M637 260L638 261L637 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M770 260L769 262L770 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M414 262L414 263L418 263L414 262M429.667 261.333L430.333 261.667L429.667 261.333M492 261L493 262L492 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M494 261L495 262L494 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M566 261L567 262L566 261M582 261L583 262L582 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M636.667 261.333L637.333 261.667L636.667 261.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M638 261L639 262L638 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M641 261L642 262L641 261M766 261L767 262L766 261M446 262L446 263L449 264L446 268L447 279L449 279L447 284L456 285L456 284L449 283L449 282L455 276C453.499 274.188 453.842 273.978 456 273L456 272L454 272L454 271L457 271L457 270L453 266L449 267L449 266L452 264L446 262M494 262L495 263L494 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M496 262L497 263L496 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M497 262L498 263L497 262M566 262L567 263L566 262M582 262L583 263L582 262M640 262L641 263L640 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M641 262L641 268L642 268L641 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M496.667 263.333L497.333 263.667L496.667 263.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M499 263L500 264L499 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M500 263L500 264L505 264L500 263M567 263L568 264L567 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M765 263L766 264L765 263M272 264L276 272L280 271L280 272L275 274L275 271L266 282L265 282L264 282L262 280L264 288L283 287C282.805 285.194 282.273 282.071 281 285L280 285L283 279L281 278L281 277L288 276C288.654 273.573 290.893 270.646 290.539 268.095C289.734 262.303 276.125 264 272 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M506 264L507 265L506 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M507 264L507 265L511 267L507 264M568 264L569 265L568 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M581 264L582 265L581 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M761 264L762 265L761 264M415 265L414 267L416 267L415 265M508 265L509 266L508 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M569 265L570 266L569 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M581.333 265.667L581.667 266.333L581.333 265.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M463 266L464 267L463 266M509 266L505 287L504 287L502 280L503 274C496.278 279.654 497.581 294.184 495.431 302C494.032 307.089 489.604 309.742 487.279 314.184C485.594 317.401 486.444 320.003 488 323L485 328C480.988 329.339 480.271 331.971 480 336C498.542 335.998 502.869 312.797 503 297C511.39 295.986 512.722 279.313 511 273L513 273L509 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M570 266L571 267L570 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M510 267L511 268L510 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M571 267L572 268L571 267M580.333 267.667L580.667 268.333L580.333 267.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M400 268L403 271L400 268M422 268L422 279L425 280L430 274L430 273L428 272C430.624 268.569 424.352 268.077 422 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M511 268L512 269L511 268M572 268L573 269L572 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M765 268L765 269L768 270L765 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M415 269L416 270L415 269M463 269L464 270L463 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M573 269L575 271L573 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M574 269L575 270L574 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M580 269L581 270L580 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M667 269L666 271L667 269M683 269L684 270L683 269M718 269L718 270L721 271L718 269M734 272L738 270L734 272M750 270L750 271L753 272L754 272L753 269L750 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M789 269L789 270L792 270L789 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M436 270L440 273L436 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M512 270L513 271L512 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M640 270L641 271L640 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M665.333 270.667L665.667 271.333L665.333 270.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M667 270L659 290L677 290L669 270L667 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M681 270L682 271L681 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M682 270L682 290L683 290L682 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M683 270L683 290L686 290L686 278L699 290L699 270C694.017 271.654 695 276.475 695 281L683 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M684 270L685 271L684 270M695 270L696 271L695 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M699 270L698 291L699 291C700.693 285.273 701.336 275.568 699 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M707 270L708 271L707 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M708 270L707 290L711 290L710 270L708 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M710 270L711 271L710 270M718 270L718 290L719 290L718 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M719 270L719 290L722 290L722 281L727 286L729 286L734 281L734 290L738 289L737 270C727.429 278.364 728.571 278.364 719 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M737 270L738 271L737 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M751 270L743 290L761 290L753 270L751 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M754.333 270.667L754.667 271.333L754.333 270.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M766 270L766 288L767 288L766 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M767 270L767 290L779 290L779 287L770 286C771.47 281.028 772.967 271.98 767 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M770 270L771 271L770 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M787 270L788 271L787 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M784 285C789.224 295.358 803.36 285.564 793.896 279.367C792.073 278.174 790.061 277.596 788 277L797 274C793.872 270.456 783.979 267.99 785.377 276C786.523 282.567 798.806 287.455 784 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M793 270L794 271L793 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M794 270L795 271L794 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M511 271L512 272L511 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M576 271L577 272L576 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M578 271L579 272L578 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M579 271L578 273L580 273L579 271M640 271L641 272L640 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M666 271L667 272L666 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M669 271L670 272L669 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M685 271L686 272L685 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M706 271L706 290L707 290L706 271M711 271L711 290L712 290L711 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M750 271L751 272L750 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M785 271L786 272L785 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M795 271L796 272L795 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M432 272L433 273L432 272M474 272L475 276L476 276L476 272L474 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M513 272L514 273L513 272M548 272L549 273L548 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M549 272L544 290C538.832 290.58 529.812 296.55 533.047 302.871C534.549 305.807 539.448 307.069 538.122 311.019C537.165 313.87 530.379 326.056 526.549 323.248C523.392 320.934 523.512 313.514 522.919 310C522.354 306.652 521.666 303.329 521 300C520.002 295.008 518.679 290.041 518 285L517 285L508 324C514.171 323.713 518.998 321.558 520 315L523 315C522.983 319.012 523.862 329.301 519 330C518.253 334.689 516.333 335.494 512 334L514 340L512 341C502.657 340.347 489.009 339.185 488 352L500 351L498 348L503 345L504 345L508 348L504 349L504 350L512 352L512 361L505 351L504 351L504 360L496 360C495.61 365.056 493.148 366.512 489 369L490 371L480 376L480 387L493 387L493 389L480 392C479.435 396.211 478.164 398.715 474 400L472 415L464 412L462 415L464 422L472 424L472 432C477.321 432.004 483.765 433.597 488.882 431.761C491.961 430.656 492.485 427.696 494.633 425.583C502.61 417.742 504 414.555 504 403L512 403L512 399C516.327 397.8 519.225 396.686 520 392L536.911 391.683L544.442 387.765L547 392L560 388L560 400L565 400L565 392L568 395L575 392L576 384L572 384C571.986 377.528 571.085 371.899 576 367L576 376C580.18 372.918 578.808 368.591 579 364L583 367L584 363L584 362L580 358L587 359L587 358L576 358L582 344L581 344C578.788 346.443 576.437 347.962 574 345L573 345L573 359L564 351L560 360L561 344L560 344L562 368L558 364L552 367L558 368L548 376L549 368C545.334 363.944 547.589 361.322 551 358L553 360L555 355L549 355L549 351L557 352L560 326L572 336C572.055 328.801 572.936 321.391 564 320L565 317L560 315L556 320L554 303L555 302L557 302L560 312L563 311L563 310L560 309L560 305L565 305L568 310L574 311L556.192 297.893L566 285L563 286C563.134 289.739 558.28 291.317 555 291L563 277L554 288L553 288L549 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M639 272L640 273L639 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M686 272L693 279L686 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M687 272L688 273L687 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M721 272L722 273L721 272M734 272L735 273L734 272M737 272L737 277L738 277L737 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M755 272L756 273L755 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M796 272L797 273L796 272M550 273L551 274L550 273M567 273L567 274L569 277L570 277L567 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M664 273L665 274L664 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M665 273L666 274L665 273M670 273L671 274L670 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M671 273L672 277L673 277L671 273M688 273L689 274L688 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M722 273L723 274L722 273M733 273L734 274L733 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M749 273L750 274L749 273M754 273L755 274L754 273M784 273L785 274L784 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M789 273L789 274L792 274L789 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M797 273L798 274L797 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M412.667 274.333L413.333 274.667L412.667 274.333M513 274L514 275L513 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M514 274L515 275L514 274M547 274L548 275L547 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M550 274L551 275L550 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M565 274L566 275L565 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M555 291C558.795 291.083 562.491 290.157 563 286L566 281L568 274C560.862 276.89 556.825 283.795 555 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M568.333 274.667L568.667 275.333L568.333 274.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M638 274L639 275L638 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M670 274L671 275L670 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M681 274L682 275L681 274M689 274L690 275L689 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M723 274L724 275L723 274M732 274L733 275L732 274M754 274L755 275L754 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M755 274L756 275L755 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M784 274L784 277L785 277L784 274M788 274L789 275L788 274M793 274L794 275L793 274M796 274L797 275L796 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M434 275L434 276L436 277L430 283L431 293L424 293L426 296L420 296L423 292L423 291L423 286C414.617 282.47 415.676 293.099 412 298L416 300L415 297L421 301L418 301L418 302L418 306L409.871 299.989L390 304L393 301L392 296L376 296.82L366.015 289.798L334 289L339 299L338 303C345.09 309.116 353.182 315.545 359.61 322.255C364.607 327.471 368.376 334.45 376 336L376 337L370 340C371.812 343.614 375.689 346.043 376.863 350.004C378.948 357.033 375.476 363.938 385 367L387 357L395 365C406.215 367.657 420.795 360.879 418 347C423.285 351.222 437.455 355.544 437.227 343.999C437.132 339.223 432.665 335.782 432 331L436 332L436 331L434 329L440 331L438 326L447 325L454 319L452 307L451 307L440 312C440.544 307.519 440.097 303.343 445 302L448 296L449 286L444 283L443 289C439.173 286.846 438.118 285.068 440 281L440 280L436 278L438 276L434 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M514 275L515 276L514 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M551 275L552 276L551 275M563 275L564 276L563 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M564 275L565 276L564 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M637 275L638 276L637 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M664 275L665 276L664 275M671 275L672 276L671 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M690 275L691 276L690 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M724 275L725 276L724 275M731 275L732 276L731 275M748 275L749 276L748 275M755 275L756 276L755 275M788 275L789 276L788 275M794.667 275.333L795.333 275.667L794.667 275.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M410 276L411 279L408 280L411 284L410 280L416 280L410 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M515 276L516 277L515 276M546 276L547 277L546 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M551 276L552 277L551 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M562 276L563 277L562 276M636 276L637 277L636 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M662 276L659 286L656 287L659 291L664 276L662 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M664 276L665 277L664 276M671 276L672 277L671 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M691 276L692 277L691 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M725 276L726 277L725 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M748 276L749 277L748 276M755 276L756 277L755 276M788 276L789 277L788 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M451 277L452 278L451 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M515 277L516 278L515 277M546 277L547 278L546 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M552 277L553 278L552 277M561 277L562 278L561 277M635 277L636 278L635 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M663 277L664 278L663 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M673.333 277.667L673.667 278.333L673.333 277.667M692 277L693 278L692 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M725 277L726 278L725 277M730 277L731 278L730 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M747 277L748 278L747 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M756 277L757 278L756 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M784 277L785 278L784 277M790 277L791 278L790 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M440 278L441 279L440 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M545 278L546 279L545 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M552 278L553 279L552 278M560 278L561 279L560 278M568 278L569 279L568 278M634 278L635 279L634 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M663 278L664 279L663 278M667.667 278.333L668.333 278.667L667.667 278.333M672.333 278.667L672.667 279.333L672.333 278.667M686 278L686 289L687 289L686 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M693 278L694 279L693 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M726 278L727 279L726 278M729 278L730 279L729 278M737 278L738 279L737 278M747 278L748 279L747 278M751.667 278.333L752.333 278.667L751.667 278.333M756 278L757 279L756 278M785 278L787 280L785 278M792 278L793 279L792 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M793 278L794 279L793 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M458 280L458 281L461 281L457 285L457 294L459 292C464.283 293.231 465.137 289.742 462 286C467.023 282.655 462.256 279.654 458 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M511 279L512 280L511 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M516 279L517 280L516 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M545 279L546 280L545 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M549.667 279.333L550.333 279.667L549.667 279.333M552 279L553 280L552 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M559 279L560 280L559 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M568 279L569 280L568 279M632 279L633 280L632 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M662 279L663 280L662 279M667 279L668 280L667 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M668 279L669 280L668 279M687 279L688 280L687 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M694 279L695 280L694 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M727.667 279.333L728.333 279.667L727.667 279.333M746 279L747 280L746 279M751.667 279.333L752.333 279.667L751.667 279.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M785 279L786 280L785 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M794 279L795 280L794 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M376 280L377 281L376 280M444.667 280.333L445.333 280.667L444.667 280.333M515 280L516 281L515 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M516 280L517 281L516 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M545 280L546 281L545 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M558 280L559 281L558 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M630 280L631 281L630 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M631 280L632 281L631 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M662 280L663 281L662 280M666 280L667 281L666 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M667 280L666 284L670 284L669 280L667 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M673 280L674 281L673 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M688 280L689 281L688 280M746 280L747 281L746 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M751 280L750 284L754 284L751 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M757 280L758 281L757 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M787 280L788 281L787 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M796 280L797 281L796 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M390 281L390 282L393 283L390 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M544.333 281.667L544.667 282.333L544.333 281.667M553 281L554 282L553 281M557 281L558 282L557 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M566 281L567 282L566 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M567 281L568 282L567 281M628 281L629 282L628 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M630 281L631 282L630 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M661 281L662 282L661 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M666 281L667 282L666 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M669 281L670 282L669 281M673 281L674 282L673 281M689 281L690 282L689 281M722 281L723 282L722 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M723 281L724 282L723 281M732 281L731 283L732 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M733 281L733 290L734 290L733 281M750 281L751 282L750 281M753 281L754 282L753 281M757 281L758 282L757 281M789 281L790 282L789 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M441.667 282.333L442.333 282.667L441.667 282.333M516.333 282.667L516.667 283.333L516.333 282.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M517.333 282.667L517.667 283.333L517.333 282.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M553 282L555 287L553 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M556 282L557 283L556 282M625 282L624 284L625 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M626 282L627 283L626 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M619 307L620 307L621 297L631 298L632 297L632 287L628 286L629 282C617.63 285.876 618.651 297.129 619 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M661 282L662 283L661 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M669 282L670 283L669 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M674 282L675 283L674 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M690 282L691 283L690 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M722 282L722 290L723 290L722 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M724 282L725 283L724 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M732 282L733 283L732 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M745.333 282.667L745.667 283.333L745.333 282.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M750 282L751 283L750 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M758 282L759 283L758 282M791 282L792 283L791 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M792 282L793 283L792 282M797 282L798 283L797 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M463 283L464 284L463 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M544 283L545 284L544 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M551 283L552 284L551 283M556 283L557 284L556 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M565 283L566 284L565 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M661 283L662 284L661 283M665 283L666 284L665 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M667.667 283.333L668.333 283.667L667.667 283.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M670 283L671 284L670 283M674 283L675 284L674 283M691 283L692 284L691 283M725 283L726 284L725 283M730 283L731 284L730 283M737.333 283.667L737.667 284.333L737.333 283.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M744 283L745 284L744 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M749 283L750 284L749 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M751.667 283.333L752.333 283.667L751.667 283.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M754 283L755 284L754 283M758 283L759 284L758 283M793 283L794 284L793 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M517 284L518 285L517 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M544 284L545 285L544 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M555 284L556 285L555 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M561 284L562 285L561 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M566 284L567 285L566 284M623 284L624 285L623 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M626 284L627 285L626 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M657.333 284.667L657.667 285.333L657.333 284.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M660 284L661 285L660 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M675 284L676 285L675 284M688 284L689 285L688 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M692 284L693 285L692 284M726 284L727 285L726 284M729 284L730 285L729 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M744 284L745 285L744 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M759 284L760 285L759 284M784 284L785 285L784 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M785.667 284.333L786.333 284.667L785.667 284.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M793 284L794 285L793 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M407 285L408 286L407 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M518.333 285.667L518.667 286.333L518.333 285.667M554 285L555 286L554 285M566 285L567 286L566 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M622 285L623 286L622 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M660 285L661 286L660 285M675 285L676 286L675 285M693 285L694 286L693 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M726 285L727 286L726 285M729 285L730 286L729 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M744 285L745 286L744 285M759 285L760 286L759 285M770 285L771 286L770 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M783 285L784 286L783 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M787 285L788 286L787 285M793 285L794 286L793 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M430 286L431 287L430 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M565 286L566 287L565 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M621 286L622 287L621 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M626.333 286.667L626.667 287.333L626.333 286.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M659 286L660 287L659 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M694 286L695 287L694 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M727 286L728 287L727 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M737.333 286.667L737.667 287.333L737.333 286.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M743 286L744 287L743 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M771 286L771 287L779 290C780.031 285.412 774.226 286.011 771 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M779 286L780 287L779 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M783 286L784 287L783 286M789 286L790 287L789 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M790.667 286.333L791.333 286.667L790.667 286.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M792 286L793 287L792 286M797 286L798 287L797 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M275 287L276 288L275 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M518 287L519 288L518 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M553 287L554 288L553 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M565 287L566 288L565 287M659 287L660 288L659 287M664 287L664 288L670 288L664 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M670 287L671 288L670 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M671 287L672 288L671 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M676 287L677 288L676 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M743 287L744 288L743 287M748 287L748 288L756 288L748 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M760 287L761 288L760 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M784 287L786 289L784 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M797 287L798 288L797 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M280 288L280 289L284 289L280 288M423 288L425 290L425 288L423 288M466.667 288.333L467.333 288.667L466.667 288.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M503 288L504 289L503 288M518 288L519 289L518 288M554 288L555 289L554 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M564 288L565 289L564 288M620 288L621 289L620 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M658 288L659 289L658 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M663 288L664 289L663 288M672 288L673 289L672 288M676 288L677 289L676 288M747 288L748 289L747 288M756 288L757 289L756 288M760 288L761 289L760 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M766.333 288.667L766.667 289.333L766.333 288.667M784 288L785 289L784 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M796 288L797 289L796 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M436 289L431 293L432 302C433.929 302.792 441.62 303.393 438 300L441 290L436 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M519.333 289.667L519.667 290.333L519.333 289.667M541 289L542 290L541 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M542.667 289.333L543.333 289.667L542.667 289.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M557 289L558 290L557 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M563 289L564 290L563 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M619 289L620 290L619 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M658 289L659 290L658 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M663 289L664 290L663 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M672 289L673 290L672 289M686 289L687 290L686 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M696 289L697 290L696 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M737 289L738 290L737 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M742 289L743 290L742 289M747 289L748 290L747 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M756 289L757 290L756 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M786 289L787 290L786 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M794 289L795 290L794 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M795 289L796 290L795 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M264 291L264 292L277 291L264 291M298 290L282 295L282 296L292 299L292 298L288 297L288 296L294 297L298 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M462.667 290.333L463.333 290.667L462.667 290.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M539 290L540 291L539 290M562 290L563 291L562 290M619 290L620 291L619 290M660.667 290.333L661.333 290.667L660.667 290.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M662 290L663 291L662 290M673 290L673 291L676 291L673 290M683 290L684 291L683 290M685 290L686 291L685 290M697 290L698 291L697 290M699 290L700 291L699 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M706 290L707 291L706 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M709.667 290.333L710.333 290.667L709.667 290.333M719 290L719 291L722 291L719 290M734 290L734 291L738 291L734 290M743 290L744 291L743 290M745 290L746 291L745 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M773 290L773 291L779 291L773 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M788.667 290.333L789.333 290.667L788.667 290.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M790.667 290.333L791.333 290.667L790.667 290.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M792.667 290.333L793.333 290.667L792.667 290.333M519 291L520 292L519 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M537 291L538 292L537 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M554 291L555 292L554 291M559.667 291.333L560.333 291.667L559.667 291.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M561 291L562 292L561 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M619 291L620 292L619 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M748 291L749 292L748 291M378 292L380 294L380 292L378 292M399.333 292.667L399.667 293.333L399.333 292.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M519 292L520 293L519 292M556 292L555 294L556 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M559 292L560 293L559 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M618.333 292.667L618.667 293.333L618.333 292.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M536 293L537 294L536 293M541 293L542 294L541 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M558 293L559 294L558 293M520 294L521 295L520 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M535 294L536 295L535 294M539 294L540 295L539 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M557 294L558 295L557 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M618 294L619 295L618 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M395 295L395 297L398 297L398 295L395 295M456 295L457 296L456 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M520.333 295.667L520.667 296.333L520.333 295.667M534 295L535 296L534 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M556 295L557 296L556 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M618 295L619 296L618 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M713 295L714 296L713 295M248 296L248 297L256 299L255 301L272 303L272 304L268 304C268 308.01 267.434 310.653 271 313L264 312C262.363 319.345 260.604 326.971 253 330L254 333C242.459 336.906 244 343.075 244 354C234.902 349.564 237.823 370.222 246 369C243.858 381.241 261.905 407.085 271 388L265 392L267 385L264 388L263 388L266 379L261 378L261 377L267 369L259 374L271 364L271 363L265 365L271 361L271 360L260 364C263.647 359.561 266.072 356.844 272 357L272 356L268 356L268 355L277 351L277 350L271 351L271 350L276 348L276 347L270 349L277 341L267 347L275 336L267 339L267 338L272 334L268 335L270 331L270 330L268 328L272 328L272 327L265 327L265 326L270 323L266 323L266 322L271 322L271 321L268 320L278 317L278 316L275 315L278 314L278 313L275 313L275 312C276.882 311.96 283.145 311.366 280 309L280 308L282 308L282 307L280 307L282 306L281 302L288 301C279.897 294.335 258.521 296.859 248 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M533 296L534 297L533 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M555 296L556 297L555 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M453 297L453 299L456 299L456 297L453 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M520 297L521 298L520 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M532 297L533 298L532 297M555.333 297.667L555.667 298.333L555.333 297.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M618 297L618 300L619 300L618 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M521.333 298.667L521.667 299.333L521.333 298.667M531 298L532 299L531 298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M531 299L532 300L531 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M555 299L556 300L555 299M752 299L753 300L752 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M452 302L455 300L452 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M521 300L522 301L521 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M531.333 300.667L531.667 301.333L531.333 300.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M556 300L557 301L556 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M557 300L558 301L557 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M521.333 301.667L521.667 302.333L521.333 301.667M558 301L559 302L558 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M559 301L560 302L559 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M560 301L561 302L560 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M618 301L619 302L618 301M753 301L754 302L753 301M519 302L518 303L518 304L519 305L520 305L521 304L521 303L519 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M531 302L532 303L531 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M561 302L562 303L561 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M562 302L563 303L562 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M563 302L564 303L563 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M618.333 302.667L618.667 303.333L618.333 302.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M666 302L667 303L666 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M667 302L668 303L667 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M668 302L668 303L671 303L668 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M671 302L672 303L671 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M690 302L691 303L690 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M691 302L692 303L691 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M692.667 302.333L693.333 302.667L692.667 302.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M694 302L695 303L694 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M695 302L696 303L695 302M709 302L710 303L709 302M711 302L712 303L711 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M731 302L732 303L731 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M732 302L731 323L732 323L732 303L741 311L732 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M745 302L746 303L745 302M747 302L749 304L747 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M749 302L750 303L749 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M754 302L754 303L760 303L754 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M522.333 303.667L522.667 304.333L522.333 303.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M532 303L534 305L532 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M555 303L556 304L555 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M560 303L561 304L560 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M564 303L565 304L564 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M565 303L566 304L565 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M664 303L665 304L664 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M665 303L666 304L665 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M678 318C674.557 317.43 671.314 319.762 668.044 318.918C662.469 317.481 662.051 309.631 667.109 307.237C670.362 305.697 674.471 308.338 678 308C676.526 306.14 675.301 304.606 672.982 303.738C655.721 297.287 655.41 328.678 672.982 322.11C675.293 321.246 676.503 319.841 678 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M673 303L674 304L673 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M674 303L675 304L674 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M688.667 303.333L689.333 303.667L688.667 303.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M690.004 303.573C677.657 307.099 683.839 326.042 695.996 322.343C708.354 318.584 702.512 300.002 690.004 303.573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M697 303L698 304L697 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M708 303L709 304L708 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M709 303C709 307.75 707.771 314.613 710.179 318.891C713.32 324.47 721.866 323.826 724.258 317.956C726.017 313.639 725 307.586 725 303L722 303C722 306.948 723.459 318.793 717 318.793C710.541 318.793 712 306.948 712 303L709 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M712 303L713 304L712 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M721 303L721 316L722 316L721 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M725 303L726 304L725 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M732 303L732 323L735 323L735 312L748 323L748 303L745 303L745 314L732 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M744 303L744 314L745 314L744 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M753 303L753 306L754 306L753 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M754 303L754 306L760 306L761 323L763 323L764 306L770 306L770 303L754 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M770 303L764 306L764 307C767.061 306.9 770.867 306.86 770 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M410 304L414 307L410 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M452 304L452 306L454 306L452 304M471 304L471 306L473 304L471 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M532 304L533 305L532 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M535 304L536 305L535 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M566 304L567 305L566 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M567 304L568 305L567 304M618 304L618 307L619 307L618 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M662 304L663 305L662 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M663 304L664 305L663 304M675 304L676 305L675 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M686 304L687 305L686 304M699 304L700 305L699 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M708 304L708 316L709 316L708 304M712 304L712 316L713 316L712 304M725 304L725 316L726 316L725 304M748 304L748 323L749 323L748 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M522.333 305.667L522.667 306.333L522.333 305.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M534 305L535 306L534 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M568 305L569 306L568 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M569 305L570 306L569 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M661 305L662 306L661 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M676 305L677 306L676 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M685 305L686 306L685 305M700 305L701 306L700 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M536 306L537 307L536 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M537 306L538 307L537 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M570 306L571 307L570 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M660 306L661 307L660 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M667 306L667 307L672 307L667 306M677 306L678 307L677 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M684 306L685 307L684 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M690.667 306.333L691.333 306.667L690.667 306.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M692.667 306.333L693.333 306.667L692.667 306.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M694.667 306.333L695.333 306.667L694.667 306.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M701 306L702 307L701 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M754 306L754 307L760 307L754 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M770 306L771 307L770 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M469 307L472 309L469 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M522 307L523 308L522 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M538 307L539 308L538 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M561 307L562 308L561 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M571 307L572 308L571 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M660 307L661 308L660 307M665 307L666 308L665 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M666 307L667 308L666 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M672 307L673 308L672 307M689 307L688 309L689 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M690.228 308.032C684.019 311.696 689.494 321.343 695.852 317.806C702.244 314.25 696.488 304.339 690.228 308.032z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M696 307L697 308L696 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M702 307L703 308L702 307M764 307L765 308L764 307M422 309L422 311L425 312L426 308L422 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M539.333 308.667L539.667 309.333L539.333 308.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M567 308L568 309L567 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M572 308L573 309L572 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M659 308L660 309L659 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M664 308L665 309L664 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M673 308L674 309L673 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M676 308L677 309L676 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M677 308L678 309L677 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M683 308L684 309L683 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M697 308L698 309L697 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M702 308L703 309L702 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M764 308L765 309L764 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M466 309L471 312L471 311L466 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M523.333 309.667L523.667 310.333L523.333 309.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M571 309L572 310L571 309M573 309L574 310L573 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M574 309L575 310L574 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M619 309L620 310L619 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M620 309L622 313L620 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M656 309L657 310L656 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M659 309L660 310L659 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M674 309L675 310L674 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M675 309L676 310L675 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M687 309L688 310L687 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M698 309L699 310L698 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M703 309L704 310L703 309M764 309L765 310L764 309M539 310L540 311L539 310M560 310L561 311L560 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M566 310L567 311L566 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M619.333 310.667L619.667 311.333L619.333 310.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M658 310L659 311L658 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M663 310L664 311L663 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M682.333 310.667L682.667 311.333L682.333 310.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M687 310L688 311L687 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M703 310L703 316L704 316L703 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M730 310L730 313L731 313L730 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M764 310L765 311L764 310M523 311L524 312L523 311M538 311L539 312L538 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M563 311L564 312L563 311M568 311L569 312L568 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M575 311L576 312L575 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M656 311L657 312L656 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M658 311L658 315L659 315L658 311M663 311L664 312L663 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M699 311L699 315L700 315L699 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M741 311L742 312L741 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M764 311L765 312L764 311M272.667 312.333L273.333 312.667L272.667 312.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M464 312L456 322L456 324L464 328L464 320L464 319C466.475 318.487 466.575 318.396 466 316L469 315L468 312L464 312M480 312L481 313L480 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M523.333 312.667L523.667 313.333L523.333 312.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M537 312L538 313L537 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M575 312L576 313L575 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M576 312L577 313L576 312M682 312L683 313L682 312M686.333 312.667L686.667 313.333L686.333 312.667M735 312L735 323L736 323L735 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M736 312L738 314L736 312M742 312L744 314L742 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M743 312L744 313L743 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M759 312L759 322L760 322L759 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M764 312L764 320L765 320L764 312M536 313L537 314L536 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M559 313L560 314L559 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M576 313L577 314L576 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M663 313L664 314L663 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M682.333 313.667L682.667 314.333L682.333 313.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M736 313L737 314L736 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M524 314L524 317L525 317L524 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M535 314L536 315L535 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M576 314L577 322C583.496 326.46 589.392 326 597 326L597 325C584.74 325 583.064 323.332 576 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M577 314L578 315L577 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M620 314L621 315L620 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M621 314L621 317L622 317L621 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M663 314L664 315L663 314M738 314L739 315L738 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M272.667 315.333L273.333 315.667L272.667 315.333M464 315L465 316L464 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M478.667 315.333L479.333 315.667L478.667 315.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M534 315L535 316L534 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M537 315L538 316L537 315M577 315L578 316L577 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M620 315L620 318L621 318L620 315M663 315L664 316L663 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M682 315L683 316L682 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M687 315L688 316L687 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M739 315L740 316L739 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M534 316L535 317L534 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M578 316L579 317L578 316M659 316L660 317L659 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M674 316L675 317L674 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M675 316L676 317L675 316M683 316L684 317L683 316M687 316L688 317L687 316M698 316L699 317L698 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M703 316L704 317L703 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M708 316L709 317L708 316M725.333 316.667L725.667 317.333L725.333 316.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M740 316L741 317L740 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M264 317L264 320L265 320L264 317M430 317L430 318L437 320L437 317L430 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M524.333 317.667L524.667 318.333L524.333 317.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M533 317L534 318L533 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M578 317L579 318L578 317M659 317L660 318L659 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M664 317L665 318L664 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M673 317L674 318L673 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M677 317L678 318L677 317M683 317L684 318L683 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M688 317L689 318L688 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M697 317L698 318L697 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M702 317L703 318L702 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M708 317L709 318L708 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M713 317L714 318L713 317M720 317L721 318L720 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M741 317L742 318L741 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M487.333 318.667L487.667 319.333L487.333 318.667M533 318L534 319L533 318M578 318L579 319L578 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M660 318L661 319L660 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M666 318L667 319L666 318M672 318L673 319L672 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M684 318L685 319L684 318M689 318L690 319L689 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M690 318L691 319L690 318M695 318L696 319L695 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M696 318L697 319L696 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M702 318L703 319L702 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M709 318L710 319L709 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M714 318L715 319L714 318M719 318L720 319L719 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M724 318L725 319L724 318M742 318L743 319L742 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M477 319L478 320L477 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M524 319L525 320L524 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M532 319L533 320L532 319M579 319L580 320L579 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M660 319L661 320L660 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M667 319L667 320L671 320L667 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M677 319L678 320L677 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M684 319L685 320L684 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M691 319L691 320L695 320L691 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M701 319L702 320L701 319M709 319L710 320L709 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M715 319L715 320L719 320L715 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M724 319L725 320L724 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M743 319L744 320L743 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M749 319L750 320L749 319M272 322L276 321L272 322M479 320L480 321L479 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M495 320L496 321L495 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M521 320L522 321L521 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M532 320L533 321L532 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M579 320L580 321L579 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M622 320L623 321L622 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M661 320L662 321L661 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M676 320L677 321L676 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M685 320L686 321L685 320M700 320L701 321L700 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M710 320L711 321L710 320M723 320L724 321L723 320M744 320L745 321L744 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M764 320L764 323L765 323L764 320M264 321L265 322L264 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M470 327L470 328L479 331L480 331L480 326L477 327L476 324L478 321L470 327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M531 321L532 322L531 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M534 321L534 325L531 324C530.275 329.38 522.477 333.171 530 338L528 333L531 335C533.157 330.281 536.148 326.175 534 321M567 321L566 324L567 321M578 321L579 322L578 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M580 321L581 322L580 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M662 321L663 322L662 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M663 321L664 322L663 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M675 321L676 322L675 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M686 321L687 322L686 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M687 321L688 322L687 321M698 321L699 322L698 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M699 321L700 322L699 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M708 321L709 322L708 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M711 321L712 322L711 321M722 321L723 322L722 321M745 321L746 322L745 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M749 321L750 322L749 321M480.333 322.667L480.667 323.333L480.333 322.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M525 322L526 323L525 322M530 322L531 323L530 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M580 322L581 323L580 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M620 322L621 323L620 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M621 322L622 323L621 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M664 322L665 323L664 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M665 322L666 323L665 322M672.667 322.333L673.333 322.667L672.667 322.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M688 322L689 323L688 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M689 322L690 323L689 322M696 322L697 323L696 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M697 322L698 323L697 322M712 322L713 323L712 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M713 322L714 323L713 322M720 322L721 323L720 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M721 322L722 323L721 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M746 322L748 324L746 322M760 322L761 323L760 322M763 322L764 323L763 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M521 323L522 324L521 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M525 323L526 324L525 323M530 323L531 324L530 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M581 323L582 324L581 323M620 323L621 324L620 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M659 323L660 324L659 323M667 323L668 324L667 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M668 323L668 324L671 324L668 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M671 323L672 324L671 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M691 323L691 324L695 324L691 323M715 323L715 324L719 324L715 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M719 323L720 324L719 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M746 323L747 324L746 323M526 324L527 325L526 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M527.667 324.333L528.333 324.667L527.667 324.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M529 324L530 325L529 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M583 324L584 325L583 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M584 324L584 325L618 325L584 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M618 324L619 325L618 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M504 325C500.519 328.22 500.191 330.401 501 335C504.59 332.644 506.055 328.911 504 325M534 325L535 326L534 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M567 325L566 328L567 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M576 325L576 326L580 326L580 325L576 325M600 325L600 326L608 326L600 325M617.667 325.333L618.333 325.667L617.667 325.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M526 326L525 328L526 326M528 326L529 327L528 326M716 326L717 327L716 326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M722 326L724 328L724 326L722 326M532 327L533 328L532 327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M786 328L787 329L786 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M470 329L470 331L472 331L472 329L470 329M248 331L249 332L248 331M455 333L455 336L456 336L455 333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M791.333 334.667L791.667 335.333L791.333 334.667M266 335L267 336L266 335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M568 335L566 339L568 335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M261 337L262 338L261 337M264 341L267 340L264 341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M570.333 340.667L570.667 341.333L570.333 340.667M571 342L572 343L571 342M562 343L570 352L570 346L565 346L562 343M570 343L569 345L571 345L570 343M572 343L573 344L572 343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M510 344L510 345L513 345L510 344M514 344L515 345L514 344M516 344L516 345L521 346L516 344M525 344L526 345L525 344M537 344L538 345L537 344M547 344L548 345L547 344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M566 344L567 345L566 344M574.667 344.333L575.333 344.667L574.667 344.333M579 344L580 345L579 344M586 344L587 345L586 344M616 344L617 345L616 344M624 344L624 345L627 345L627 344L624 344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M630 344L631 345L630 344M732 344L733 345L732 344M739 344L740 345L739 344M769 344L769 345L772 345L769 344M785 344L786 345L785 344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M360 345L361 352L362 352L360 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M509.333 345.667L509.667 346.333L509.333 345.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M510 345L510 347L514 347L514 357L515 357L515 347L519 347L519 345L510 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M519.333 345.667L519.667 346.333L519.333 345.667M524 345L525 358L526 358L527 352L526 352L526 357L525 357L524 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M525 345L525 357L526 357L526 352L533 352L533 357L534 357L534 345L533 345L533 350L526 350L525 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M526 345L526 350L527 350L526 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M532 345L532 350L533 350L532 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M534 345L534 349L535 349L534 345M540 345L541 346L540 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M540 356L549 357L549 356L542 356L542 352L546 352L546 350L542 350L542 347L548 347L548 345C539.28 345.103 541.503 349.092 540 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M548.333 345.667L548.667 346.333L548.333 345.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M561 345L561 357L562 357L561 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M562 345L562 357L564 357L564 350L572 357L572 345L571 345L570 353L562 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M563 345L564 346L563 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M570 345L571 346L570 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M572 345L572 358L573 358L572 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M577 345L578 346L577 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M581 345L582 346L581 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M582 345L581 347L582 345M590.333 345.667L590.667 346.333L590.333 345.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M591 345L591 347L595 347L595 357L596 357L596 347L600 347L600 345L591 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M600.333 345.667L600.667 346.333L600.333 345.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M604 345L605 346L604 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M605 345L607 358L605 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M606 345L606 357L607 357L606 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M607 345L607 358L608 358L607 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M614 345L612 348L614 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M615 345L616 346L615 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M616 345L617 346L616 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M617.059 345.786C610.081 348.233 613.715 359.408 620.892 357.012C627.928 354.663 624.318 343.24 617.059 345.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M621 345L622 346L621 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M622 345L623 346L622 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M630.667 345.333L631.333 345.667L630.667 345.333M638 345L638 352L633 350L633 351L639 353L638 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M639 345L639 353L635 351L640 357L639 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M640 345L641 346L640 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M650.667 345.333L651.333 345.667L650.667 345.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M661 345L661 358L662 358L661 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M662 345L662 357L669 357L669 356L663 356L662 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M663 345L663 356L664 356L663 345M681 345L682 346L681 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M681 346L682 357C694.842 356.848 692.244 343.199 681 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M686.667 345.333L687.333 345.667L686.667 345.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M688 345L689 346L688 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M700.667 345.333L701.333 345.667L700.667 345.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M708.333 345.667L708.667 346.333L708.333 345.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M709 345L710 346L709 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M709 346L709 347L713 347L713 357L715 357L715 347L719 347L719 345L709 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M714 345L715 346L714 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M719.333 345.667L719.667 346.333L719.333 345.667M726 345L727 346L726 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M727 345L722 357L732 357L727 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M734 345L735 346L734 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M737 345L737 356L738 356L737 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M738 345L738 357C749.394 356.96 748.251 345.566 738 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M743 345L744 346L743 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M744 345L745 346L744 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M753 345L754 346L753 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M756 345L752 357L762 357L756 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M757 345L758 346L757 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M764 345L765 346L764 345M766 345L767 346L766 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M768 345L767 347L768 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M773 353L773 355L766 355L766 356L774 357L769 347L774 348C770.192 342.698 765.022 349.37 773 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M772 345L773 346L772 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M773 345L774 346L773 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M780 345L781 346L780 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M780 357L788 357L788 356L782 356L782 352L786 352L786 350L782 350L782 347L788 347L788 345C779.441 345.101 780 349.62 780 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M788 345L789 346L788 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M564 346L566 348L564 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M582 346L577 357L587 357L582 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M583 346L584 347L583 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M584 346L588 357L589 357L584 346M586.667 346.333L587.333 346.667L586.667 346.333M601 346L602 347L601 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M614 346L615 347L614 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M623 346L624 347L623 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M630 346L631 357L632 357L632 350L635 351L630 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M632 346L633 347L632 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M635 346L636 347L635 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M640 346L640 352L641 352L640 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M649 346L650 347L649 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M650 346L646 357L656 357L652 346L650 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M652 346L653 347L652 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M689 346L690 347L689 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M700 346L696 357L706 357L702 346L700 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M702 346L703 347L702 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M728 346L729 347L728 346M745 346L746 347L745 346M755 346L756 347L755 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M757 346L758 347L757 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M761 346L762 347L761 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M774.333 346.667L774.667 347.333L774.333 346.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M788 346L789 347L788 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M504.667 347.333L505.333 347.667L504.667 347.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M509.667 347.333L510.333 347.667L509.667 347.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M511 347L512 348L511 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M512 347L513 348L512 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M513 347L514 358L515 358L516 347L515 347L515 357L514 357L513 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M516 347L521 352L519 347L520 349L519 349L516 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M518 347L519 348L518 347M542 347L542 350L543 350L542 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M543 347L543 348L549 348L543 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M564 347L565 348L564 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M567 347L568 348L567 347M569.333 347.667L569.667 348.333L569.333 347.667M573 347L574 348L573 347M575 347L574 357L575 357L575 353C577.78 350.953 577.252 349.344 575 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M580 347L581 348L580 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M584 347L585 348L584 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M593 347L594 348L593 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M594 347L594 358C597.825 355.52 597 351.192 597 347L596 347L596 357L595 357L594 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M597 347L598 348L597 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M598.667 347.333L599.333 347.667L598.667 347.333M613 347L614 348L613 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M616 347L615 349L616 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M617 347L618 348L617 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M618 347L618 350L615 349L616 355L623 354L623 353L621 354L621 353L620 347L618 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M620 347L621 348L620 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M621 347L623 349L621 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M624 347L625 348L624 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M630 347L632 358L630 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M633 347L634 348L633 347M649 347L650 348L649 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M652 347L653 348L652 347M681 347L682 348L681 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M683 347L683 356L684 356L683 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M684 347L684 355C690.187 353.967 689.209 348.915 684 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M686 347L687 348L686 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M687 347L688 348L687 347M690 347L691 348L690 347M699 347L700 348L699 347M702 347L703 348L702 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M715 347L716 348L715 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M725 347L726 348L725 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M728 347L729 348L728 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M740 347L740 348L744 349L744 348L740 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M743 347L744 348L743 347M745 347L746 348L745 347M755 347L756 348L755 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M758 347L759 348L758 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M763 347L764 348L763 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M766 347L766 350L767 350L766 347M769 347L770 348L769 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M771 347L772 348L771 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M772 347L773 348L772 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M782 347L783 348L782 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M783.667 347.333L784.333 347.667L783.667 347.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M785 347L786 348L785 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M786 347L786 348L790 348L786 347M265.667 348.333L266.333 348.667L265.667 348.333M508 348L509 349L508 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M518.667 348.333L519.333 348.667L518.667 348.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M537 348L538 349L537 348M551 348L552 349L551 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M565 348L566 349L565 348M580 348L581 349L580 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M584 348L585 349L584 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M590 348L591 349L590 348M593 348L593 357L594 357L593 348M597 348L597 358L598 358L599 348L597 348M600 348L601 349L600 348M604 348L604 354L605 354L604 348M611 348L612 349L611 348M616 348L616 350L618 350L618 348L616 348M619 348L620 349L619 348M621 348L621 354L622 354L621 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M625 348L626 349L625 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M634 348L635 349L634 348M688 348L689 349L688 348M691 348L692 349L691 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M715.333 348.667L715.667 349.333L715.333 348.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M725 348L726 349L725 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M729 348L730 349L729 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M740 348L740 350L743 350L743 348L740 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M754 348L755 349L754 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M758 348L759 349L758 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M773 348L774 349L773 348M782 348L783 349L782 348M269 349L270 350L269 349M507.333 349.667L507.667 350.333L507.333 349.667M509 349L512 351L509 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M540 349L540 355L541 355L540 349M566 349L567 350L566 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M575 349L576 350L575 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M579 349L580 350L579 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M582 349L581 351L582 349M584 349L585 350L584 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M612 349L613 350L612 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M622 349L623 350L622 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M625 349L626 350L625 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M635 349L636 350L635 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M648 349L649 350L648 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M650.667 349.333L651.333 349.667L650.667 349.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M653 349L654 350L653 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M681 349L682 350L681 349M689 349L690 350L689 349M691 349L692 350L691 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M698 349L699 350L698 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M700.667 349.333L701.333 349.667L700.667 349.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M703 349L704 350L703 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M727 349L726 351L727 349M729 349L730 350L729 349M743 349L744 350L743 349M745 349L746 350L745 349M754 349L755 350L754 349M756 349L758 351L756 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M759 349L760 350L759 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M769 349L770 350L769 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M770 349L771 350L770 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M782 349L783 350L782 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M516 350L517 351L516 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M546.333 350.667L546.667 351.333L546.333 350.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M547 350L548 351L547 350M550 350L551 351L550 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M564 350L565 351L564 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M567 350L568 351L567 350M579 350L580 351L579 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M582 350L583 351L582 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M585 350L586 351L585 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M600 350L601 351L600 350M611.333 350.667L611.667 351.333L611.333 350.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M612 350L612 353L613 353L612 350M614 350L614 353L615 353L614 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M615 350L616 354L617 354L615 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M623.333 350.667L623.667 351.333L623.333 350.667M625 350L625 353L626 353L625 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M632 350L632 357L633 357L632 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M648 350L649 351L648 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M650 350L651 351L650 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M651 350L652 351L651 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M689 350L690 351L689 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M698 350L699 351L698 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M700.667 350.333L701.333 350.667L700.667 350.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M703 350L704 351L703 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M715 350L716 351L715 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M724 350L725 351L724 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M727 350L726 353L727 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M730 350L731 351L730 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M740.667 350.333L741.333 350.667L740.667 350.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M745 350L746 351L745 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M753 350L754 351L753 350M756 350L757 351L756 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M759 350L760 351L759 350M767 350L768 351L767 350M771 350L772 351L771 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M772 350L773 351L772 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M786.333 350.667L786.667 351.333L786.333 350.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M517.333 351.667L517.667 352.333L517.333 351.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M565 351L566 352L565 351M568 351L569 352L568 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M578 351L579 352L578 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M581 351L582 352L581 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M582 351L581 353L583 353L582 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M583 351L584 352L583 351M585 351L586 352L585 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M587 351L588 352L587 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M647 351L648 352L647 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M650 351L650 353L652 353L652 351L650 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M654 351L655 352L654 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M681 351C681.137 355.176 681.638 357.272 686 358L686 357L682 357L681 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M689 351L690 352L689 351M697 351L698 352L697 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M700 351L700 353L702 353L702 351L700 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M702 351L703 352L702 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M704 351L705 352L704 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M715 351L715 356L716 356L715 351M726 351L727 352L726 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M728 351L729 352L728 351M730 351L731 352L730 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M746 351L747 352L746 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M753 351L754 352L753 351M755 351L756 352L755 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M756 351L756 353L758 353L756 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M757 351L758 352L757 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M760 351L761 352L760 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M768 351L769 352L768 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M769 351L770 352L769 351M773 351L774 352L773 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M527 352L527 358L528 358L530 354L531 358L532 358L532 352L527 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M528 352L528 353L531 353L528 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M532 352L532 358L533 358L532 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M536 352L537 353L536 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M542 352C543.099 355.321 544.59 355.737 548 356L548 355L542 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M545 352L546 353L545 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M566 352L567 353L566 352M569 352L570 353L569 352M578 352L579 353L578 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M580.333 352.667L580.667 353.333L580.333 352.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M583 352L581 353L581 354L583 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M586 352L587 353L586 352M627 352L628 353L627 352M634 352L635 353L634 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M640.333 352.667L640.667 353.333L640.333 352.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M647 352L648 353L647 352M649 352L650 353L649 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M652 352L649 353L649 354L652 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M654 352L655 353L654 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M689 352L690 353L689 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M697 352L698 353L697 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M699 352L703 353L703 352L699 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M704 352L705 353L704 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M723 352L724 353L723 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M725.333 352.667L725.667 353.333L725.333 352.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M728 352L727 354L729 354L728 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M740 352L740 355L745 355L740 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M744 352L745 353L744 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M755 352L758 354L758 353L755 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M758.333 352.667L758.667 353.333L758.333 352.667M760 352L761 353L760 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M770 352L771 353L770 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M771 352L772 353L771 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M774 352L775 353L774 352M782 352L782 356L788 356L788 355L782 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M534 353L535 354L534 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M538 353L539 354L538 353M564 353L565 354L564 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M567 353L568 354L567 353M578 353L579 354L578 353M586 353L587 354L586 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M611 353L612 354L611 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M612 353L613 354L612 353M615 353L616 354L615 353M625 353L626 354L625 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M628.667 353.333L629.333 353.667L628.667 353.333M635 353L636 354L635 353M646 353L647 354L646 353M655 353L656 354L655 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M689 353L690 354L689 353M691 353L692 354L691 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M696 353L697 354L696 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M702 353L703 354L702 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M726 353L727 354L726 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M731 353L732 354L731 353M747 353L748 354L747 353M752 353L753 354L752 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M761 353L762 354L761 353M767 353L769 355L767 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M772 353L773 354L772 353M774 353L774 356L775 356L774 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M787 353L788 354L787 353M517.333 354.667L517.667 355.333L517.333 354.667M528 354L527 361L522 361L520 364C520.397 368.804 516.929 382.504 512 384L512 392L518 392L518 384L522 384L528 369L532 363L530 354L528 354M537.333 354.667L537.667 355.333L537.333 354.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M568 354L569 355L568 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M573 354L574 355L573 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M577 354L578 355L577 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M587 354L588 355L587 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M613 354L614 355L613 354M615 354L616 355L615 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M617 354L617 355L621 355L617 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M622 354L623 355L622 354M624 354L625 355L624 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M625 354L626 355L625 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M636 354L637 355L636 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M640 354L641 355L640 354M646 354L647 355L646 354M655 354L656 355L655 354M688 354L689 355L688 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M691 354L692 355L691 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M696 354L697 355L696 354M705 354L706 355L705 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M722 354L723 355L722 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M731 354L732 355L731 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M747 354L748 355L747 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M752 354L753 355L752 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M761 354L762 355L761 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M766.667 354.333L767.333 354.667L766.667 354.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M772 354L773 355L772 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M779 354L780 355L779 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M534 355L533 358L534 355M542 355L543 356L542 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M548 355L549 356L548 355M551 355L552 356L551 355M566 355L568 359L566 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M569 355L570 356L569 355M577 355L578 356L577 355M580 355L580 356L585 356L580 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M587 355L588 356L587 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M604.333 355.667L604.667 356.333L604.333 355.667M611.667 355.333L612.333 355.667L611.667 355.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M613 355L614 356L613 355M617 355L618 356L617 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M618.667 355.333L619.333 355.667L618.667 355.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M620 355L621 356L620 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M621 355L622 356L621 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M624 355L625 356L624 355M637 355L638 356L637 355M640 355L641 356L640 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M648 355L648 356L654 356L648 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M664 355L664 356L669 356L664 355M684 355L685 356L684 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M685.667 355.333L686.333 355.667L685.667 355.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M687 355L688 356L687 355M690 355L691 356L690 355M698 355L698 356L704 356L698 355M722 355L723 356L722 355M724 355L724 356L730 356L724 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M732 355L733 356L732 355M740 355L740 356L744 356L740 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M744 355L745 356L744 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M751 355L752 356L751 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M754 355L754 356L760 356L754 355M761 355L762 356L761 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M765 355L768 358L765 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M768 355L769 356L768 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M769 355L770 356L769 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M770 355L771 356L770 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M771 355L772 356L771 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M788 355L789 356L788 355M519.333 356.667L519.667 357.333L519.333 356.667M521 356L522 357L521 356M536 356L535 360L538 359L536 356M538 356L539 357L538 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M540 356L549 358L549 357L540 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M549 356L550 357L549 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M570 356L572 358L570 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M576.333 356.667L576.667 357.333L576.333 356.667M579 356L580 357L579 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M585 356L585 357L588 358L588 357L588 356L585 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M590 356L589 358L591 358L590 356M608.333 356.667L608.667 357.333L608.333 356.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M623 356L624 357L623 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M638 356L639 357L638 356M640 356L639 358L640 356M645 356L647 358L645 356M654 356L654 357L657 357L657 356L654 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M669 356L670 357L669 356M689 356L690 357L689 356M695.333 356.667L695.667 357.333L695.333 356.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M706 356L705 358L706 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M715 356L716 357L715 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M721 356L722 357L721 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M730 356L730 357L733 358L733 357L733 356L730 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M737.333 356.667L737.667 357.333L737.333 356.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M746 356L747 357L746 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M751 356L751 357L751 358L754 357L754 356L751 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M759 356L760 357L759 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M762.333 356.667L762.667 357.333L762.333 356.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M767 356L768 357L767 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M774 356L775 357L774 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M788 356L780 357L780 358L789 357L788 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M513 357L514 358L513 357M515 357L516 358L515 357M524 357L525 358L524 357M526 357L527 358L526 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M551 357L552 358L551 357M561 357L560 360L561 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M562.667 357.333L563.333 357.667L562.667 357.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M570 357L571 358L570 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M577.667 357.333L578.333 357.667L577.667 357.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M585 357L586 358L585 357M596 357L597 358L596 357M616 357L617 358L616 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M617 357L618 358L617 357M620 357L621 358L620 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M621 357L622 358L621 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M625 357L626 358L625 357M632 357L633 358L632 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M640 357L641 358L640 357M645 357L646 358L645 357M647 357L648 358L647 357M654 357L655 358L654 357M656 357L657 358L656 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M662 357L662 358L669 358L662 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M669 357L670 358L669 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M681 357L682 358L681 357M686.667 357.333L687.333 357.667L686.667 357.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M696 357L697 358L696 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M697 357L698 358L697 357M704 357L705 358L704 357M706 357L707 358L706 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M713.667 357.333L714.333 357.667L713.667 357.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M721 357L722 358L721 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M722 357L723 358L722 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M723 357L724 358L723 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M730 357L731 358L730 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M738 357L738 358L744 358L738 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M744 357L745 358L744 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M745 357L746 358L745 357M753 357L754 358L753 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M760.667 357.333L761.333 357.667L760.667 357.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M763 357L764 358L763 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M768 357L769 358L768 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M769 357L770 358L769 357M771.667 357.333L772.333 357.667L771.667 357.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M773 357L774 358L773 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M788 357L789 358L788 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M247.333 358.667L247.667 359.333L247.333 358.667M512 358L513 359L512 358M521.333 358.667L521.667 359.333L521.333 358.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M529 358L530 359L529 358M536 358L537 359L536 358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M564 358L565 359L564 358M572 358L573 359L572 358M574 358L573 360L574 358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M583 358L584 359L583 358M594 358L595 359L594 358M604 358L605 359L604 358M616 358L617 359L616 358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M628 358L627 360L628 358M764 358L762 359L747 368C748.098 375.948 752.083 379.347 760 380C761.222 372.897 767.012 365.194 764 358M766 358L767 359L766 358M519 359L520 360L519 359M533 359L534 360L533 359M546 359L547 360L546 359M562 359L563 360L562 359M571 359L572 360L571 359M577 359L578 360L577 359M578 361L581 364L578 361M247 365L250 368L249 365L247 365M260 366L260 367L264 366L260 366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M550 367L551 368L550 367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M504 370L504 374L511 372L504 370M703 373L698.059 395.001L699 416L703 416L704 408C713.342 404.727 717.353 371.924 703 373M245 375L246 376L245 375M496 376L496 384L500 383L500 380L497 380L496 376M715 452L720 452L720 445C735.812 443.245 728.11 428.966 728 419C742.364 415.755 741.752 405.775 741.036 393C740.671 386.494 738.071 376.872 730.014 376.272C723.959 375.822 722.71 383.412 723.304 388C726.195 410.341 716.786 429.563 715 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M360.054 378.916C349.041 382.624 342.334 413.282 360 408.246C370.105 405.366 369.885 398.383 368.714 389C368.161 384.571 366.279 376.82 360.054 378.916z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M670 384C670.789 387.578 671.244 390.902 675 392L677 400L679 396L680 396L682 400L680 386L670 384M650 384L652 395L653 384L650 384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M370 396C371.172 402.223 368.945 411.63 371.183 416.981C380.398 439.021 418.365 398.241 395.942 388.122C390.837 385.818 376.625 395.114 370 396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M759 389L764 411L768 410L766 406C772.377 400.435 766.428 389.573 759 389M509 392L512 396L512 392L509 392M863 405L862 408L864 422L870 416L866 416L872 408L863 405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M703 407L704 408L703 407M463 408L464 409L463 408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M502 408L502 416L503 416L502 408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M624 408L625 409L624 408M766 409L767 410L766 409M330 428C334.119 425.922 335.17 423.441 334 419C329.483 420.917 328.677 423.355 330 428M336 419L336 424L337 424L336 419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M684 419C680.788 427.478 684.879 434.001 693 437C693.205 427.07 695.998 420.483 684 419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M462 424L463 428L464 428L464 424L462 424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M653 424L656 427L653 424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M360 431L352 431C347.941 448.67 372.752 443.991 369 428C364.943 427.935 361.515 426.49 360 431M465 428L466 429L465 428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M612 435L619 430C614.496 428.491 612.895 430.629 612 435M653 429L653 432L656 432L656 429L653 429M764 430L765 431L764 430M356.333 433.667L356.667 434.333L356.333 433.667M675 440L672 450L674 452L675 452C676.83 449.559 678.552 450.792 678 453L679 453L682 450C681.627 444.571 681.101 440.889 675 440M638 445C633.409 448.851 623.41 458.01 632 463C635.502 456.879 640.363 452.874 638 445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M504 449L505 450L504 449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M640 450L641 451L640 450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M675 450L679 452L679 451L675 450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M251 451L252 452L251 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M266 521L266 520L252 520L252 452L266 452C262.877 450.69 254.478 449.51 252.028 452.603C249.456 455.85 251 464.071 251 468L251 505C251 508.731 249.577 516.302 252.028 519.397C254.473 522.484 262.486 521 266 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M266 451C266 456.887 263.303 471.694 267.028 476.397C270.713 481.05 290.297 478 296 478L296 477L267 477L266 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M296 451L296 477L297 477L297 452L311 453L296 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M641 451L642 452L641 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M642 451L642 452L672 452L642 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M672.667 451.333L673.333 451.667L672.667 451.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M711 451L696 462L694 461L693 486L700 473L701 473C705.199 476.272 709.344 474.549 714 473L712 469L715 469L712 468L712 467C715.161 463.758 713.794 454.283 711 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M252 452L252 520L266 520L267 490C274.908 492.077 287.6 486.302 294.682 491.028C300.094 494.639 297 514.021 297 520L310 520L311 453L297 452C297 457.642 299.597 472.196 295.397 476.397C290.658 481.135 272.46 478 266 478L266 452L252 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M505 452L506 453L505 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M641 452L641 521L642 521L642 474L641 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M642 452L642 520L656 520L656 496C672.184 496.002 671.979 510.058 683.3 518.397C687.272 521.322 694.321 520 699 520L681 493C696.215 485.084 696.264 462.427 680.996 454.403C670.498 448.885 653.581 452 642 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M676 452L677 453L676 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M677 452L678 453L677 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M526 453L526 456L527 456L526 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M679 453L680 454L679 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M680 453L681 454L680 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M310 454L310 514L311 514L311 473L310 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M506 455L506 456L524 455L506 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M681 454L682 455L681 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M1004 454L1004 455L1016 455L1004 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M508 455L509 456L508 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M507 469L508 469L509 456L522 456L524 469C522.085 460.957 524.613 454.573 514.005 455.019C512.273 455.092 510.211 455.11 509.028 456.603C506.868 459.33 507.813 465.586 507 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M522 455L523 456L522 455M683 455L684 456L683 455M1002 455L1003 456L1002 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1002 468L995 468L995 469C1004.01 468.893 1003 463.57 1003 456L1016 456C1016 463.57 1014.99 468.893 1024 469L1024 468L1017 468C1017 464.855 1018.05 459.223 1015.97 456.603C1013.77 453.817 1004.25 453.979 1002.6 457.318C1001.18 460.218 1002 464.844 1002 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1016 455L1017 456L1016 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M509 456C509 463.923 509.194 468.891 500 469L500 480C503.559 480.042 507.543 479.909 508.682 484.059C511.287 493.544 505.555 505.366 511.653 513.985C515.445 519.345 532.543 526.3 537.972 519.397C539.907 516.938 539 511.936 539 509C525.772 509 521.999 505.259 522 492C522 488.899 521.178 484.029 523.603 481.603C526.483 478.724 533.279 480 537 480L537 469L522 469L522 456L509 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M523 456L523 468L538 468L538 481L523 481C523 487.192 520.124 503.24 526.228 506.972C530.364 509.501 537.209 508.164 542 510L535 505L527 507L528 498L528 497L524 486L527 487L525 482L526 484L527 482L528 482C529.767 490.245 539.301 481.951 542 480L539 471C537.73 464.391 529.157 466.073 524 467L523 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M567 456L568 457L567 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M684 456L685 457L684 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M1003 456C1003 463.923 1003.19 468.891 994 469L994 480C997.559 480.042 1001.54 479.909 1002.68 484.059C1005.3 493.604 999.699 505.194 1005.7 513.985C1009.34 519.308 1026.74 525.998 1031.97 519.397C1033.91 516.949 1033 511.927 1033 509C1028.89 509 1023.68 509.782 1020.13 507.258C1015.21 503.757 1013.14 486.07 1017.6 481.603C1020.48 478.724 1027.28 480 1031 480L1031 469C1019.38 469 1016 468.267 1016 456L1003 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M1017 456L1017 464L1018 464L1017 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M685 457L686 458L685 457M687 459L688 460L687 459M688 460L689 461L688 460z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M689 461L690 462L689 461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M690 462L691 463L690 462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M690 463L691 464L690 463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M464 464L465 465L464 464M466 464L467 465L466 464M498 464L499 465L498 464M505 464L506 465L505 464M507 464L507 467L499 469L508 468L507 464M534 464L535 465L534 464M541 464L541 469L542 469L544 464L541 464M555 464L555 468L559 469L559 468L555 464M559 464L560 465L559 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M656 464L656 482L657 482L656 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M657 464L657 465L658 472C660.137 470.43 661.799 468.307 660 466L660 465L665 465L657 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M660 465L660 466L662 467L658 472L659 465C655.094 468.413 657 478.07 657 483C661.998 483 669.526 484.384 673.786 481.258C679.57 477.014 678.38 468.057 671.956 465.229C668.093 463.529 664.012 464.684 660 465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M670 464L671 465L670 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M671 464L672 465L671 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M691 464L692 465L691 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M538 465L540 467L538 465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M566 465L567 466L566 465M568 465L569 466L568 465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M673 465L674 466L673 465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M691.333 465.667L691.667 466.333L691.333 465.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M712 465L713 466L712 465M1001 465L999 467L999 468C1001.25 467.527 1002.12 467.14 1001 465M352.667 466.333L353.333 466.667L352.667 466.333M421 466L421 467L427 467L421 466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M663 466L664 467L663 466M674 466L675 467L674 466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M675 466L676 467L675 466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M341 467L342 468L341 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M344 467L345 468L344 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M345 467L345 468L354 468L345 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M354.667 467.333L355.333 467.667L354.667 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M381 467L382 468L381 467M383 467L383 468L392 468L383 467M393 467L394 468L393 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M421 468L421 469L427 468L421 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M450 469L451 470L454 468L450 469M455 467L455 468L467 468L455 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M566 467L567 468L566 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M567.667 467.333L568.333 467.667L567.667 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M569 467L569 468L576 468L569 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M576.667 467.333L577.333 467.667L576.667 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M578 467L579 468L578 467M692 467L693 468L692 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M725.667 467.333L726.333 467.667L725.667 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M727 467L727 468L733 468L727 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M733.667 467.333L734.333 467.667L733.667 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M735 467L736 468L735 467M783 467L784 468L783 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M784.667 467.333L785.333 467.667L784.667 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M786 467L786 468L790 468L786 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M790.667 467.333L791.333 467.667L790.667 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M792 467L793 468L792 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M911 467L911 468L914 468L911 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M914 467L914 468L920 468L914 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M920 467L921 468L920 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M921 467L922 468L921 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M963.667 467.333L964.333 467.667L963.667 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M965 467L965 468L974 468L965 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M974.667 467.333L975.333 467.667L974.667 467.333M340 468L341 469L340 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M341 468L342 469L341 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M342 468.529C306.628 476.692 323.451 529.489 358.001 520.481C392.569 511.469 375.97 460.69 342 468.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M357.667 468.333L358.333 468.667L357.667 468.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M359 468L360 469L359 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M360 468L361 469L360 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M381.667 468.333L382.333 468.667L381.667 468.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M383 468L384 469L383 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M384 468L384 469L392 469L384 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M392 468L393 469L392 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M393.667 468.333L394.333 468.667L393.667 468.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M395 468L397 470L395 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M408 498C404.965 491.511 401.137 472.8 394.582 469.603C390.995 467.854 384.92 469 381 469C386.537 482.497 392.923 495.675 398.861 509C400.214 512.036 402.882 521.065 407.028 520.994C410.421 520.936 411.993 516.482 413.247 513.999C416.914 506.737 420.873 499.51 424 492C428.146 499.104 431.523 506.667 435.248 513.999C436.461 516.387 437.962 520.424 441.061 520.824C445.59 521.408 447.755 513.052 449.245 510C455.295 497.604 464.582 482.566 467 469C463.204 469 456.765 467.779 453.499 470.028C447.991 473.822 443.139 490.592 442 497C435.886 490.898 433.804 471.717 425.625 468.662C422.124 467.354 420.04 471.494 418.865 474.005C415.151 481.941 411.364 489.909 408 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M427 468L428 469L427 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M428 468L429 469L428 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M452 468L453 469L452 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M453 468L453 469L456 469L453 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M456 468L456 469L468 470L456 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M467 468L468 469L467 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M468 468L469 469L468 468M470 468L471 469L470 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M500 468L501 469L500 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M501 468L501 469L506 469L501 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M506 468L507 469L506 468M524 468L524 469L528 469L524 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M528 468L528 469L532 469L528 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M532 468L533 469L532 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M533 468L533 469L537 469L533 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M537 468L538 469L537 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M543.333 468.667L543.667 469.333L543.333 468.667M549 468L549 469L554 472L554 469L553 468L549 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M563 468L564 469L563 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M564.667 468.333L565.333 468.667L564.667 468.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M566 468.468C547.004 472.057 538.962 496.013 550.532 510.996C557.522 520.047 569.095 522.588 580 520.671C596.549 517.763 605.413 496.399 597.583 482C591.324 470.491 578.379 466.128 566 468.468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M580 468L581 469L580 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M581 468L582 469L581 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M582 468L583 469L582 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M676 468L677 469L676 468M692 468L693 469L692 468M721 468L722 469L721 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M722 468L723 469L722 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M752 515L747 505C736.118 508.953 723.12 514.051 718 499L754 499C754.997 491.11 755.174 483.789 750.211 477.015C740.724 464.069 719.453 465.323 709.681 477.09C698.28 490.819 703.812 513.942 721 519.891C731.759 523.615 742.533 519.98 752 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M737 468L738 469L737 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M738 468L739 469L738 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M739 468L740 469L739 468M779 468L780 469L779 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M780.667 468.333L781.333 468.667L780.667 468.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M804 516L804 539L817 539L817 469L805 469L805 475C775.703 447.666 743.853 503.385 777 519.08C780.823 520.891 784.848 521.04 789 520.996C794.944 520.933 798.984 518.989 804 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M794.667 468.333L795.333 468.667L794.667 468.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M796 468L797 469L796 468M805 468L805 469L818 469L805 468M831 468L831 469L845 469L831 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M845 468L846 469L845 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M864 501L865 501L865 469L879 469C858.426 460.367 864 489.065 864 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M907 468L908 469L907 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M908.667 468.333L909.333 468.667L908.667 468.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M933 505C922.242 508.849 909.058 513.837 904 499L940 499C940.882 494.25 941.357 489.743 940.073 485C929.433 445.724 867.74 481.916 896.329 512.826C902.925 519.958 913.557 523.054 923 521.192C933.932 519.036 939.944 515.347 933 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M923.667 468.333L924.333 468.667L923.667 468.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M925 468L926 469L925 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M960 468L961 469L960 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M961.667 468.333L962.333 468.667L961.667 468.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M953 504C940.624 522.439 975.854 526.575 985.581 514.895C993.933 504.866 985.789 494.178 976 490.015C973.14 488.798 965.207 486.921 965.207 482.873C965.207 475.017 978.053 482.459 980.985 482.006C984.102 481.525 986.156 478.236 988 476C979.461 464.508 951.852 463.777 951.047 482C950.304 498.83 967.971 493.915 974.029 504.375C977.886 511.034 964.744 509.637 962 508.316C958.86 506.805 956.406 504.883 953 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M977 468L978 469L977 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M978 468L979 469L978 468M994 468L995 469L994 468M1024 468L1024 469L1031 469L1024 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M336 469L337 470L336 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M338 469L339 470L338 469M360 469L361 470L360 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M361 469L362 470L361 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M397 469L398 470L397 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M420 469L421 470L420 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M427 469L428 470L427 469M452 469L453 470L452 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M537 469L537 480L538 480L537 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M555 469L554 473L558 470L556 471L557 469L555 469M559 469L560 470L559 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M561 469L562 470L561 469M583 469L584 470L583 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M584 469L585 470L584 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M591 470L592 473L595 475L596 473L597 474L597 478L600 476L599 478L600 478L601 472L600 472L596 473L596 472L598 470L591 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M677 469L678 470L677 469M692 469L692 472L693 472L692 469M719 469L720 470L719 469M740 469L741 470L740 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M741 469L742 470L741 469M777 469L778 470L777 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M778 469L779 470L778 469M797 469L798 470L797 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M798 469L799 470L798 469M804 469L803 474L804 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M817 469L817 539L818 539L818 491L817 469M831 469L832 470L831 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M831 470C831.783 482.161 828.188 497.7 833.839 509C841.524 524.363 866.311 525.843 875.387 510.985C882.266 499.723 879 481.656 879 469L865 469C865 478.403 870.051 508.573 855 508.573C839.949 508.573 845 478.403 845 469L831 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M845 469L845 496L846 496L845 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M905 469L906 470L905 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M926 469L927 470L926 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M927 469L928 470L927 469M958 469L959 470L958 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M959 469L960 470L959 469M980 469L981 470L980 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1031 469L1031 481L1032 481L1031 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M334 470L335 471L334 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M336 470L337 471L336 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M363 470L364 471L363 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M380 470L381 474L382 474L380 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M381 470L382 471L381 470M396 470L397 471L396 470M420 470L421 471L420 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M428 470L429 471L428 470M467 470L468 471L467 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M469 470L470 471L469 470M499 470L496 480L496 481L505 484L505 485L508 481L499 481L499 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M559 470L560 471L559 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M586 470L587 471L586 470M677 470L678 471L677 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M717 470L718 471L717 470M742 470L743 471L742 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M743 470L744 471L743 470M775 470L776 471L775 470M903 470L904 471L903 470M929 470L930 471L929 470M956 470L957 471L956 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M957 470L958 471L957 470M982 470L983 471L982 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M334 471L335 472L334 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M364 471L365 472L364 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M365 471L366 472L365 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M366 471L368 473L366 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M381 471L382 472L381 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M428 471L429 472L428 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M451 471L452 472L451 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M467 471L467 473L469 471L467 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M557 471L558 472L557 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M587 471L588 472L587 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M588 471L589 472L588 471M677 471L678 472L677 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M715 471L716 472L715 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M744 471L745 472L744 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M745 471L746 472L745 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M774 471L775 472L774 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M801 471L802 472L801 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M831 471L832 472L831 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M901 471L902 472L901 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M902 471L903 472L902 471M930 471L931 472L930 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M931 471L932 472L931 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M955 471L956 472L955 471M984 471L985 472L984 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M994 471L995 472L994 471M333 472L334 473L333 472M366 472L367 473L366 472M382 472L383 473L382 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M397 472L398 473L397 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M418 472L419 473L418 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M419 472L420 473L419 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M429 472L430 473L429 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M430 472L431 473L430 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M451 472L452 473L451 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M466 472L467 473L466 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M544 472L548 478L550 474L550 473L544 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M556 472L557 473L556 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M589 472L590 473L589 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M712 472L713 473L712 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M714 472L715 473L714 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M746 472L747 473L746 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M772 472L773 473L772 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M802 472L803 473L802 472M900 472L901 473L900 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M932 472L933 473L932 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M954 472L955 473L954 472M985 472L986 473L985 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M331 473L332 474L331 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M367 473L368 474L367 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M382 473L383 474L382 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M397 473L398 474L397 473M429 473L430 474L429 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M449.333 473.667L449.667 474.333L449.333 473.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M450 473L451 474L450 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M546 473L546 476L547 476L546 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M551 473L552 474L551 473M553 473L548 476L549 479L546 478L546 483L547 483L553 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M590 473L591 474L590 473M678.333 473.667L678.667 474.333L678.333 473.667M713 473L714 474L713 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M747 473L748 474L747 473M771 473L772 474L771 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M899 473L900 474L899 473M933 473L934 474L933 473M953 473L954 474L953 473M986 473L987 474L986 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M329 474L330 475L329 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M330 474L331 475L330 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M368 474L369 475L368 474M383 474L384 475L383 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M398 474L399 475L398 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M417 474L418 475L417 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M418 474L419 475L418 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M430 474L431 475L430 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M450 474L451 475L450 474M465 474L466 475L465 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M466 474L467 475L466 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M553 474L554 475L553 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M591 474L594 477L591 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M592 474L593 475L592 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M598 474L597 476L598 474M706 474L707 475L706 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M711 474L712 475L711 474M748 474L749 475L748 474M770 474L771 475L770 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M804 474L805 475L804 474M898 474L899 475L898 474M934 474L935 475L934 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M952 474L953 475L952 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M987 474L988 475L987 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M329 475L330 476L329 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M371 475L372 476L371 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M383 475L384 476L383 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M398 475L399 476L398 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M399 475L400 476L399 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M430 475L431 476L430 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M552 475L553 476L552 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M593 475L594 476L593 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M710 475L711 476L710 475M749 475L750 476L749 475M769 475L770 476L769 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M935 475L936 476L935 475M952 475L953 476L952 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M988 475L989 476L988 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M327 476L326 478L327 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M328 476L329 477L328 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M370 476L371 477L370 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M416.333 476.667L416.667 477.333L416.333 476.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M417 476L418 477L417 476M431 476L432 477L431 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M448.333 476.667L448.667 477.333L448.333 476.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M449 476L450 477L449 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M464 476L465 477L464 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M465 476L466 477L465 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M551 476L552 477L551 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M677 476L678 477L677 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M692.333 476.667L692.667 477.333L692.333 476.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M709 476L710 477L709 476M750 476L751 477L750 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M896 476L897 477L896 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M936 476L937 477L936 476M951 476L952 477L951 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M987 476L988 477L987 476M266 477L267 478L266 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M327 477L328 478L327 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M371 477L373 479L371 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M372 477L373 478L372 477M383 477L384 478L383 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M384 477L385 478L384 477M399 477L400 478L399 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M400 477L401 478L400 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M417 477L418 478L417 477M431 477L432 478L431 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M432 477L433 478L432 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M449 477L450 478L449 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M466 477L467 478L466 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M550 477L551 478L550 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M594 477L595 478L594 477M677 477L678 478L677 477M709 477L710 478L709 477M750 477L751 478L750 477M895 477L896 478L895 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M937 477L938 478L937 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M951 477L952 478L951 477M986 477L987 478L986 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M373 478L375 480L373 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M416 478L417 479L416 478M432 478L433 479L432 478M448 478L449 479L448 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M463 478L464 479L463 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M464 478L457 495L458 495L464 478M467 478L468 479L467 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M550 478L551 479L550 478M595 478L596 479L595 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M676 478L677 479L676 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M692.333 478.667L692.667 479.333L692.333 478.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M705 478L706 479L705 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M708 478L709 479L708 478M751 478L752 479L751 478M767 478L768 479L767 478M894 478L895 479L894 478M937 478L938 479L937 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M950.333 478.667L950.667 479.333L950.333 478.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M326 479L327 480L326 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M373 479L374 480L373 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M384 479L385 480L384 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M385 479L386 480L385 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M400 479L401 480L400 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M416 479L417 480L416 479M432 479L433 480L432 479M448 479L449 480L448 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M463 479L464 480L463 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M549 479L550 480L549 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M596 479L597 480L596 479M676 479L677 480L676 479M707 479L708 480L707 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M726 479L727 480L726 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M727 479L728 480L727 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M728 479L728 480L732 480L728 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M732 479L733 480L732 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M733 479L734 480L733 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M766 479L767 480L766 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M893 479L894 480L893 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M912 479L913 480L912 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M913 479L914 480L913 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M914 479L915 480L914 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M904 489L923 489L926 486C920.191 475.414 908.201 479.478 904 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M917 479L918 480L917 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M918 479L919 480L918 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M919 479L920 480L919 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M938 479L939 480L938 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M966.667 479.333L967.333 479.667L966.667 479.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M968 479L968 480L972 480L968 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M972.667 479.333L973.333 479.667L972.667 479.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M325 480L326 481L325 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M347 480L347 481L352 481L347 480M400 480L401 481L400 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M401 480L402 483L403 483L401 480M414.333 480.667L414.667 481.333L414.333 480.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M415 480L416 481L415 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M434.333 480.667L434.667 481.333L434.333 480.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M462 480L463 481L462 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M499 480L500 481L499 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M500 480L500 481L508 481L500 480M523 480L523 481L537 481L523 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M537 480L538 481L537 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M542 480L543 481L542 480M545 480L546 481L545 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M548 480L549 481L548 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M570 480L570 481L575 481L570 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M658 480L659 481L658 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M675 480L676 481L675 480M724 480L725 481L724 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M718 489L741 489L738 485L739 483C730.47 477.817 722.117 479.668 718 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M735 480L736 481L735 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M752 480L753 481L752 480M766 480L767 481L766 480M787 480L787 481L791 481L787 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M791 480L792 481L791 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M792.667 480.333L793.333 480.667L792.667 480.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M879 480L879 499L880 499L879 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M893 480L894 481L893 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M910 480L911 481L910 480M921 480L922 481L921 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M922 480L923 481L922 480M938 480L939 481L938 480M950 480L950 486L951 486L950 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M965 480L966 481L965 480M974 480L975 481L974 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M975 480L976 481L975 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M984 480L985 481L984 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M994 480L994 481L1002 481L994 480M1017 480L1017 481L1031 481L1017 480M344 481L345 482L344 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M345 481L346 482L345 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M346 483L343 482C334.763 495.598 336.561 506.626 354 508L353 506L354 506C358.917 505.872 361.882 501.753 361 497L362 489L360 485C355.388 482.694 346.993 478.034 346 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M347 481L348 482L347 481M349.667 481.333L350.333 481.667L349.667 481.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M354 481L355 482L354 481M374 481L375 482L374 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M375 481L376 482L375 481M385.333 481.667L385.667 482.333L385.333 481.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M386 481L387 482L386 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M401 481L402 482L401 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M415 481L416 482L415 481M433 481L434 482L433 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M446 481L447 482L446 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M447 481L448 482L447 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M462 481L463 482L462 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M508 481L508 507L509 507L508 481M522 481L522 504L523 504L522 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M539 481L537 482L537 483L539 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M567 481L568 482L567 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M568 481L569 482L568 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M569 481L570 482L569 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M562 491L564 485L566 487L576 482C569.708 479.435 561.329 483.871 562 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M566 487L564 485L565 488L563 491L560 490L560 499L562 501L564 504L566 503L566 507L567 507C567 504.182 569.644 505.973 568 507L568 508L577 508L578 505L581 506L585 501C583.667 495.401 585.882 484.189 578 484L577 481L566 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M577 481L578 482L577 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M578 481L579 482L578 481M597 481L598 482L597 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M674 481L675 482L674 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M691 481L692 482L691 481M706 481L707 482L706 481M722 481L723 482L722 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M736 481L737 482L736 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M737 481L738 482L737 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M765 481L766 482L765 481M785 481L786 482L785 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M786.001 481.742C770.405 487.733 779.344 513.808 795.985 507.258C810.292 501.625 801.981 475.604 786.001 481.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M795 481L796 482L795 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M796 481L797 482L796 481M892 481L893 482L892 481M908 481L909 482L908 481M923 481L924 482L923 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M939 481L940 482L939 481M964 481L964 484L965 484L964 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M977 481L978 482L977 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M983 481L984 482L983 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M998 481L999 482L998 481M1000 481L1001 482L1000 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1002 481L1002 506L1003 506L1002 481M1016 481L1016 503L1017 503L1016 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M323 482L324 483L323 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M324 482L325 483L324 482M342 482L341 484L342 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M344.667 482.333L345.333 482.667L344.667 482.333M354 482L354 483L357 484L354 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M356 482L357 483L356 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M386 482L388 485L386 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M401 482L402 483L401 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M542.667 482.333L543.333 482.667L542.667 482.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M547 482L548 483L547 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M565 482L566 483L565 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M566 482L567 483L566 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M577 482L580 484L577 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M579 482L580 483L579 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M598 482L599 483L598 482M656 482L657 483L656 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M672 482L673 483L672 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M673 482L674 483L673 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M691 482L692 483L691 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M721 482L722 483L721 482M738 482L739 483L738 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M753 482L754 483L753 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M765 482L766 483L765 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M783 482L784 483L783 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M797 482L798 483L797 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M907 482L908 483L907 482M924 482L925 483L924 482M939 482L940 483L939 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M978 482L979 483L978 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M979 482L980 483L979 482M982 482L983 483L982 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M1001 482L1001 485L1002 485L1001 482M342 483L343 484L342 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M357 483L358 484L357 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M375 483L376 484L375 483M387 483L388 484L387 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M413 483L412 486L413 486L413 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M414 483L415 484L414 483M434 483L435 484L434 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M435 483L436 484L435 483M445.333 483.667L445.667 484.333L445.333 483.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M446 483L447 484L446 483M461 483L462 484L461 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M545 483L543 484L544 488L535 490L535 491L543 492L541 495L544 497L545 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M564 483L565 484L564 483M598 483L599 484L598 483M656 483L656 484L671 484L656 483M690 483L691 484L690 483M705 483L706 484L705 483M720 483L721 484L720 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M764 483L765 484L764 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M782 483L783 484L782 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M799 483L800 484L799 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M891 483L892 484L891 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M906 483L907 484L906 483M925 483L926 484L925 483M980.667 483.333L981.333 483.667L980.667 483.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M323 484L324 485L323 484M340 484L341 485L340 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M341 484L342 485L341 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M402 484L403 485L402 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M413 484L414 485L413 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M446 484L447 485L446 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M461 484L462 485L461 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M499 484L500 485L499 484M502 484L503 485L502 484M541 484L542 485L541 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M546 484L547 485L546 484M563 484L564 485L563 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M567 484L568 485L567 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M580 484L582 486L580 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M599 484L600 485L599 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M690 484L691 485L690 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M738.667 484.333L739.333 484.667L738.667 484.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M764 484L765 485L764 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M781 484L782 485L781 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M800 484L801 485L800 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M925 484L926 485L925 484M940 484L941 485L940 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M964 484L965 485L964 484M323 485L324 486L323 485M339 485L338 487L339 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M340 485L341 486L340 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M376 485L377 486L376 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M377 485L378 486L377 485M387.333 485.667L387.667 486.333L387.333 485.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M388 485L389 486L388 485M402 485L403 486L402 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M403 485L404 486L403 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M413 485L414 486L413 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M435 485L436 486L435 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M436 485L437 486L436 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M445 485L446 486L445 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M460 485L461 486L460 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M537.667 485.333L538.333 485.667L537.667 485.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M546 485L547 486L546 485M562 485L563 486L562 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M599 485L600 486L599 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M689 485L690 486L689 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M704 485L705 486L704 485M719 485L720 486L719 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M740 485L741 486L740 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M754 485L755 486L754 485M780 485L781 486L780 485M890 485L891 486L890 485M905 485L906 486L905 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M924 485L923 489L926 489L924 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M926 485L927 486L926 485M940.333 485.667L940.667 486.333L940.333 485.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M966 485L967 486L966 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M321 486L322 487L321 486M339 486L338 490L339 490L339 486M359 486L360 490L361 490L359 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M360 486L361 487L360 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M376 486L377 487L376 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M388 486L389 487L388 486M403 486L404 487L403 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M445 486L446 487L445 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M460 486L461 487L460 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M500 486L501 487L500 486M507 486C500.977 499.742 509.026 513.622 518 523L534 525L534 524L531 524L531 523L540 522L540 521C527.861 523.254 511.938 522.745 508.529 508C506.893 500.921 509.813 492.705 507 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M545 486L546 487L545 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M561 486L562 487L561 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M582 486L584 488L582 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M583 486L584 487L583 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M599 486L600 487L599 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M689 486L690 487L689 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M704 486L705 487L704 486M718 486L719 487L718 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M740 486L741 487L740 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M754.333 486.667L754.667 487.333L754.333 486.667M779 486L780 487L779 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M801 486L802 487L801 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M890.333 486.667L890.667 487.333L890.333 486.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M926 486L926 489L927 489L926 486M950.333 486.667L950.667 487.333L950.333 486.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M967 486L968 487L967 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M968 486L969 487L968 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M1001 486L1001 509L1002 509L1001 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M322 487L323 488L322 487M338 487L339 488L338 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M361 487L362 488L361 487M403 487L404 488L403 487M412 487L413 488L412 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M436 487L437 488L436 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M437 487L438 488L437 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M459 487L460 488L459 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M539 487L540 488L539 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M545 487L546 488L545 487M561 487L562 488L561 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M584 487L585 488L584 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M688 487L689 488L688 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M695 487L696 488L695 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M718 487L719 488L718 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M740 487L741 488L740 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M763 487L764 488L763 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M802 487L803 488L802 487M904 487L905 488L904 487M969.667 487.333L970.333 487.667L969.667 487.333M322.333 488.667L322.667 489.333L322.333 488.667M337 488L338 489L337 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M361 488L362 489L361 488M377.333 488.667L377.667 489.333L377.333 488.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M378 488L378 493L379 493L378 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M389 488L390 489L389 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M405 488L408 496L411 488L410 488L409 493L407 493L405 488M443 488L444 489L443 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M444 488L445 489L444 488M459 488L460 489L459 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M545.333 488.667L545.667 489.333L545.333 488.667M560 488L561 489L560 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M584 488L585 489L584 488M600.333 488.667L600.667 489.333L600.333 488.667M687 488L688 489L687 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M703 488L704 489L703 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M763.333 488.667L763.667 489.333L763.333 488.667M778 488L779 489L778 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M802 488L803 489L802 488M941 488L941 496L942 496L941 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M951 488L952 489L951 488M972 488L973 489L972 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M973 488L974 489L973 488M337 489L338 490L337 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M388 489L390 493L391 493L388 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M389 489L390 490L389 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M404 489L405 490L404 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M411 489L412 490L411 489M437 489L438 490L437 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M444 489L445 490L444 489M458 489L459 490L458 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M560 489L561 490L560 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M584 489L584 500L585 500L584 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M585.333 489.667L585.667 490.333L585.333 489.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M686 489L687 490L686 489M703.333 489.667L703.667 490.333L703.333 489.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M718 489L718 490L741 490L718 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M778 489L779 490L778 489M889.333 489.667L889.667 490.333L889.333 489.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M905 489L905 490L924 490L905 489M926 489L927 490L926 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M951 489L952 490L951 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M974 489L975 490L974 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M975 489L976 490L975 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M267 490L268 491L267 490M271 490L272 491L271 490M273 490L273 491L296 491L273 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M361.333 490.667L361.667 491.333L361.333 490.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M362 490L363 491L362 490M377 490L377 500L378 500L377 490M390 490L391 491L390 490M411 490L412 491L411 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M442.333 490.667L442.667 491.333L442.333 490.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M443 490L444 491L443 490M458 490L459 491L458 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M544 490L544 493L545 493L544 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M600 490L600 500L601 500L600 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M685 490L686 491L685 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M803.333 490.667L803.667 491.333L803.333 490.667M952 490L953 491L952 490M977 490L978 491L977 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M266 491L266 520L267 520L266 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M296 491L296 521L311 521L311 515L310 515L310 520L297 520L296 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M362.333 491.667L362.667 492.333L362.333 491.667M390 491L391 492L390 491M405 491L406 492L405 491M410 491L411 492L410 491M438 491L439 492L438 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M439 491L440 492L439 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M443 491L444 492L443 491M457 491L458 492L457 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M460 491L461 492L460 491M560 491L560 496L561 496L560 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M585 491L586 492L585 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M684 491L685 492L684 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M703 491L703 499L704 499L703 491M777 491L777 498L778 498L777 491M889 491L889 498L890 498L889 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M952 491L953 492L952 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M979 491L980 492L979 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M321 492L321 497L322 497L321 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M336 492L336 498L337 498L336 492M391 492L392 493L391 492M405 492L406 493L405 492M410 492L411 493L410 492M424 492L423 494L424 492M438 492L439 493L438 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M457 492L458 493L457 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M559 492L559 498L560 498L559 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M585 492L585 497L586 497L585 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M682 492L683 493L682 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M803 492L803 497L804 497L803 492M953 492L954 493L953 492M981 492L982 493L981 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M337.333 493.667L337.667 494.333L337.333 493.667M361.333 493.667L361.667 494.333L361.333 493.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M391 493L392 494L391 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M406 493L407 494L406 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M409 493L410 494L409 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M424 493L423 496L426 496L424 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M439 493L440 494L439 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M440 493L440 495L442 493L440 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M442 493L443 494L442 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M544.333 493.667L544.667 494.333L544.333 493.667M681 493L682 494L681 493M954 493L955 494L954 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M982 493L983 494L982 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M378 494L378 499L379 499L378 494M391 494L390 495L392 498L393 498L391 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M392 494L393 495L392 494M406 494L407 495L406 494M409 494L410 495L409 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M423 494L424 495L423 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M425 494L426 495L425 494M439 494L440 495L439 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M441 494L442 495L441 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M456 494L457 495L456 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M681 494L682 495L681 494M956 494L957 495L956 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M984 494L985 495L984 494M392 495L393 496L392 495M408 495L407 497L408 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M422 495L423 496L422 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M440.667 495.333L441.333 495.667L440.667 495.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M527 495L528 496L527 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M682 495L683 496L682 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M754 495L754 498L755 498L754 495M957 495L958 496L957 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M985 495L986 496L985 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M408 496L409 497L408 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M422 496L423 497L422 496M426 496L427 497L426 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M440.667 496.333L441.333 496.667L440.667 496.333M455 496L456 497L455 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M525 496L526 497L525 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M562 496L563 497L562 496M576 496L577 499L578 499L576 496M603 496L604 497L603 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M656 496L656 511L657 511L656 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M657 496L658 497L657 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M658 496L658 497L662 497L658 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M662 496L662 497L666 497L662 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M666 496L667 497L666 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M845 496L846 497L845 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M940 496C935.581 502.817 911.782 499 904 499L904 500L932 500C935.231 499.993 941.029 500.582 940 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M958 496L959 497L958 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M959 496L960 497L959 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M986 496L987 497L986 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M361 497L362 498L361 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M362 497L363 498L362 497M393 497L394 498L393 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M407 497L408 498L407 497M421 497L422 498L421 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M422 497L420 502L421 502L422 497M566 497L567 498L566 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M585.333 497.667L585.667 498.333L585.333 497.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M667 497L668 498L667 497M683 497L684 498L683 497M803.333 497.667L803.667 498.333L803.333 497.667M831 497L831 503L832 503L831 497M845 497L845 502L846 502L845 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M960 497L961 498L960 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M961 497L962 498L961 497M362.333 498.667L362.667 499.333L362.333 498.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M421 498L422 499L421 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M426 498L427 499L426 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M427 498L428 499L427 498M454 498L455 499L454 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M455 498L456 499L455 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M524.333 498.667L524.667 499.333L524.333 498.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M561 498L566 505L566 504L566 503L564 504L564 503L562 501L561 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M684 498L685 499L684 498M754 498L755 499L754 498M889.333 498.667L889.667 499.333L889.333 498.667M962 498L963 499L962 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M963 498L964 499L963 498M987 498L988 499L987 498M322.333 499.667L322.667 500.333L322.333 499.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M337 499L338 500L337 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M338.333 499.667L338.667 500.333L338.333 499.667M393 499L395 502L393 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M394 499L395 500L394 499M420 499L421 500L420 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M454 499L455 500L454 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M544 499L544 504L541 507L543 505L544 505L547 508L544 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M545.333 499.667L545.667 500.333L545.333 499.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M560 499L561 500L560 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M564 499L567 503L564 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M585 499L586 500L585 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M668 499L669 500L668 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M685 499L686 500L685 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M703 499L704 500L703 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M718 499L718 500L754 500C744.44 495.989 728.387 499 718 499M763.333 499.667L763.667 500.333L763.333 499.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M778 499L779 500L778 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M940 499L941 500L940 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M965.667 499.333L966.333 499.667L965.667 499.333M337 500L338 501L337 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M377 500L378 501L377 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M394 500L395 501L394 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M420 500L421 501L420 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M427 500L428 501L427 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M428 500L429 501L428 500M453 500L454 501L453 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M454.333 500.667L454.667 501.333L454.333 500.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M560 500L561 501L560 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M583 500L581 505L582 505L583 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M600 500L601 501L600 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M669 500L670 501L669 500M685 500L686 501L685 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M703 500L704 501L703 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M778 500L779 501L778 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M802 500L803 501L802 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M889 500L890 501L889 500M904 500L905 501L904 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M905 500L912 508L916 501L905 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M967 500L968 501L967 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M968 500L969 501L968 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M988 500L989 501L988 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M989 500L990 501L989 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M322.333 501.667L322.667 502.333L322.333 501.667M338 501L339 502L338 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M360 501L361 502L360 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M361 501L362 502L361 501M395 501L396 502L395 501M419 501L420 502L419 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M453 501L454 502L453 501M545 501L546 502L545 501M561 501L562 502L561 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M584 501L585 502L584 501M686 501L687 502L686 501M718 501L719 502L718 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M763 501L764 502L763 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M802 501L803 502L802 501M864 501L865 502L864 501M904 501L905 502L904 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M969 501L970 502L969 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M970 501L971 502L970 501M988 501L989 502L988 501M338 502L339 503L338 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M360 502L361 503L360 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M376 502L377 503L376 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M419 502L420 503L419 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M428 502L429 503L428 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M429 502L430 503L429 502M452 502L453 503L452 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M527 502L528 503L527 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M545 502L546 503L545 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M561 502L562 503L561 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M583 502L584 503L583 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M599.333 502.667L599.667 503.333L599.333 502.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M670 502L671 503L670 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M687 502L688 503L687 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M704 502L705 503L704 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M763 502L764 503L763 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M779 502L780 503L779 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M801 502L802 503L801 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M878.333 502.667L878.667 503.333L878.333 502.667M890 502L891 503L890 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M905 502L906 503L905 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M972 502L973 503L972 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M339 503L340 504L339 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M360 503L361 504L360 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M376 503L377 504L376 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M377 503L378 504L377 503M395 503L396 504L395 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M396 503L397 504L396 503M418 503L419 504L418 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M419 503L420 504L419 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M452 503L453 504L452 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M453 503L454 504L453 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M546 503L547 504L546 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M562 503L563 504L562 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M583 503L584 504L583 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M600 503L601 504L600 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M671 503L672 504L671 503M704 503L705 504L704 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M719 503L720 504L719 503M801 503L802 504L801 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M831 503L832 504L831 503M846 503L847 504L846 503M863 503L864 504L863 503M890 503L891 504L890 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M905 503L906 504L905 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M953 503L954 504L953 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M954 503L955 504L954 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M955 503L956 504L955 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M972 503L973 504L972 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M974 503L975 504L974 503M323 504L324 505L323 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M340 504L341 505L340 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M358 504L359 505L358 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M359 504L360 505L359 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M396 504L397 505L396 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M429 504L430 505L429 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M430 504L431 505L430 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M523 504L524 505L523 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M527.667 504.333L528.333 504.667L527.667 504.333M537 504L538 505L537 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M546 504L547 505L546 504M563 504L564 505L563 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M582 504L583 505L582 504M672 504L673 505L672 504M688 504L689 505L688 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M720 504L721 505L720 504M746 504L747 505L746 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M764 504L765 505L764 504M800 504L801 505L800 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M878 504L879 505L878 504M906 504L907 505L906 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M932 504L934 506L932 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M933 504L934 505L933 504M956 504L957 505L956 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M1017 504L1018 505L1017 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M341 505L342 506L341 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M342 505L343 506L342 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M358 505L359 506L358 505M375 505L376 506L375 505M397 505L398 506L397 505M417 505L418 506L417 505M451 505L452 506L451 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M452 505L453 506L452 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M523 505L524 506L523 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M546 505L547 506L546 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M564 505L565 506L564 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M566 505L566 506L570 507L566 505M577 507L580 505L577 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M581 505L582 506L581 505M598 505L599 506L598 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M599.333 505.667L599.667 506.333L599.333 505.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M689 505L690 506L689 505M705 505L706 506L705 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M721 505L722 506L721 505M744 505L745 506L744 505M747 505L748 506L747 505M764 505L765 506L764 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M799 505L800 506L799 505M847 505L848 506L847 505M862 505L863 506L862 505M891 505L892 506L891 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M907 505L908 506L907 505M930 505L931 506L930 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M952 505L953 506L952 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M957 505L958 506L957 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M975.333 505.667L975.667 506.333L975.333 505.667M1017 505L1018 506L1017 505M324 506L325 507L324 506M342 506L343 507L342 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M353.667 506.333L354.333 506.667L353.667 506.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M356 506L357 507L356 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M396 506L397 507L396 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M397 506L398 507L397 506M417 506L418 507L417 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M418 506L419 507L418 506M430 506L431 507L430 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M431 506L432 507L431 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M524 506L525 507L524 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M543 506L544 507L543 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M547 506L548 507L547 506M565 506L566 507L565 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M579 506L580 507L579 506M673 506L674 507L673 506M690 506L691 507L690 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M705 506L706 507L705 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M722 506L723 507L722 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M742 506L743 507L742 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M743 506L744 507L743 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M783 506L784 507L783 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M798 506L799 507L798 506M832 506L833 507L832 506M848 506L849 507L848 506M861 506L862 507L861 506M877 506L878 507L877 506M908 506L909 507L908 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M928 506L929 507L928 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M929 506L930 507L929 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M934 506L935 507L934 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M951 506L952 507L951 506M958 506L959 507L958 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1002.33 506.667L1002.67 507.333L1002.33 506.667M1018 506L1019 507L1018 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M344 507L345 508L344 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M345 507L346 508L345 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M348 507L349 508L348 507M351.667 507.333L352.333 507.667L351.667 507.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M354 507L355 508L354 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M355 507L356 508L355 507M374 507L375 508L374 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M375 507L376 508L375 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M416 507L417 508L416 507M450 507L451 508L450 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M451 507L452 508L451 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M508.333 507.667L508.667 508.333L508.333 507.667M525 507L526 508L525 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M567 507L568 508L567 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M570 507L570 508L576 508L570 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M577 507L578 508L577 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M578 507L579 508L578 507M597 507L598 508L597 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M598 507L599 508L598 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M674 507L675 508L674 507M706 507L707 508L706 507M723 507L724 508L723 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M724 507L725 508L724 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M741 507L742 508L741 507M748 507L749 508L748 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M765 507L766 508L765 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M784 507L785 508L784 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M785 507L786 508L785 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M796 507L797 508L796 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M832 507L833 508L832 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M850 507L851 508L850 507M859 507L860 508L859 507M877 507L878 508L877 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M892 507L893 508L892 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M910 507L911 508L910 507M926 507L927 508L926 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M927 507L928 508L927 507M934 507L935 508L934 507M950 507L951 508L950 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M960 507L961 508L960 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1019 507L1020 508L1019 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M324 508L325 509L324 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M325 508L326 509L325 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M347 508L347 509L353 509L347 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M397 508L398 509L397 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M398 508L399 509L398 508M416 508L417 509L416 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M417 508L418 509L417 508M431 508L432 509L431 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M432 508L433 509L432 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M452 508L453 509L452 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M527 508L528 509L527 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M528 508L528 509L531 509L528 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M531 508L532 509L531 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M532 508L532 509L539 509L532 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M547 508L546 510L547 514L548 514L547 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M548 508L549 509L548 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M570.667 508.333L571.333 508.667L570.667 508.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M572 508L573 509L572 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M573 508L573 509L576 509L573 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M599.333 508.667L599.667 509.333L599.333 508.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M675 508L676 509L675 508M691 508L692 509L691 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M706 508L707 509L706 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M725 508L726 509L725 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M726 508L727 509L726 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M737 508L738 509L737 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M738 508L739 509L738 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M739 508L740 509L739 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M749 508L750 509L749 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M787 508L788 509L787 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M788.667 508.333L789.333 508.667L788.667 508.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M790 508L791 509L790 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M791 508L791 509L794 509L791 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M794 508L795 509L794 508M833 508L834 509L833 508M852 508L853 509L852 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M853 508L853 509L857 509L853 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M857 508L858 509L857 508M911 508L912 509L911 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M912.667 508.333L913.333 508.667L912.667 508.333M922.667 508.333L923.333 508.667L922.667 508.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M924 508L925 509L924 508M935 508L936 509L935 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M949 508L950 509L949 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M961 508L962 509L961 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M962 508L963 509L962 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M974 508L975 509L974 508M1021 508L1022 509L1021 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1022.67 508.333L1023.33 508.667L1022.67 508.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M1024 508L1025 509L1024 508M1028.67 508.333L1029.33 508.667L1028.67 508.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1030 508L1030 509L1033 509L1030 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M326 509L327 510L326 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M373 509L374 510L373 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M374 509L375 510L374 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M415 509L416 510L415 509M449 509L450 510L449 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M450 509L449 512L450 509M545 509L544 512L545 512L545 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M549 509L550 510L549 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M596 509L597 510L596 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M597 509L598 510L597 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M675 509L676 510L675 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M692 509L693 510L692 509M707 509L708 510L707 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M728 509L728 510L736 510L728 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M766 509L767 510L766 509M833 509L834 510L833 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M876 509L877 510L876 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M893 509L894 510L893 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M915 509L915 510L922 510L915 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M936 509L937 512L938 512L936 509M948 509L949 510L948 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M964.667 509.333L965.333 509.667L964.667 509.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M966.667 509.333L967.333 509.667L966.667 509.333M970.667 509.333L971.333 509.667L970.667 509.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M972 509L973 510L972 509M988 509L989 510L988 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M989.333 509.667L989.667 510.333L989.333 509.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1003.33 509.667L1003.67 510.333L1003.33 509.667M372 510L373 511L372 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M373 510L374 511L373 510M398 510L399 511L398 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M399 510L400 511L399 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M415 510L416 511L415 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M432 510L433 511L432 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M433 510L434 511L433 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M449 510L450 511L449 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M509 510L510 511L509 510M595 510L596 511L595 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M676 510L677 511L676 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M693 510L694 511L693 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M708 510L709 511L708 510M750 510L751 511L750 510M767 510L768 511L767 510M834 510L835 511L834 510M894 510L895 511L894 510M936 510L937 511L936 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M947 510L948 511L947 510M988 510L989 511L988 510M327 511L328 512L327 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M371 511L372 512L371 511M414 511L415 512L414 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M415 511L414 515L415 515L415 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M448 511L449 512L448 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M505 511L506 512L505 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M509 511L510 512L509 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M540 511C540 515.192 539.175 519.52 543 522L542 519L544 520L543 511L540 511M549 511L554 516L553 519L555 520L558 519L558 518L549 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M550 511L551 512L550 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M594 511L595 512L594 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M656 511L656 520L657 520L656 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M677 511L678 512L677 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M751 511L752 512L751 511M834 511L835 512L834 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M875 511L876 512L875 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M947.333 511.667L947.667 512.333L947.333 511.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M1003 511L1004 512L1003 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M328 512L331 515L328 512M370 512L371 513L370 512M400 512L401 513L400 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M414 512L415 513L414 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M434 512L435 513L434 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M448 512L449 513L448 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M510 512L511 513L510 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M551 512L552 513L551 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M593 512L594 513L593 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M591 517L595 517L594 520L595 520L596 518L597 520L598 519L595 517L597 512L591 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M678 512L679 513L678 512M694 512L695 513L694 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M709 512L710 513L709 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M751 512L752 513L751 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M768 512L769 513L768 512M835 512L836 513L835 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M874 512L875 513L874 512M987 512L988 513L987 512M1004 512L1005 513L1004 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M328 513L329 514L328 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M369 513L370 514L369 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M400 513L401 514L400 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M413 513L414 514L413 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M433 513L435 515L433 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M434 513L435 514L434 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M447 513L448 514L447 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M510 513L511 514L510 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M552 513L553 514L552 513M592 513L593 514L592 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M595 513L592 517L595 513M678 513L679 514L678 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M695 513L696 514L695 513M710 513L711 514L710 513M752.333 513.667L752.667 514.333L752.333 513.667M769 513L770 514L769 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M836 513L837 514L836 513M873 513L874 514L873 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M896 513L897 514L896 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M938.333 513.667L938.667 514.333L938.333 513.667M948 513L949 514L948 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M329 514L330 515L329 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M368 514L366 517L368 514M401 514L402 515L401 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M413 514L414 515L413 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M435 514L436 515L435 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M447 514L448 515L447 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M448 514L449 515L448 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M511 514L515 518L511 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M545 514L545 520C547.104 517.685 547.59 516.064 545 514M548 514L549 519L552 516L548 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M553 514L554 515L553 514M679 514L680 515L679 514M711 514L712 515L711 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M770 514L771 515L770 514M837 514L838 515L837 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M897 514L898 515L897 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M949 514L950 515L949 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M986 514L987 515L986 514M1005 514L1006 515L1005 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M330 515L331 516L330 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M331 515L332 516L331 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M368 515L369 516L368 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M369 515L370 516L369 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M401 515L402 516L401 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M412 515L413 516L412 515M446 515L447 516L446 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M505 515L506 516L505 515M508 515L509 516L508 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M511 515L512 516L511 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M554 515L555 516L554 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M590 515L591 516L590 515M680 515L681 516L680 515M696 515L697 516L696 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M712 515L713 516L712 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M713 515L714 516L713 515M750 515L751 516L750 515M771 515L772 516L771 515M838 515L839 516L838 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M872 515L873 516L872 515M898 515L899 516L898 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M899 515L900 516L899 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M937 515L938 516L937 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M950 515L951 516L950 515M985 515L984 517L985 515M1006 515L1007 516L1006 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M332 516L333 517L332 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M367.667 516.333L368.333 516.667L367.667 516.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M402 516L403 517L402 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M412 516L413 517L412 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M435 516L436 517L435 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M436 516L437 517L436 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M446 516L447 517L446 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M447 516L439 523L437 518L436 518C438.076 523.893 441.612 523.495 447 522L449 517L447 516M509 516L510 517L509 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M512 516L513 517L512 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M555 516L556 517L555 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M589 516L590 517L589 516M681 516L682 517L681 516M697 516L698 517L697 516M714 516L715 517L714 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M749 516L750 517L749 516M772 516L773 517L772 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M802 516L803 539L804 539C804 533.285 806.46 519.898 802 516M839 516L840 517L839 516M870 516L871 517L870 516M900 516L901 517L900 516M935 516L936 517L935 516M951 516L952 517L951 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M985 516L986 517L985 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1007 516L1008 517L1007 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M332 517L333 518L332 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M334 517L335 518L334 517M364 517L365 518L364 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M365 517L366 518L365 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M366 517L367 518L366 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M402 517L403 518L402 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M411 517L412 518L411 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M446 517L447 518L446 517M513 517L514 518L513 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M544 517L545 518L544 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M556 517L557 518L556 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M557 517L558 518L557 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M588 517L589 518L588 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M589.667 517.333L590.333 517.667L589.667 517.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M681 517L682 518L681 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M698 517L699 518L698 517M715 517L716 518L715 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M747 517L748 518L747 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M748 517L749 518L748 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M773 517L774 518L773 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M801 517L802 518L801 517M840 517L841 518L840 517M869 517L870 518L869 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M901 517L902 518L901 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M933 517L934 518L933 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M934 517L935 518L934 517M952 517L953 518L952 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M953 517L954 518L953 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M983 517L984 518L983 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M984 517L985 518L984 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1008 517L1009 518L1008 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M334 518L335 519L334 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M335 518L336 519L335 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M336 518L337 519L336 518M363 518L364 519L363 518M403 518L404 519L403 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M411 518L412 519L411 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M437 518L438 519L437 518M445 518L446 519L445 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M505 518L506 519L505 518M511 518L512 519L511 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M515 518L516 519L515 518M559 518L560 519L559 518M586 518L587 519L586 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M587.667 518.333L588.333 518.667L587.667 518.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M639 518L637 525L640 528L642 528L645 524L645 523L639 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M682 518L683 519L682 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M717 518L718 519L717 518M745 518L746 519L745 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M746 518L747 519L746 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M775 518L776 519L775 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M800 518L801 519L800 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M842 518L843 519L842 518M867 518L868 519L867 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M868 518L869 519L868 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M903 518L904 519L903 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M932 518L933 519L932 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M954 518L955 519L954 518M981 518L982 519L981 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M982 518L983 519L982 518M1009 518L1010 519L1009 518M337 519L338 520L337 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M338 519L339 520L338 519M361 519L362 520L361 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M403 519L404 520L403 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M410 519L411 520L410 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M437 519L438 520L437 519M445 519L446 520L445 519M516 519L517 520L516 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M517 519L518 520L517 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M552 519L553 520L552 519M558 519L558 520L560 523L581 525L587 519C576.217 522.641 568.807 521.949 558 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M560 519L561 520L560 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M561 519L562 520L561 519M584 519L585 520L584 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M585 519L586 520L585 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M589 519L590 520L589 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M683 519L684 520L683 519M699 519L684 520L684 521L699 519M719 519L720 520L719 519M743 519L744 520L743 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M744 519L745 520L744 519M776 519L777 520L776 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M777 519L778 520L777 519M798 519L799 520L798 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M843 519L844 520L843 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M844 519L845 520L844 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M866 519L867 520L866 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M905 519L906 520L905 519M929 519L930 520L929 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M930 519L931 520L930 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M956 519L957 520L956 519M979 519L980 520L979 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M980 519L981 520L980 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M1001 519L1002 520L1001 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1011 519L1012 520L1011 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M251 520L252 521L251 520M339 520L340 521L339 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M340 520L341 521L340 520M358 520L359 521L358 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M359 520L360 521L359 520M410 520L411 521L410 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M411 520L412 521L411 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M438 520L441 522L441 521L438 520M444 520L442 521L442 522L444 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M518 520L519 521L518 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M519 520L520 521L519 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M538 520L539 521L538 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M562 520L563 521L562 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M563.667 520.333L564.333 520.667L563.667 520.333M581 520L582 521L581 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M582 520L583 521L582 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M642 520L642 521L656 521L642 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M700 520L701 521L700 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M721 520L722 521L721 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M722 520L723 521L722 520M740 520L741 521L740 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M741 520L742 521L741 520M779 520L780 521L779 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M780 520L781 521L780 520M795.667 520.333L796.333 520.667L795.667 520.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M845 520L846 521L845 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M846 520L847 521L846 520M863 520L864 521L863 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M864 520L865 521L864 520M907 520L908 521L907 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M908 520L909 521L908 520M926.667 520.333L927.333 520.667L926.667 520.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M928 520L929 521L928 520M958 520L959 521L958 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M959 520L960 521L959 520M977 520L978 521L977 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M978 520L979 521L978 520M1013 520L1014 521L1013 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1014 520L1015 521L1014 520M1032 520L1033 521L1032 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M305 521L306 522L305 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M343 521L344 522L343 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M344 521L344 522L349 522L344 521M350 521L351 522L350 521M352 521L352 522L355 522L352 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M355.667 521.333L356.333 521.667L355.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M404.667 521.333L405.333 521.667L404.667 521.333M407 521L407 522L410 522L407 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M438 521L439 522L438 521M444 521L445 522L444 521M521 521L522 522L521 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M522 521L523 522L522 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M523 521L523 522L530 522L523 521M531 521L531 522L535 522L531 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M535.667 521.333L536.333 521.667L535.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M537 521L538 522L537 521M565 521L566 522L565 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M566 521L567 522L566 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M567 521L567 522L578 522L567 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M578.667 521.333L579.333 521.667L578.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M580 521L581 522L580 521M724 521L725 522L724 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M725 521L726 522L725 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M726 521L726 522L737 522L726 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M737 521L738 522L737 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M738 521L739 522L738 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M782.667 521.333L783.333 521.667L782.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M784 521L784 522L793 522L784 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M793 521L794 522L793 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M848 521L849 522L848 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M849 521L850 522L849 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M850 521L850 522L860 522L850 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M860 521L861 522L860 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M861 521L862 522L861 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M909.667 521.333L910.333 521.667L909.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M911 521L911 522L915 522L911 521M921 521L921 522L924 522L921 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M924.667 521.333L925.333 521.667L924.667 521.333M961.667 521.333L962.333 521.667L961.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M963 521L963 522L966 522L963 521M967.667 521.333L968.333 521.667L967.667 521.333M971 521L971 522L974 522L971 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M974.667 521.333L975.333 521.667L974.667 521.333M1016.67 521.333L1017.33 521.667L1016.67 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1018 521L1018 522L1029 522L1018 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1029 521L1030 522L1029 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M1030 521L1031 522L1030 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M352 522L352 523L355 523L352 522M404 522L405 523L404 522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M439.667 522.333L440.333 522.667L439.667 522.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M976 522L977 523L976 522M446 523L447 524L446 523M540 523L542 525L542 523L540 523M562 523L563 524L562 523M437 524L438 525L437 524M441 524L442 525L441 524M518.667 524.333L519.333 524.667L518.667 524.333M521 524L518 527L518 528L524 528L526 526L526 525L521 524M538 524L540 526L538 524M439 525L440 526L439 525M445 525L446 526L445 525M536 525L537 526L536 525M514 526L515 527L514 526M531 526L531 527L535 527L531 526M540 528L543 527L540 528M560 526L561 527L560 526M437 527L438 528L437 527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M803 539L804 540L803 539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M804 539L804 540L818 540L804 539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M624.667 543.333L625.333 543.667L624.667 543.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M449.333 562.667L449.667 563.333L449.333 562.667M452 562L452 565L453 565L452 562M440 563L441 564L440 563M443 565L443 566C449.325 566.205 458.052 571.496 454.022 578.981C451.934 582.858 447.463 583.702 445 587L455 583C458.4 597.485 445.369 588.665 438.603 594.028C436.043 596.057 436.666 602.004 435 605L437 623L436 623L436 609L435 609C435 618.624 437 627.424 437 637C437 639.963 435.562 645.288 438.139 647.361C441.933 650.413 457.246 647.233 454 645L454 644L455 633L455 601C460.03 600.357 456.18 595.81 453 595L453 647L438 647L438 594L454.271 593.282L461.886 588.92L465 594L461 592L464.826 627.001L465 647L466 647L467 593L480 597L492 593L492 592L488 592C485.537 582.851 473.366 580.006 465 580C463.069 583.596 460.977 584.061 457 584L456 567L443 565M947 565L948 566L947 565M440 566L441 567L440 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M443 566L444 567L443 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M444 566L444 567L447 567L444 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M447 566L448 567L447 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M448.667 566.333L449.333 566.667L448.667 566.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M871 566L872 567L871 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M872 566L872 567L876 567L872 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M876 566L877 567L876 566M943 566L944 567L943 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M944 566L944 567L947 567L944 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M947 566L948 567L947 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M441 567L442 568L441 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M442.044 567.743C431.955 571.798 438.79 587.172 448.981 583.254C459.856 579.073 452.349 563.602 442.044 567.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M449 567L450 568L449 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M450 567L451 568L450 567M838 567L838 596L839 596L838 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M839 567L839 568L852 568L852 575L853 575L853 567L839 567M869 567L870 568L869 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M870.044 567.743C859.965 571.793 867.014 587.047 876.985 583.254C888.147 579.008 880.375 563.591 870.044 567.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M877 567L878 568L877 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M878 567L879 568L878 567M940 567L939 569L940 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M941 567L942 568L941 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M942.019 567.743C931.906 571.726 938.734 587.365 948.956 583.257C959.078 579.189 952.391 563.659 942.019 567.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M949 567L950 568L949 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M950 567L951 568L950 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M436 568L434 583L435 584L444 586L444 585L436 582L435 572L439 568L436 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M439 568L440 569L439 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M451 568L452 569L451 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M462 568L463 569L462 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M667.667 568.333L668.333 568.667L667.667 568.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M839 568L839 646L851.972 644.397L853 624L852 568L839 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M867 568L868 569L867 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M879 568L881 570L879 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M880 568L881 569L880 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M951 568L953 570L951 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M952 568L953 569L952 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M438 569L439 570L438 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M452 569L453 570L452 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M866 569L867 570L866 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M938 569L939 570L938 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M437 570L438 571L437 570z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M453 570L454 571L453 570z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M667 570L668 571L667 570z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M881 570L882 571L881 570z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M937 570L938 571L937 570M953 570L954 571L953 570z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M954.667 570.333L955.333 570.667L954.667 570.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M437 571L438 572L437 571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M454 571L455 572L454 571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M865 571L866 572L865 571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M882 571L883 572L882 571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M435.667 572.333L436.333 572.667L435.667 572.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M454 572L455 573L454 572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M882 572L883 573L882 572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M936 572L937 573L936 572M954 572L955 573L954 572M436 573L437 574L436 573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M454 573L455 574L454 573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M864 573L864 578L865 578L864 573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M936 573L936 578L937 578L936 573M954 573L954 578L955 578L954 573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M955.333 573.667L955.667 574.333L955.333 573.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M436 574L436 577L437 577L436 574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M455.333 574.667L455.667 575.333L455.333 574.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M883 574L883 577L884 577L883 574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M664 575L665 576L664 575M671 575L672 576L671 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M672 575L672 576L681 576L672 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M681.667 575.333L682.333 575.667L681.667 575.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M347 576L347 577L360 577L347 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M653 576L656 579L653 576M655 576L655 577L659 580L659 577L655 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M666 576L667 577L666 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M667 576L668 577L667 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M668.667 576.333L669.333 576.667L668.667 576.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M708 630C705.354 628.201 701.449 624.301 698.089 624.33C694.763 624.359 691.611 629.017 688.996 630.751C683.725 634.246 676.004 635.198 670 633.03C649.525 625.638 650.92 593.279 673 589.329C678.65 588.319 684.297 589.306 689 592.638C691.677 594.535 694.457 598.58 698 598.694C701.135 598.794 704.471 595.559 707 594C705.299 585.57 696.803 580.133 689 577.725C671.23 572.24 650.164 579.932 643.119 598C627.459 638.164 686.477 667.234 708 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M684.667 576.333L685.333 576.667L684.667 576.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M686 576L687 577L686 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M687 576L688 577L687 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M852 576L852 581L853 581L852 576M346 577L346 627L347 627C347 612.951 351.409 589.89 346 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M347 577L347 614C347 619.333 347.978 626.363 344.436 630.856C340.775 635.5 335.131 634.634 330 634C330 637.097 328.952 642.693 331.028 645.258C337.396 653.129 355.624 643.934 358.633 636.999C361.204 631.071 360 623.324 360 617L360 577L347 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M360 577L360 632L361 632L361 595L360 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M436 577L437 578L436 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M454 577L455 578L454 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M663 577L664 578L663 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M664 577L665 578L664 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M665 577L666 578L665 577M688.667 577.333L689.333 577.667L688.667 577.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M690 577L691 578L690 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M955 577L952 583L955 577M345.333 578.667L345.667 579.333L345.333 578.667M361 578L361 627L362 627C362 613.212 366.309 590.652 361 578M433 578L434 579L433 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M436 578L437 579L436 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M454 578L455 579L454 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M652 578L654 580L652 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M661 578L662 579L661 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M662 578L663 579L662 578M691 578L692 579L691 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M692 578L693 579L692 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M882 578L883 579L882 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M936 578L937 579L936 578M954 578L955 579L954 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M437 579L438 580L437 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M454 579L455 580L454 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M660 579L661 580L660 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M694 579L695 580L694 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M865 579L866 580L865 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M882 579L883 580L882 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M937 579L938 580L937 579M953 579L954 580L953 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M436 582L439 582L438 580L436 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M453 580L454 581L453 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M455 580L455 583L456 583L455 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M654 582L657 580L654 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M658 580L659 581L658 580M695 580L696 581L695 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M696 580L697 581L696 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M866 580L867 581L866 580M881 580L882 581L881 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M898 580L897 594L898 594L898 580M953 580L954 581L953 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M205.333 581.667L205.667 582.333L205.333 581.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M205 595C196.363 592.54 197 599.427 197 606C212.267 606.18 203.63 625.895 206.804 636C210.681 648.344 225.71 647.91 236 646L236 635C216.351 634.998 219 621.848 219 606L234 606C234 595.613 231.017 591.743 220 595L219 581C206.15 581 205.648 582.641 205 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M219 581L220 595L221 595L219 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M345 581L345 584L346 584L345 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M452 581L453 582L452 581M656 581L657 582L656 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M697 581L698 582L697 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M866 581L867 582L866 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M880 581L881 582L880 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M898 581L898 594L890 594L890 606L898 606C898 622.463 893.883 646.447 917 646.985C920.756 647.073 924.316 646.684 928 646L928 635C908.827 634.987 912 621.056 912 606L927 605L927 595L912 594L912 581L898 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M938 581L940 583L938 581M952 581L953 582L952 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M435 582L436 583L435 582M439 582L440 583L439 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M451 582L452 583L451 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M648 582L649 583L648 582M651 582L652 583L651 582M653 582L654 583L653 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M655 582L656 583L655 582M698 582L699 583L698 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M699 582L700 583L699 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M867 582L868 583L867 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M868 582L869 583L868 582M879 582L880 583L879 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M938 582L939 583L938 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M951 582L952 583L951 582M441 583L442 584L441 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M442 583L443 584L442 583M449 583L450 584L449 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M450 583L451 584L450 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M652 583L647 589L652 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M654 583L655 584L654 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M700 583L701 584L700 583M869 583L870 584L869 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M870 583L871 584L870 583M877 583L878 584L877 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M878 583L879 584L878 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M941 583L942 584L941 583M949 583L950 584L949 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M443 584L444 585L443 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M444 584L444 585L447 585L444 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M447 584L448 585L447 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M644 584L640 589L642 586L645 587L644 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M652 584L653 585L652 584M701 584L702 585L701 584M872 584L872 585L877 585L872 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M941 584L942 585L941 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M944 584L944 585L947 585L944 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M949.667 584.333L950.333 584.667L949.667 584.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M458.667 585.333L459.333 585.667L458.667 585.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M651 585L652 586L651 585M702 585L703 586L702 585M650 586L651 587L650 586M703 586L704 587L703 586M649 587L650 588L649 587M704 587L705 588L704 587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M447 588L448 589L447 588M645 588L644 590L645 588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M648 588L649 589L648 588M705 588L706 589L705 588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M646 589L644 594C641.287 594 641.617 595.384 642 598L632 605L636 624L632 624L632 630L640 636L640 633L642 635L655 642C646.568 630.028 637.943 622 640.301 606C641.14 600.305 646.468 594.385 646 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M671.667 589.333L672.333 589.667L671.667 589.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M673.667 589.333L674.333 589.667L673.667 589.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M675 589L675 590L680 590L675 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M680.667 589.333L681.333 589.667L680.667 589.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M682.667 589.333L683.333 589.667L682.667 589.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M642 590L640 594L641 594L642 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M647 590L648 591L647 590M668 590L669 591L668 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M669 590L670 591L669 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M670 590L671 591L670 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M684 590L685 591L684 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M685 590L686 591L685 590M706 590L707 591L706 590M646 591L647 592L646 591M666 591L667 592L666 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M667 591L668 592L667 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M671.667 591.333L672.333 591.667L671.667 591.333M683 591L684 592L683 591M686 591L687 592L686 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M687 591L688 592L687 591M707 591L708 592L707 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M205.333 592.667L205.667 593.333L205.333 592.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M220.333 592.667L220.667 593.333L220.333 592.667M259 593L259 594L266 593L259 593M274.667 592.333L275.333 592.667L274.667 592.333M277 592L278 593L277 592M295 592L296 593L295 592M391 592L389 593L389 594L391 592M393 592L393 593L396 593L393 592M403 592L403 593L412 595L403 592M422 592L422 595L423 595L422 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M473 592L474 593L473 592M479 592L479 593L484 593L484 592L479 592M485 592L486 593L485 592M487 592L488 593L487 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M497 592L497 593L507 596L497 592M511 592L508 594L508 595L512 593L511 592M564 595L564 596L575 593L564 595M581 592L581 593L586 593L581 592M594 592L595 593L594 592M599 592L598 594L599 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M645 592L646 593L645 592M665 592L666 593L665 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M666 595L670 596L669 593L672 594C669.335 592.033 667.935 592.34 666 595M676 592L676 593L680 593L676 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M689 592L690 593L689 592M707.333 592.667L707.667 593.333L707.333 592.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M912 592L913 593L912 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M199 593L200 594L199 593M232 593L233 594L232 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M261 593L262 594L261 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M262 593L263 594L262 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M263 593L263 594L266 594L263 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M266 593.439C229.551 599.12 239.147 651.997 275 646.699C309.607 641.586 300.184 588.111 266 593.439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M274.667 593.333L275.333 593.667L274.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M276 593L277 594L276 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M279 593L279 594L282 595L279 593M381 593L382 594L381 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M391 593L392 594L391 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M392 593L393 594L392 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M393 593L393 594L396 594L393 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M396 593.439C359.505 599.127 368.938 652.028 405 646.699C439.512 641.6 430.15 588.116 396 593.439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M404.667 593.333L405.333 593.667L404.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M406 593L407 594L406 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M407.667 593.333L408.333 593.667L407.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M413 593L413 596L426 607L421 597L413 593M420 593L421 594L420 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M452 593L453 594L452 593M467 593L468 594L467 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M488.667 593.333L489.333 593.667L488.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M490.667 593.333L491.333 593.667L490.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M480 598C478.496 592.863 472.341 595.043 468 594C463.488 609.264 467 630.069 467 646L481 646C481 636.206 476.291 610.821 488.004 606.607C493.623 604.586 498.514 608.887 500.057 614.001C502.962 623.625 501 636.013 501 646L514 646C514 628.411 520.578 588.173 491 593.62C486.959 594.364 483.6 596.116 480 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M498.667 593.333L499.333 593.667L498.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M500 593L501 594L500 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M501 593L502 594L501 593M570 593L571 594L570 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M571.667 593.333L572.333 593.667L571.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M573.667 593.333L574.333 593.667L573.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M563 612L564 612C572.703 604.607 585.646 602.073 587 617C578.443 617 567.388 615.246 560.044 620.652C551.133 627.212 553.082 641.046 563.015 645.467C571.605 649.29 580.304 646.033 588 642L588 646C591.18 646 597.738 647.218 599.972 644.397C602.423 641.302 601 633.731 601 630C601 617.361 602.654 600.195 588 594.905C576.127 590.619 548.095 596.713 563 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M582 593L582 594L585 594L582 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M585 593L586 594L585 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M587 593L587 594L592 596L591 593L587 593M595 593C593.724 596.216 593.954 597.279 597 599L595 596L595 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M645 593L646 594L645 593M663 593L664 594L663 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M664 593L665 594L664 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M690 593L691 594L690 593M735 593L736 594L735 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M736 593L736 594L739 594L736 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M739 593.44C702.585 598.999 711.99 652.69 748 646.674C782.358 640.935 773.172 588.224 739 593.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M746 593L746 594L749 594L746 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M749 593L750 594L749 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M750 593L751 594L750 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M796 593L797 594L796 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M797 593L797 594L800 594L797 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M787 612L788 612C796.587 605.213 810.157 601.603 811 617C802.449 617 791.38 615.242 784.044 620.652C775.503 626.95 778.06 640.812 787.001 645.312C795.223 649.45 804.649 646.2 812 642L812 646L825 646C825 631.225 830.323 604.871 814.999 596.089C803.575 589.543 773.075 595.828 787 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M806.667 593.333L807.333 593.667L806.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M808.667 593.333L809.333 593.667L808.667 593.333M867 593L866 595L867 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M940.667 593.333L941.333 593.667L940.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M984.667 593.333L985.333 593.667L984.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M986.667 593.333L987.333 593.667L986.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M988 593.44C951.998 598.936 960.078 651.888 996 646.7C1030.98 641.648 1022.37 588.194 988 593.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M995.667 593.333L996.333 593.667L995.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M997 593L998 594L997 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M998 593L999 594L998 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1052 593L1053 594L1052 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1053.67 593.333L1054.33 593.667L1053.67 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M1043 599L1043 594L1031 595L1031 646L1044 646C1044 636.295 1041.73 623.287 1044.65 614.001C1046.25 608.92 1051.48 604.623 1057 606.607C1068.71 610.821 1064 636.206 1064 646L1078 646C1078 628.291 1083.48 586.285 1053 593.903C1049.16 594.863 1046.14 596.654 1043 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1061 593L1061 594L1064 594L1061 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M1064 593L1065 594L1064 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M197 594L198 595L197 594M204 594L205 595L204 594M233 594L234 595L233 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M234 594L234 606L235 606L234 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M257 594L258 595L257 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M259 594L260 595L259 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M260 594L261 595L260 594M278.667 594.333L279.333 594.667L278.667 594.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M280 594L281 595L280 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M385 594L386 596L387 596L388 594L385 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M389 594L390 595L389 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M390 594L391 595L390 594M408.667 594.333L409.333 594.667L408.667 594.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M410 594L411 595L410 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M432 594L433 595L432 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M438 594L439 595L438 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M439 594C434.488 609.264 438 630.069 438 646L439 646L439 610L441 595L439 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M439 646L453 646L453 595L440.028 595.832L439 609L439 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M442 594L442 595L448 595L442 594M449 594L449 595L453 595L449 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M466 594L466 646L467 646L467 611L466 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M467 594L468 595L467 594M469 594L469 595L475 595L469 594M477 594L477 595L480 595L477 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M485 594L486 595L485 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M486 594L487 595L486 594M502.667 594.333L503.333 594.667L502.667 594.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M504 594L505 595L504 594M567 594L568 595L567 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M568 594L569 595L568 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M569 594L570 595L569 594M587 594L588 595L587 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M588 594L589 595L588 594M644 594L645 595L644 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M662 594L663 595L662 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M691 594L692 595L691 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M705 594L706 595L705 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M706 594L707 595L706 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M732 594L733 595L732 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M733 594L734 595L733 594M752 594L753 595L752 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M753 594L754 595L753 594M792 594L793 595L792 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M793 594L794 595L793 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M794 594L795 595L794 594M811 594L812 595L811 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M812 594L813 595L812 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M867 594L867 646L881 646L881 609L879.972 595.603L867 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M880 594L881 595L880 594M889 594L889 606L890 606L889 594M916 594L917 595L916 594M926 594L927 595L926 594M938 594L938 646L939 646L939 611L938 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6fbfb",
      stroke: "none"
    },
    d: "M939 594L939 646L952 646L952 595L939 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M943 594L944 595L943 594M949 594L949 595L952 595L952 646L953 646L953 594L949 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M981 594L982 595L981 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M982 594L983 595L982 594M1000 594L1001 595L1000 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1001 594L1002 595L1001 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1030 594L1030 646L1031 646L1031 595L1040 595L1030 594M1041 594L1042 595L1041 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1043 594L1045 598L1043 594M1049 594L1050 595L1049 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1050 594L1051 595L1050 594M1066 594L1067 595L1066 594M257 595L258 596L257 595M281 595L282 596L281 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M282 595L283 596L282 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M283 595L284 596L283 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M387 595L388 596L387 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M411 595L412 596L411 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M414 595L415 596L414 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M420 595L421 596L420 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M464 595L465 596L464 595M481 595L482 596L481 595M483 595L484 596L483 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M484 595L485 596L484 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M505 595L506 596L505 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M561 595L560 599L561 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M565 595L566 596L565 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M566 595L567 596L566 595M589 595L590 596L589 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M590 595L591 596L590 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M598 595L599 598L600 598L600 595L598 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M643 595L644 596L643 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M661 595L662 596L661 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M689 595L690 596L689 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M704 595L705 596L704 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M730 595L731 596L730 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M754 595L755 596L754 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M755 595L756 596L755 595M790 595L791 596L790 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M791 595L792 596L791 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M814 595L815 596L814 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M866 595L866 642L867 642C867 628.735 871.11 607.176 866 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M881 595L881 624L882 624L881 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M979 595L980 596L979 595M1003 595L1004 596L1003 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1047 595L1048 596L1047 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1068 595L1069 596L1068 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M235 596L236 597L235 596M254 596L255 597L254 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M255 596L256 597L255 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M283 596L284 597L283 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M284 596L285 597L284 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M285 596L285 597L294 604L285 596M380 596L381 597L380 596M384 596L385 597L384 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M385 596L386 597L385 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M413 596L414 597L413 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M414 596L415 597L414 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M432.333 596.667L432.667 597.333L432.333 596.667M435 596L436 597L435 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M454 596L455 597L454 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M482 596L483 597L482 596M506 596L507 597L506 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M508 596L510 598L508 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M564 596L565 597L564 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M640.333 596.667L640.667 597.333L640.333 596.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M643 596L644 597L643 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M660 596L661 597L660 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M664 598C660.502 598.72 660.624 600.665 661 604L663 605L667 606L668 604L667 601L672 597L666 600L665 598L665 597L668 597L664 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M703 596L704 597L703 596M728 596L729 597L728 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M756 596L757 597L756 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M757 596L758 597L757 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M788 596L789 597L788 596M816 596L817 597L816 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M838 596L838 646L839 646C839 631.951 843.409 608.889 838 596M926 596L927 597L926 596M977 596L978 597L977 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1005 596L1006 597L1005 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M1045 596L1046 597L1045 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1046 596L1047 597L1046 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1070 596L1071 597L1070 596M253 597L254 598L253 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M254 597L255 598L254 597M285 597L286 598L285 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M379 600L383 597L379 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M383 597L384 598L383 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M384 597L385 598L384 597M415 597L416 598L415 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M418 597L419 598L418 597M480 597L481 598L480 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M481 597L482 598L481 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M508 597L509 598L508 597M562 597L563 598L562 597M593 597L594 598L593 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M660 597L661 598L660 597M689 597L688 599L689 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M694 597L695 598L694 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M701 597L702 598L701 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M702 597L703 598L702 597M720 597L721 598L720 597M722 597L723 598L722 597M726 597L727 598L726 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M727 597L728 598L727 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M758 597L759 598L758 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M787 597L788 598L787 597M817 597L818 598L817 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M975 597L976 598L975 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1006 597L1007 598L1006 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1007 597L1008 598L1007 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1071 597L1072 598L1071 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M235 598L235 602L236 602L235 598M251 598L252 599L251 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M252 598L253 599L252 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M286 598L287 599L286 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M287 598L289 600L289 598L287 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M382 598L383 599L382 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M416 598L417 599L416 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M417 598L418 599L417 598M455 598L456 599L455 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M511 598L512 599L511 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M561 598L562 599L561 598M594 598L595 599L594 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M642 598L643 599L642 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M659 598L660 599L659 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M662 598L661 600L662 598M664 598L665 599L664 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M691 598L692 599L691 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M695 598L696 599L695 598M700 598L701 599L700 598M725 598L726 599L725 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M759 598L760 599L759 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M785 598L786 599L785 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M818 598L819 599L818 598M926 598L926 604L927 604L926 598M974 598L975 599L974 598M1008 598L1009 599L1008 598M1043 598L1044 599L1043 598M1072 598L1073 599L1072 598M251 599L252 600L251 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M294 599L294 601L296 599L294 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M381 599L382 600L381 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M418 599L419 600L418 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M423 599L423 602L425 601L425 600L423 599M557 599C554.281 604.785 556.909 607.964 560 613L561 613C559.453 607.303 556.067 604.921 559 599L557 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M595 599L596 600L595 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M598 599L599 600L598 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M642 599L643 600L642 599M658 599L659 600L658 599M696 599L697 600L696 599M698 599L699 600L698 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M699 599L700 600L699 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M724 599L725 600L724 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M761 599L762 600L761 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M784 599L785 600L784 599M819 599L820 600L819 599M973 599L974 600L973 599M1009 599L1010 600L1009 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1073 599L1074 600L1073 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M249 600L245 605L249 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M250 600L251 601L250 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M289 600L290 601L289 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M292 600L293 601L292 600M377 600L378 601L377 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M380 600L381 601L380 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M419 600L420 601L419 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M464 600L465 601L464 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M510 600L512 602L510 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M511 600L512 601L511 600M514 600L515 601L514 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M558 600L559 601L558 600M596 600L597 601L596 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M597 600L601 614L602 614C601.979 609.035 601.926 602.424 597 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M641 600L642 601L641 600M658 600L659 601L658 600M696 600L697 601L696 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M697 600L698 601L697 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M722 600L723 601L722 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M723 600L724 601L723 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M762 600L763 601L762 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M783 600L784 601L783 600M820 600L821 601L820 600M972 600L973 601L972 600M1010 600L1011 601L1010 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1074 600L1075 601L1074 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M249 601L250 602L249 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M290 601L291 602L290 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M295 601L296 602L295 601M378 601L374 606L378 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M379 601L380 602L379 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M420 601L421 602L420 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M512 601L513 604L514 604L512 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M557 601L558 602L557 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M597 601L598 602L597 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M641 601L642 602L641 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M657 601L658 602L657 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M663 601L664 602L663 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M714 601L715 602L714 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M722 601L723 602L722 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M763 601L764 602L763 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M782 601L783 602L782 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M821 601L822 602L821 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M971 601L972 602L971 601M1074 601L1075 602L1074 601M248 602L249 603L248 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M291 602L292 603L291 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M294 602L295 603L294 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M378 602L379 603L378 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M421 602L422 603L421 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M464 602L465 603L464 602M512 602L513 603L512 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M553 602L554 603L553 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M556 602L557 603L556 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M597 602L598 603L597 602M641.333 602.667L641.667 603.333L641.333 602.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M657 602L658 603L657 602M659 602L659 607L660 607L659 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M721 602L722 603L721 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M764 602L765 603L764 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M781 602L782 603L781 602M970 602L971 603L970 602M1012 602L1013 603L1012 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1075 602L1076 603L1075 602M247 603L248 604L247 603M292 603L293 604L292 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M295 603L296 604L295 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M377 603L378 604L377 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M422 603L423 604L422 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M429 603L430 604L429 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M512 603L513 604L512 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M598 603L599 604L598 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M656 603L657 604L656 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M697 603L698 604L697 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M720 603L721 604L720 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M780 603L781 604L780 603M822 603L823 604L822 603M969 603L970 604L969 603M1013 603L1014 604L1013 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M246 604L247 605L246 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M292 604L293 605L292 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M376 604L377 605L376 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M422 604L423 605L422 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M456 604L456 609L457 609L456 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M556 604L557 605L556 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M599 604L600 605L599 604M640.333 604.667L640.667 605.333L640.333 604.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M656 604L657 605L656 604M719 604L720 605L719 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M765 604L766 605L765 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M780 604L781 605L780 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M968 604L969 605L968 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1014 604L1015 605L1014 604M1076 604L1077 605L1076 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M246 605L247 606L246 605M293 605L294 606L293 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M294 605L298 627L299 627C299 619.231 300.104 610.797 294 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M375 605L376 606L375 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M423 605L424 606L423 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M428 605L432 607L432 606L428 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M513 605L514 606L513 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M514 605L516 608L514 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M574 605L574 606L580 606L574 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M599 605L600 606L599 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M656 605L657 606L656 605M699 605L700 606L699 605M718 605L719 606L718 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M719 605L720 606L719 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M766 605L767 606L766 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M781 605L782 606L781 605M798.667 605.333L799.333 605.667L798.667 605.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M800.667 605.333L801.333 605.667L800.667 605.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M802.667 605.333L803.333 605.667L802.667 605.333M823 605L824 606L823 605M926 605L927 606L926 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M967 605L968 606L967 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M1015 605L1016 606L1015 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1076 605L1077 606L1076 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M197 606L197 607L205 607L197 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M219 606L219 629L220 629L219 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M220 606L220 607L234 607L220 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M244 606L245 607L244 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M245 606L246 607L245 606M265.667 606.333L266.333 606.667L265.667 606.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M267 606L267 607L273 607L267 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M273 606L274 607L273 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M294 606L295 607L294 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M375 606L376 607L375 606M395.667 606.333L396.333 606.667L395.667 606.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M397.667 606.333L398.333 606.667L397.667 606.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M399 606L400 607L399 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M400.667 606.333L401.333 606.667L400.667 606.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M402.667 606.333L403.333 606.667L402.667 606.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M424 606L425 607L424 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M486 606L487 607L486 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M487.667 606.333L488.333 606.667L487.667 606.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M489 606L489 607L493 607L489 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M493 606L494 607L493 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M494 606L495 607L494 606M513 606L514 607L513 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M557 606L558 607L557 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M571 606L572 607L571 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M572 606L573 607L572 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M570 607L569 608L570 610L566 612L570 615L568 616L568 617L574 612C578.156 614.932 582.79 615.505 586 611L584 613C580.582 607.845 575.914 606.781 570 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M574 606L574 607L583 613L584 613L585 609L574 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M580 606L581 607L580 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M581 606L582 607L581 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M582 606L583 607L582 606M599 606L600 607L599 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M640 606L640 609L641 609L640 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M655 606L655 610L656 610L655 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M662.667 606.333L663.333 606.667L662.667 606.333M712 606L713 607L712 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M718 606L719 607L718 606M738.667 606.333L739.333 606.667L738.667 606.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M740.667 606.333L741.333 606.667L740.667 606.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M742.667 606.333L743.333 606.667L742.667 606.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M744.667 606.333L745.333 606.667L744.667 606.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M746 606L747 607L746 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M767 606L768 607L767 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M782 606L783 607L782 606M795 606L796 607L795 606M806 606L807 607L806 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M889 606L889 607L897 607L897 632C900.862 622.796 900.676 606.041 889 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M897 606L898 607L897 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M912 606L912 607L927 607L912 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M967 606L968 607L967 606M987 606L988 607L987 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M988.667 606.333L989.333 606.667L988.667 606.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M990 606L991 607L990 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M991 606.614C974.339 607.453 975.326 634.675 992 633.855C1008.58 633.04 1007.65 605.776 991 606.614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M993.667 606.333L994.333 606.667L993.667 606.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M995 606L996 607L995 606M1015 606L1016 607L1015 606M1050 606L1051 607L1050 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1051 606L1052 607L1051 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M1056 606L1057 607L1056 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1057 606L1058 607L1057 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1058 606L1059 607L1058 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M204 607L205 608L204 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M205 607L205 633L206 633L205 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M220 607L221 608L220 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M263 607L264 608L263 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M264 607L265 608L264 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M265 607L264 611L261 611L262 609L261 609L262 613L258 613L259 629L262 632L276 632L282 626L281 621L283 622L281 619L281 612L277 608L275 607L265 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M266 607L266 608L271 608L266 607M272.667 607.333L273.333 607.667L272.667 607.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M275 607L276 608L275 607M294 607L295 608L294 607M393 607L394 608L393 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M394 607L395 608L394 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M393 610C407.77 605.32 413.07 617.556 408 630C420.326 619.123 401.563 597.88 393 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M404 607L405 608L404 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M405 607L406 608L405 607M424 607L425 608L424 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M485 607L486 608L485 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M482 641L483 641L484 613C490.778 609.227 494.301 607.789 499 615L499 632C502.455 623.767 497.47 596.166 484.318 609.318C478.656 614.979 482 633.416 482 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M495 607L496 608L495 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M496 607L497 608L496 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M558 607L559 608L558 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M569 607L570 608L569 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M571 607L572 608L571 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M582 607L583 608L582 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M583 607L584 608L583 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M717 607L718 608L717 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M736 607L737 608L736 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M737 607L738 608L737 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M738.001 607.742C723.002 613.508 731.479 639.238 746.999 632.99C762.461 626.766 754.514 601.394 738.001 607.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M748 607L749 608L748 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M767 607L768 608L767 607M783 607L784 608L783 607M793 607L794 608L793 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M896 607L897 608L896 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M966 607L967 608L966 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M985 607L986 608L985 607M997 607L998 608L997 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1016 607L1017 608L1016 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1048 607L1049 608L1048 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M1049 607L1050 608L1049 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1059 607L1060 608L1059 607M1077 607L1078 608L1077 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M243 608L244 609L243 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M244 608L245 609L244 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M262 608L263 609L262 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M263.667 608.333L264.333 608.667L263.667 608.333M275 608L276 609L275 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M277 608L281 612L277 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M295 608L296 609L295 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M373 608L374 609L373 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M374 608L375 609L374 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M392 608L393 609L392 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M391 609L391 612L388 613L387 625L389 629L397 634L407 632C410.889 625.304 413.714 612.477 403.978 608.739C399.801 607.136 395.288 609.203 391 609M406 608L408 610L406 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M407 608L408 609L407 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M425 608L426 609L425 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M426 608C428.727 619.929 427.903 627.237 422 638L427 636L427 630C432.431 630.031 429.018 612.227 429 608L428 608L426 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M484 608L485 609L484 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M497 608L498 609L497 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M559 608L560 609L559 608M568 608L569 609L568 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M570 608L571 609L570 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M584 608L585 609L584 608M600.333 608.667L600.667 609.333L600.333 608.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M607 608L607 611L608 611L607 608M623 608L623 616L624 616L623 608M631 608L631 616L632 616L631 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M635 608L635 616L637 616L637 608L635 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M717 608L718 609L717 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M735 608L736 609L735 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M750 608L751 609L750 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M768 608L769 609L768 608M792 608L793 609L792 608M824 608L825 609L824 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M983 608L984 609L983 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M998 608L999 609L998 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M999 608L1000 609L999 608M1047 608L1048 609L1047 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M1060 608L1061 609L1060 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1077 608L1077 611L1078 611L1077 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M261 611L264 611L263 609L261 611M274 609L273 611L274 609M276 609L280 613L276 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M295 609L296 610L295 609M408 609L409 610L408 609M425 609L426 610L425 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M483 609L484 610L483 609M485.667 609.333L486.333 609.667L485.667 609.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M498 609L499 610L498 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M514.333 609.667L514.667 610.333L514.333 609.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M555 609L556 610L555 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M560 609L561 610L560 609M566 609L564 612L566 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M567 609L568 610L567 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M563 613L563 614L570 610L563 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M585 609L586 610L585 609M640 609L640 615L641 615L640 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M716 609L717 610L716 609M734 609L735 610L734 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M751 609L752 610L751 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M768 609L769 610L768 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M809 609L810 610L809 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M824 609L825 610L824 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M965 609L966 610L965 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M982 609L983 610L982 609M1000 609L1001 610L1000 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1017 609L1018 610L1017 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1046 609L1047 610L1046 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1061 609L1062 610L1061 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M242 610L243 611L242 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M243 610L244 611L243 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M296 610L297 611L296 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M372.333 610.667L372.667 611.333L372.333 610.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M373 610L374 611L373 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M391 610L392 611L391 610M396 610L397 611L396 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M409 610L410 611L409 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M426 610L427 611L426 610M482 610L483 611L482 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M495 610L492 611L492 612L495 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M498 610L499 611L498 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M515 610L515 646L516 646C516 635.613 519.011 619.56 515 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M561 610L562 611L561 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M585 610L586 611L585 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M600 610L600 613L601 613L600 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M655 610L655 614L656 614L655 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M716 610L717 611L716 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M733 610L734 611L733 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M752 610L753 611L752 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M785 610L786 611L785 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M789 610L790 611L789 610M965 610L966 611L965 610M981 610L982 611L981 610M1001 610L1002 611L1001 610M1017 610L1018 611L1017 610M1062 610L1063 611L1062 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M259 611L260 612L259 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M260 611L259 614L262 612L260 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M296 611L297 612L296 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M389 611L390 612L389 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M390 611L391 612L390 611M394 611L395 612L394 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M410 611L411 612L410 611M426.333 611.667L426.667 612.333L426.333 611.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M488.667 611.333L489.333 611.667L488.667 611.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M499 611L500 612L499 611M514 611L514 646L515 646L514 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M557 611L558 612L557 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M562 611L563 612L562 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M732 611L733 612L732 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M753 611L754 612L753 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M769 611L770 612L769 611M786 611L787 612L786 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M788 611L789 612L788 611M810 611L811 612L810 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M964 611L965 612L964 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M980 611L981 612L980 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1045 611L1046 612L1045 611M242.333 612.667L242.667 613.333L242.333 612.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M258 612L259 613L258 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M263 612L264 613L263 612M276 612L277 613L276 612M302.333 612.667L302.667 613.333L302.333 612.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M372 612L373 613L372 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M388 612L389 613L388 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M389 612L390 613L389 612M392 612L393 613L392 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M410 612L411 613L410 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M431 612L432 613L431 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M481 612L482 613L481 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M499 612L500 613L499 612M563 612L564 613L563 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M564 612L565 613L564 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M567 612L569 614L569 612L567 612M574 612L571 615L571 616L586 616L586 612L585 612C581.178 615.002 578.004 614.27 574 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M586 612L586 617L587 617L586 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M715 612L716 613L715 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M731 612L732 613L731 612M769 612L770 613L769 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M787 612L788 613L787 612M810 612L811 613L810 612M825 612L825 646L826 646L825 612M964 612L965 613L964 612M1002 612L1003 613L1002 612M1018 612L1019 613L1018 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1063 612L1064 613L1063 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M241 613L241 616L242 616L241 613M280 613L281 614L280 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M281 613L282 614L281 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M297 613L298 614L297 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M371 613L370 623L371 623L371 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M372 613L372 616L373 616L372 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M396 613L397 614L396 613M400 613L401 614L400 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M409 613L410 614L409 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M411 613L412 614L411 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M427 613L428 614L427 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M481.333 613.667L481.667 614.333L481.333 613.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M486 613L487 614L486 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M499 613L500 614L499 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M552 613L553 614L552 613M555 613L556 614L555 613M566 613L559 620C554.321 620.856 553.38 624.805 552 629L570 616L570 615L566 613M607 613L608 614L607 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M715 613L716 614L715 613M754 613L755 614L754 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M810 613L811 614L810 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M964 613L965 614L964 613M979 613L980 614L979 613M1003 613L1004 614L1003 613M1018 613L1019 614L1018 613M1044 613L1044 646L1045 646L1044 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1063.33 613.667L1063.67 614.333L1063.33 613.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M242.333 614.667L242.667 615.333L242.333 614.667M257 614L258 615L257 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M258 614L259 628L260 628L258 614M262 614L263 615L262 614M274 614L275 615L274 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M297 614L298 615L297 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M387 614L388 615L387 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M388 614L387 623L388 623L388 614M406 614L407 615L406 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M411 614L412 615L411 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M427 614L428 615L427 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M494.667 614.333L495.333 614.667L494.667 614.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M655 614L655 617L656 617L655 614M715.333 614.667L715.667 615.333L715.333 614.667M730 614L731 615L730 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M770.333 614.667L770.667 615.333L770.333 614.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M979 614L980 615L979 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1003 614L1004 615L1003 614M257 615L258 616L257 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M280 615L281 616L280 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M282 615L283 616L282 615M297 615L297 625L298 625L297 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M387 615L388 616L387 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M401 615L402 616L401 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M412 615L413 616L412 615M427 615L427 625L428 625L427 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M483 615L484 616L483 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M487 615L488 616L487 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M500 615L500 646L501 646L500 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M566 615L567 616L566 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M602 615L603 616L602 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M640 615L640 618L641 618L640 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M730 615L731 616L730 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M755 615L756 616L755 615M978.333 615.667L978.667 616.333L978.333 615.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M1063 615L1063 642L1064 642L1063 615M257 616L258 617L257 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M281 616L281 619L282 619L281 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M282.333 616.667L282.667 617.333L282.333 616.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M387 616L388 617L387 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M408 616L409 617L408 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M412.333 616.667L412.667 617.333L412.333 616.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M553 616L553 619L554 619L553 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M570 616L570 617L575 617L570 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M575 616L576 617L575 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M576 616L576 617L584 617L576 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M584 616L585 617L584 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M585 616L586 617L585 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M659 616L660 617L659 616M714 616L714 624L715 624L714 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M755 616L756 617L755 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M770 616L770 624L771 624L770 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M797 616L797 617L810 617L797 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M810 616L811 617L810 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M963 616L964 617L963 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1004 616L1005 617L1004 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1019 616L1019 624L1020 624L1019 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M256 617L256 623L257 623L256 617M386 617L386 624L387 624L386 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M564 617L565 618L564 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M565 617L566 618L565 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M566.667 617.333L567.333 617.667L566.667 617.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M656.333 617.667L656.667 618.333L656.333 617.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M729 617L729 624L730 624L729 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M755.333 617.667L755.667 618.333L755.333 617.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M790 617L791 618L790 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M791 617L792 618L791 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M963 617L963 624L964 624L963 617M978.333 617.667L978.667 618.333L978.333 617.667M1004.33 617.667L1004.67 618.333L1004.33 617.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M412 618L412 622L413 622L412 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M562 618L563 619L562 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M563 618L564 619L563 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M640 618L641 619L640 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M787 618L788 619L787 618M241 619L242 620L241 619M560 619L561 620L560 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M561 619L562 620L561 619M656 619L657 620L656 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M701 619L702 620L701 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M785 619L786 620L785 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M978 619L978 622L979 622L978 619M1004 619L1005 620L1004 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M487 620L488 621L487 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M559 620L560 621L559 620M641 620L642 621L641 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M658 620L659 621L658 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1004 620L1004 623L1005 623L1004 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M281 621L281 625L282 625L281 621M389 621L390 622L389 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M558 621L559 622L558 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M641 621L642 622L641 621M657 621L658 622L657 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M699 621L700 622L699 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M782 621L783 622L782 621M282.333 622.667L282.667 623.333L282.333 622.667M412.333 622.667L412.667 623.333L412.333 622.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M487.333 622.667L487.667 623.333L487.333 622.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M557 622L558 623L557 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M641 622L642 623L641 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M657 622L658 623L657 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M659 622L660 623L659 622M696 622L697 623L696 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M697 622L698 623L697 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M755 622L756 623L755 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M781 622L782 623L781 622M978 622L979 623L978 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M257.333 623.667L257.667 624.333L257.333 623.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M556 623L557 624L556 623M642 623L643 624L642 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M658 623L659 624L658 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M696 623L697 624L696 623M698 623L699 624L698 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M699 623L700 624L699 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M755 623L756 624L755 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M978.333 623.667L978.667 624.333L978.333 623.667M1004.33 623.667L1004.67 624.333L1004.33 623.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M220 624L221 625L220 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M242 624L242 627L243 627L242 624M282.333 624.667L282.667 625.333L282.333 624.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M301 624L302 625L301 624M345 624L346 625L345 624M388 624L389 628L390 628L388 624M390 624L391 628L392 628L390 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M412 624L413 625L412 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M555 624L556 625L555 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M640 624L640 632L643 632L643 631L640 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M642 624L643 625L642 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M659 624L660 625L659 624M665 624L666 625L665 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M695 624L696 625L695 624M700 624L701 625L700 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M730 624L731 625L730 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M755 624L756 625L755 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M770.333 624.667L770.667 625.333L770.333 624.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M1019 624L1020 625L1019 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M241 625L242 626L241 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M257 625L258 626L257 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M274 625L273 627L274 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M297 625L298 626L297 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M371.333 625.667L371.667 626.333L371.333 625.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M372.333 625.667L372.667 626.333L372.333 625.667M387.333 625.667L387.667 626.333L387.333 625.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M427.333 625.667L427.667 626.333L427.333 625.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M554 625L555 626L554 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M555 625L556 626L555 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M642 625L643 626L642 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M659 625L660 626L659 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M691 625L690 627L691 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M701 625L702 626L701 625M715.333 625.667L715.667 626.333L715.333 625.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M730 625L731 626L730 625M754.333 625.667L754.667 626.333L754.333 625.667M779 625L780 626L779 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M220.333 626.667L220.667 627.333L220.333 626.667M280 626L276 632L280 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M281 626L282 627L281 626M411 626L412 627L411 626M554 626L555 627L554 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M572 626L573 627L572 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M573 626L573 627L586 627L573 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M586 626L586 629L587 629L586 626M643 626L644 627L643 626M660 626L661 627L660 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M668 626L669 627L668 626M671 626L672 627L671 626M693 626L694 627L693 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M694 626L695 627L694 626M702 626L703 627L702 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M703 626L704 627L703 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M730 626L731 627L730 626M796 626L797 627L796 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M797 626L798 627L797 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M798 626L799 627L798 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M799 626L799 627L805 627L799 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M805.667 626.333L806.333 626.667L805.667 626.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M807 626L807 627L811 628L811 627L807 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M810 626L811 627L810 626M964.333 626.667L964.667 627.333L964.333 626.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M979 626L980 627L979 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1003 626L1004 627L1003 626M1018.33 626.667L1018.67 627.333L1018.33 626.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M242 627L243 628L242 627M258 627L259 628L258 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M281 627L282 628L281 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M344 627C340.204 634.116 333.208 627.099 327.822 631.318C324.393 634.003 324.788 643.82 324 648L326 653L325 653L323 650L323 656L328 656C322.44 662.073 320.001 663.294 320 672L309 672L312 674L312 680L328 685L329 682C337.301 688.433 355.857 700.481 367 698.415C373.138 697.277 377.548 692.6 382.83 689.768C391.403 685.17 399.683 680.432 401 670L392 664L376 659C374.893 652.215 366.159 649.555 360 649L357 645L358 643L358 642C347.089 646.498 340.851 647.935 329 647L330 632C336.026 636.221 343.346 633.564 346 627L344 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M372 627L373 628L372 627M388 627L389 628L388 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M411 627L412 628L411 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M427 627L428 628L427 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M554.333 627.667L554.667 628.333L554.333 627.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M570 627L569 629L570 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M586 627L578 627.001C559.131 627.131 582.1 646.274 586 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M643 627L644 628L643 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M661 627L662 628L661 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M666 627L667 628L666 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M693 627L694 628L693 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M704 627L705 628L704 627M715 627L716 628L715 627M731 627L732 628L731 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M754 627L755 628L754 627M769 627L770 628L769 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M794 627L795 628L794 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M810 628C806.482 626.524 797.575 625.555 794.608 628.603C791.52 631.776 794.919 636.478 798.915 635.353C802.979 634.208 806.045 629.767 810 628M260 628L263 631L260 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M280 628L281 629L280 628M296 628L297 629L296 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M297 628L296 632L299 628L297 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M345 628L346 629L345 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M390 628C391.877 631.578 394.032 632.557 398 633L398 632L390 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M410 628L411 629L410 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M426 628L427 629L426 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M572 631L572 632L570 633C576.111 635.695 581.531 635.084 585 629L572 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M644 628L645 629L644 628M662 628L663 629L662 628M692 628L693 629L692 628M705 628L706 629L705 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M706 628L707 629L706 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M753 628L754 629L753 628M769 628L770 629L769 628M778 628L779 629L778 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M793 628L794 629L793 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M800 636C805.504 635.431 808.377 633.336 810 628L800 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M810.333 628.667L810.667 629.333L810.333 628.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M912.333 628.667L912.667 629.333L912.333 628.667M964 628L965 629L964 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M980 628L981 629L980 628M1002 628L1003 629L1002 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M1018 628L1019 629L1018 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M242 629L243 630L242 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M243 629L244 630L243 629M259 629L260 630L259 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M273 629L274 630L273 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M279 629L280 630L279 629M296 629L297 630L296 629M345 629L346 630L345 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M372 629L377 637L372 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M373 629L374 630L373 629M389 629L390 630L389 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M409 629L410 630L409 629M426 629L427 630L426 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M568 629L569 635L570 635L568 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M574 629L575 630L574 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M644 629L645 630L644 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M663 629L664 630L663 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M690 629L691 630L690 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M707 629L708 630L707 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M716 629L717 630L716 629M732 629L733 630L732 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M752 629L753 630L752 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M769 629L770 630L769 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M778 629L778 635L779 635L778 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M913 629L914 630L913 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M981 629L982 630L981 629M1001 629L1002 630L1001 629M220 630L221 631L220 630M243 630L244 631L243 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M260 630L261 631L260 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M275 630L276 631L275 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M278 630L279 631L278 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M301 630L302 631L301 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M345 630L346 631L345 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M373 630L374 631L373 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M390 630L391 631L390 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M406 630L407 631L406 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M408 630L409 631L408 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M425.333 630.667L425.667 631.333L425.333 630.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M430 630L432 632L430 630M572 630L573 631L572 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M585 630L586 631L585 630M645 630L646 631L645 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M664 630L665 631L664 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M665 630L666 631L665 630M689 630L690 631L689 630M716 630L717 631L716 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M733 630L734 631L733 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M751 630L752 631L751 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M768 630L769 631L768 630M792 630L792 633L793 633L792 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M809 630L810 631L809 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M912 630L913 631L912 630M965 630L966 631L965 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M982 630L983 631L982 630M1000 630L1001 631L1000 630M1017 630L1018 631L1017 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M220 631L221 632L220 631M244 631L245 632L244 631M261 631L262 632L261 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M263 631L263 632C267.057 633.362 271.983 634.713 275 631L263 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M277 631L278 632L277 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M295 631L296 632L295 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M298 631L299 632L298 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M344 631L345 632L344 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M391 631L392 632L391 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M405 631L399 634L406 632L405 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M407 631L408 632L407 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M552.333 631.667L552.667 632.333L552.333 631.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M585 631L586 632L585 631M646 631L647 632L646 631M666 631L667 632L666 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M687 631L688 632L687 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M688 631L689 632L688 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M707 631L708 632L707 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M717 631L718 632L717 631M734 631L735 632L734 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M750 631L751 632L750 631M768 631L769 632L768 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M809 631L810 632L809 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M913 631L914 632L913 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M914 631L915 632L914 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M983 631L984 632L983 631M999 631L1000 632L999 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M204 632L205 633L204 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M221 632L222 633L221 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M244 632L245 633L244 632M263 632L264 633L263 632M275 632L276 633L275 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M276 632L277 633L276 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M330 632L329 634L331 634L330 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M343 632L344 633L343 632M360.333 632.667L360.667 633.333L360.333 632.667M374 632L375 633L374 632M393 632L394 633L393 632M405 632L406 633L405 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M406 632L407 633L406 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M425 632L426 633L425 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M572 632L574 634L572 632M578 632L579 633L578 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M584 632L585 633L584 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M646 632L647 633L646 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M668 632L669 633L668 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M669 632L670 633L669 632M685 632L686 633L685 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M686 632L687 633L686 632M706 632L707 633L706 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M717 632L718 633L717 632M736 632L737 633L736 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M748 632L749 633L748 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M749 632L750 633L749 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M808 632L809 633L808 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M966 632L967 633L966 632M984 632L985 633L984 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M997 632L998 633L997 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M998 632L999 633L998 632M1016 632L1017 633L1016 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M205 633L206 634L205 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M222 633L223 634L222 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M223 633L224 634L223 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M244 633L245 634L244 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M245 633L246 634L245 633M265 633L266 634L265 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M266 633L267 634L266 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M267.667 633.333L268.333 633.667L267.667 633.333M271.667 633.333L272.333 633.667L271.667 633.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M273 633L274 634L273 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M274 633L275 634L274 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M294 633L295 634L294 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M295 633C286.595 644.145 277.732 648 264 648L264 649L279 647L282 648L286 646L287 646L295 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M340 633L341 634L340 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M341 633L342 634L341 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M342 633L343 634L342 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M374 633L375 634L374 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M375 633L376 634L375 633M395 633L396 634L395 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M396 633L397 634L396 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M401 633L402 634L401 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M402.667 633.333L403.333 633.667L402.667 633.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M404 633L405 634L404 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M424 633L425 634L424 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M429 633L430 634L429 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M569 633L570 634L569 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M576 633L577 634L576 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M583 633L584 634L583 633M647 633L648 634L647 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M670.667 633.333L671.333 633.667L670.667 633.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M672 633L673 634L672 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M673 633L674 634L673 633M680 633L681 634L680 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M681.667 633.333L682.333 633.667L681.667 633.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M683 633L684 634L683 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M706 633L707 634L706 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M718 633L719 634L718 633M737.667 633.333L738.333 633.667L737.667 633.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M739 633L740 634L739 633M746 633L747 634L746 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M747 633L748 634L747 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M767 633L768 634L767 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M808 633L809 634L808 633M915 633L916 634L915 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M916 633L917 634L916 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M986 633L987 634L986 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M987 633L988 634L987 633M995 633L996 634L995 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M996 633L997 634L996 633M225 634L225 635L236 635L225 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M245 634L246 635L245 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M269 634L270 635L269 634M293 634L294 635L293 634M329 634C329 638.57 327.776 644.261 332 647L332 646L329 634M333 634L333 635L339 635L333 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M375 634L376 635L375 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M399 634L400 635L399 634M423 634L424 635L423 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M582 634L583 635L582 634M648 634L649 635L648 634M705 634L706 635L705 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M718 634L719 635L718 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M742.667 634.333L743.333 634.667L742.667 634.333M766 634L767 635L766 634M793 634L794 635L793 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M806 634L807 635L806 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M807 634L808 635L807 634M898 634L899 635L898 634M918 634L918 635L922 635L918 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M922 634L923 635L922 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M923 634L923 635L928 635L923 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M928 634L929 635L928 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M967 634L968 635L967 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M990.667 634.333L991.333 634.667L990.667 634.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1015 634L1016 635L1015 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M206.333 635.667L206.667 636.333L206.333 635.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M245 635L246 638L247 638L245 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M246 635L247 636L246 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M293 635L294 636L293 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M359 635L360 636L359 635M376 635L377 636L376 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M423 635L424 636L423 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M552 635L553 636L552 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M554 635L555 636L554 635M570 635L571 636L570 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M571 635L572 636L571 635M580 635L581 636L580 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M581 635L582 636L581 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M641 635L640 639L641 639L641 635M644 635L645 640L654 644L644 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M649 635L650 636L649 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M704 635L705 636L704 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M719 635L720 636L719 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M778 635L779 636L778 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M794 635L795 636L794 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M804 635L805 636L804 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M805 635L806 636L805 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M898 635L899 636L898 635M928 635L928 646L929 646L928 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M968 635L969 636L968 635M1014 635L1015 636L1014 635M247 636L248 637L247 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M292 636L293 637L292 636M359 636L360 637L359 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M377 636L378 637L377 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M422 636L423 637L422 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M553 636C554.6 642.969 559.036 646.758 566 648L566 647L553 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M554.333 636.667L554.667 637.333L554.333 636.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M572 636L573 637L572 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M573 636L573 637L576 637L573 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M576 636L577 637L576 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M577 636L578 637L577 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M578.667 636.333L579.333 636.667L578.667 636.333M650 636L651 637L650 636M703 636L704 637L703 636M720 636L721 637L720 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M765 636L766 637L765 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M796 636L797 637L796 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M797 636L797 637L802 637L797 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M802.667 636.333L803.333 636.667L802.667 636.333M248 637L249 638L248 637M291 637L292 638L291 637M358 637L359 638L358 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M421 637L422 638L421 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M643 637L644 638L643 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M651 637L652 638L651 637M702 637L703 638L702 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M764 637L765 638L764 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M779 637L780 638L779 637M899 637L900 638L899 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M969 637L970 638L969 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M207 638L208 639L207 638M249 638L250 639L249 638M290 638L291 639L290 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M293 638L294 639L293 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M358 638L359 639L358 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M377 638L379 640L377 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M378 638L379 639L378 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M420 638L418 641L420 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M554 638L555 639L554 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M555 638L556 639L555 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M652 638L653 639L652 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M701 638L702 639L701 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M721 638L722 639L721 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M763 638L764 639L763 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M779 638L780 639L779 638M970 638L971 639L970 638M1012 638L1013 639L1012 638M249 639L251 641L249 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M289 639L290 640L289 639M357 639L358 640L357 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M358 639L359 640L358 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M379 639L380 640L379 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M420 639L412 645L412 646C415.531 645.153 420.239 643.15 420 639M426 639L427 640L426 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M555 639L556 640L555 639M653 639L654 640L653 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M700 639L701 640L700 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M722 639L723 640L722 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M762 639L763 640L762 639M900 639L901 640L900 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M971 639L972 640L971 639M1011 639L1012 640L1011 639M208 640L209 641L208 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M249 640L250 641L249 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M251 640L254 643L251 640M288 640L289 641L288 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M380 640L381 641L380 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M381 640L382 641L381 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M499 640L500 641L499 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M556 640L558 642L556 640M655 640L656 641L655 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M699 640L700 641L699 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M723 640L724 641L723 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M761 640L762 641L761 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M780 640L781 641L780 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M901 640L902 641L901 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M972 640L973 641L972 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M1010 640L1011 641L1010 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M209 641L210 642L209 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M250 641L253 643L253 642L250 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M251 641L252 642L251 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M287 641L288 642L287 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M288 641L289 642L288 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M295 641L296 642L295 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M356 641L357 642L356 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M380 641L381 642L380 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M382 641L384 643L382 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M417 641L418 642L417 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M553 641L554 642L553 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M556 641L557 642L556 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M656 641L657 642L656 641M697 641L698 642L697 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M698 641L699 642L698 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M725 641L726 642L725 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M760 641L761 642L760 641M781 641L782 642L781 641M881 641L882 642L881 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M973 641L974 642L973 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1008 641L1009 642L1008 641M210 642L211 643L210 642M285 642L286 643L285 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M286 642L287 643L286 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M355 642L356 643L355 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M382 642L383 643L382 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M415 642L414 644L415 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M416 642L417 643L416 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M453 642L454 643L453 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M482 642L483 643L482 642M499 642L499 645L500 645L499 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M557 642L558 643L557 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M586 642L587 643L586 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M587 642L587 646L588 646L587 642M657 642L658 643L657 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M658 642L659 643L658 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M696 642L697 643L696 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M726 642L727 643L726 642M758 642L759 643L758 642M782 642L783 643L782 642M810 642L809 644L810 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M811 642L811 646L812 646L811 642M866.333 642.667L866.667 643.333L866.333 642.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M975 642L976 643L975 642M1007 642L1008 643L1007 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M211 643L212 644L211 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M253 643L254 644L253 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M254 643L255 644L254 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M255 643L256 644L255 643M284 643L285 644L284 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M290 643L291 644L290 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M354 643L355 644L354 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M383 643L385 645L383 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M384 643L385 644L384 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M385 643L386 644L385 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M415 643L416 644L415 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M434 643L435 644L434 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M558 643L560 645L558 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M559 643L560 644L559 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M585 643L586 644L585 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M586 643L583 645L583 646C585.335 645.673 587.146 645.558 586 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M656 643L657 644L656 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M659 643L660 644L659 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M694 643L695 644L694 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M727 643L728 644L727 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M757 643L758 644L757 643M783 643L784 644L783 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M902 643L903 644L902 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M904 643L905 644L904 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M976 643L977 644L976 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M1005 643L1006 644L1005 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1006 643L1007 644L1006 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M1063.33 643.667L1063.67 644.333L1063.33 643.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M213 644L214 645L213 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M255 644L257 646L255 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M256 644L257 645L256 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M282 644L283 645L282 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M283 644L284 645L283 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M352 644L353 645L352 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M353 644L354 645L353 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M386 644L387 645L386 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M412 644L413 645L412 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M413.667 644.333L414.333 644.667L413.667 644.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M560 644L561 645L560 644M583 644L584 645L583 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M584 644L585 645L584 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M601 644L601 645L604 646L601 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M648 644L648 647L649 647L650 644L648 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M661 644L662 645L661 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M662 644L663 645L662 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M692 644L693 645L692 644M729 644L730 645L729 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M730 644L731 645L730 644M755 644L756 645L755 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M784 644L785 645L784 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M785 644L786 645L785 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M808 644L809 645L808 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M866.333 644.667L866.667 645.333L866.333 644.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M905 644L906 645L905 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M978 644L979 645L978 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1004 644L1005 645L1004 644M214 645L215 646L214 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M215 645L216 646L215 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M258 645L259 646L258 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M259 645L260 646L259 645M280 645L281 646L280 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M281 645L282 646L281 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M292 645L293 646L292 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M350 645L351 646L350 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M351 645L352 646L351 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M386 645L387 646L386 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M388 645L389 646L388 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M389 645L390 646L389 645M410 645L411 646L410 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M552 645L553 646L552 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M561 645L562 646L561 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M562 645L563 646L562 645M581 645L582 646L581 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M582 645L583 646L582 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M600 645L601 646L600 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M663 645L664 646L663 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M664 645L665 646L664 645M689 645L690 646L689 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M690 645L691 646L690 645M731 645L732 646L731 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M732 645L733 646L732 645M752 645L753 646L752 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M753 645L754 646L753 645M786 645L787 646L786 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M805.667 645.333L806.333 645.667L805.667 645.333M852 645L853 646L852 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M881 645L882 646L881 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M905 645L906 646L905 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M907 645L908 646L907 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M980 645L981 646L980 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M981 645L982 646L981 645M1001 645L1002 646L1001 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1002 645L1003 646L1002 645M217 646L218 647L217 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M218 646L219 647L218 646M233.667 646.333L234.333 646.667L233.667 646.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M235 646L236 647L235 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M258 646L258 647L263 648L263 647L258 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M260 646L261 647L260 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M261 646L262 647L261 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M262 646L263 647L262 646M276.667 646.333L277.333 646.667L276.667 646.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M278 646L279 647L278 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M287 646L288 647L287 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M329 646L330 647L329 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M346.667 646.333L347.333 646.667L346.667 646.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M348 646L349 647L348 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M351 647L351 648L354 648L354 647L351 647M358 646L359 647L358 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M389 646L390 647L389 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M391 646L392 647L391 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M392.667 646.333L393.333 646.667L392.667 646.333M406.667 646.333L407.333 646.667L406.667 646.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M408 646L409 647L408 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M410 646L411 647L410 646M434 646L435 647L434 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M438 646L439 647L438 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M439 646L439 647L453 647L439 646M467 646L467 647L481 647L467 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M482 646L483 647L482 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M500 646L500 647L514 647L500 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M556 646L555 648L556 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M563 646L564 647L563 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M564 646L565 647L564 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M565 646L566 647L565 646M578 646L579 647L578 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M579 646L580 647L579 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M581 646L582 647L581 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M588 646L588 647L601 647L588 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M650 647L650 648L655 648L650 647M657 646C657.104 648.916 654.85 650.512 659 651L659 647L661 648L662 648L662 647L657 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M666 646L667 647L666 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M667.667 646.333L668.333 646.667L667.667 646.333M685 646L686 647L685 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M686.667 646.333L687.333 646.667L686.667 646.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M733 646L734 647L733 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M734 646L735 647L734 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M735 646L736 647L735 646M749.667 646.333L750.333 646.667L749.667 646.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M751 646L752 647L751 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M788 646L789 647L788 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M789 646L790 647L789 646M802.667 646.333L803.333 646.667L802.667 646.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M804 646L805 647L804 646M812 646L813 647L812 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M813 646L813 647L816 647L813 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M816 646L816 647L825 647L816 646M839 646L839 647L853 647L839 646M867 646L867 647L881 647L867 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M904 646L905 647L904 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M909 646L910 647L909 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M910.667 646.333L911.333 646.667L910.667 646.333M925.667 646.333L926.333 646.667L925.667 646.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M927 646L928 647L927 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M938 646L939 647L938 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M939 646L939 647L952 647L939 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M952 646L953 647L952 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M983 646L984 647L983 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M984.667 646.333L985.333 646.667L984.667 646.333M997.667 646.333L998.333 646.667L997.667 646.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M999 646L1000 647L999 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M1030 646L1031 647L1030 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1031 646L1031 647L1044 647L1031 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M1044 646L1045 647L1044 646M1064.67 646.333L1065.33 646.667L1064.67 646.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M1066 646L1066 647L1077 647L1066 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M1077 646L1078 647L1077 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M220 647L220 648L223 648L220 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M223 647L223 648L229 648L223 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M229 647L229 648L232 648L229 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M233 647L233 648L236 648L233 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M265 647L265 648L268 648L265 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M268.667 647.333L269.333 647.667L268.667 647.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M270 647L270 648L274 648L270 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M274.667 647.333L275.333 647.667L274.667 647.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M293 647L294 648L293 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M333 647L334 648L333 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M334 647L334 648L345 648L334 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M345 647L346 648L345 647M355.667 647.333L356.333 647.667L355.667 647.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M391.667 647.333L392.333 647.667L391.667 647.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M395 647L395 648L398 648L395 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M398 647L398 648L401 648L398 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M401 647L401 648L404 648L401 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M404.667 647.333L405.333 647.667L404.667 647.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M406 647L406 648L409 648L406 647M467 647L467 648L481 648L467 647M502 647L502 648L515 648L502 647M552 647L553 648L552 647M560 647L561 648L560 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M567 647L567 648L573 648L567 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M573 647L574 648L573 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M574.667 647.333L575.333 647.667L574.667 647.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M578.667 647.333L579.333 647.667L578.667 647.333M588 647L588 648L601 648L588 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M670 647L671 648L670 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M671 647L671 648L675 648L671 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M675 647L675 648L678 648L675 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M678 647L678 648L683 648L678 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M683 647L684 648L683 647M737 647L738 648L737 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M738 647L738 648L747 648L738 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M747 647L748 648L747 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M791.667 647.333L792.333 647.667L791.667 647.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9e9f",
      stroke: "none"
    },
    d: "M793 647L793 648L800 648L793 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M800.667 647.333L801.333 647.667L800.667 647.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M868 647L869 648L868 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M913 647L914 648L913 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M914 647L914 648L923 648L914 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M923 647L924 648L923 647M987 647L988 648L987 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#536e70",
      stroke: "none"
    },
    d: "M988 647L988 648L995 648L988 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M995 647L996 648L995 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M395 648L395 649L406 649L395 648M567 648L567 649L577 649L567 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M327 651L328 652L327 651M329 651L330 652L329 651M660 651L664 655L660 651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M568.667 652.333L569.333 652.667L568.667 652.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M656.333 653.667L656.667 654.333L656.333 653.667M336 654L336 655L340 655L336 654M658 654L658 656L660 656L658 654M646 656L646 664L648 664L648 656L646 656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042d2d",
      stroke: "none"
    },
    d: "M528.333 669.667L528.667 670.333L528.333 669.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#075452",
      stroke: "none"
    },
    d: "M325 680L325 681L328 681L325 680M432 718L432 720L440 720L432 718z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestToJoinCoalition);
export default __webpack_public_path__ + "static/media/request_to_join_coalition.a27124da5d4d494df800cf7f10c05e38.svg";
export { ForwardRef as ReactComponent };